// Product Data with Color Options for Leisure Wellness Naples
// Includes Grand River Spas and Viking Spas products

// Base URL for Grand River Spas color visualizer images
const GR_VISUALIZER_BASE = 'https://grandriverspas.com/wp-content/plugins/spa-visualizer/assets/dist/img';

// Generate color combo image URL for Grand River Spas
const getGRColorImage = (model, shell, cabinet, corner = null) => {
  const shellName = shell.charAt(0).toUpperCase() + shell.slice(1);
  const cabinetName = cabinet === 'coastalGray' ? 'CoastalGray' : 
                      cabinet === 'barnwood' ? 'Barnwood' :
                      cabinet === 'walnut' ? 'Walnut' : 
                      cabinet === 'black' ? 'Black' : cabinet;
  const cornerName = corner || cabinetName;
  return `${GR_VISUALIZER_BASE}/${model}_${shellName}_${cabinetName}_${cornerName}.jpg`;
};

// Viking Spas Color Options
// ELITE SERIES: Shell (White, Silver, Opal) + Cabinet (Slate, Chestnut, Stone, Carbon) + Corner (Match/Carbon)
// HEIRLOOM SERIES: Shell (White, Silver, Opal) + Cabinet (Ash Gray, Walnut, Barnwood, Black) + Corner (Match/Black)

// Viking Elite Series cabinet colors
export const VS_ELITE_CABINET_COLORS = {
  slate: { name: 'Slate', hex: '#708090', image: 'https://vikingspas.com/wp-content/plugins/spa-visualizer/assets/dist/img/slate.png' },
  chestnut: { name: 'Chestnut', hex: '#954535', image: 'https://vikingspas.com/wp-content/plugins/spa-visualizer/assets/dist/img/chestnut.png' },
  stone: { name: 'Stone', hex: '#8B8B83', image: 'https://vikingspas.com/wp-content/plugins/spa-visualizer/assets/dist/img/stone.png' },
  carbon: { name: 'Carbon', hex: '#333333', image: 'https://vikingspas.com/wp-content/plugins/spa-visualizer/assets/dist/img/carbon.png' },
};

// Viking Heirloom Series cabinet colors
export const VS_HEIRLOOM_CABINET_COLORS = {
  ashGray: { name: 'Ash Gray', hex: '#B2BEB5', image: 'https://vikingspas.com/wp-content/plugins/spa-visualizer/assets/dist/img/ash.png' },
  walnut: { name: 'Walnut', hex: '#5D4037', image: 'https://vikingspas.com/wp-content/plugins/spa-visualizer/assets/dist/img/walnut.png' },
  barnwood: { name: 'Barnwood', hex: '#8B7355', image: 'https://vikingspas.com/wp-content/plugins/spa-visualizer/assets/dist/img/barnwood.png' },
  black: { name: 'Black Slate', hex: '#1a1a1a', image: 'https://vikingspas.com/wp-content/plugins/spa-visualizer/assets/dist/img/black.png' },
};

// Viking Shell Colors (same for all series)
export const VS_SHELL_COLORS = {
  white: { name: 'White Satin', hex: '#F5F5F0', image: 'https://vikingspas.com/wp-content/plugins/spa-visualizer/assets/dist/img/white.png' },
  silver: { name: 'Silver Satin', hex: '#C0C0C0', image: 'https://vikingspas.com/wp-content/plugins/spa-visualizer/assets/dist/img/silver.png' },
  opal: { name: 'Opal Satin', hex: '#A8B5B8', image: 'https://vikingspas.com/wp-content/plugins/spa-visualizer/assets/dist/img/opal.png' },
};

// Dynasty Spas Color Options
export const DYNASTY_SHELL_COLORS = {
  sterlingMarble: { name: 'Sterling Marble', hex: '#E8E8E0' },
  stormClouds: { name: 'Storm Clouds', hex: '#6B7B8A' },
  tuscanSun: { name: 'Tuscan Sun', hex: '#C4A35A' },
  smokyMountain: { name: 'Smoky Mountain', hex: '#8B7355' },
};

export const DYNASTY_CABINET_COLORS = {
  blackConfer: { name: 'Black Confer', hex: '#1a1a1a' },
  grayConfer: { name: 'Gray Confer', hex: '#6B7280' },
  ashElite: { name: 'Ash Elite', hex: '#B2BEB5' },
  coastalGrayElite: { name: 'Coastal Gray Elite', hex: '#708090' },
};

// Helper to generate all color combinations for a Grand River model
const generateGRColorImages = (modelName) => {
  const shells = ['white', 'silver', 'opal'];
  const cabinets = ['coastalGray', 'walnut', 'barnwood', 'black'];
  const colorImages = {};
  
  shells.forEach(shell => {
    cabinets.forEach(cabinet => {
      const key = `${shell}-${cabinet}`;
      const cabinetName = cabinet === 'coastalGray' ? 'CoastalGray' : 
                          cabinet.charAt(0).toUpperCase() + cabinet.slice(1);
      colorImages[key] = `${GR_VISUALIZER_BASE}/${modelName}_${shell.charAt(0).toUpperCase() + shell.slice(1)}_${cabinetName}_${cabinetName}.jpg`;
    });
  });
  
  return colorImages;
};

// ===========================================
// GRAND RIVER SPAS PRODUCTS - PREMIER SERIES
// ===========================================
export const GRAND_RIVER_PRODUCTS = [
  {
    id: 'gr-chariton-2',
    name: 'Chariton 2',
    brand: 'Grand River Spas',
    series: 'Premier Series',
    modelFamily: 'Chariton',
    persons: 6,
    jets: 63,
    price: '$11,999.99',
    priceValue: 11999.99,
    seatingLayout: 'Lounge',
    dimensions: '92″ x 92″ x 37.5″',
    dimensionsMetric: '234 cm x 234 cm x 95.25cm',
    waterCapacity: '370 gallons | 1,400 liters',
    dryWeight: '650 lbs. | 295 kg',
    filledWeight: '3,738 lbs. | 1,693 kg',
    electrical: '240v/60amp',
    description: 'Our largest lounger model, designed for full-body relaxation with Volcano floor jet and focused neck jets.',
    longDescription: 'Step into luxurious comfort with the Chariton—our largest lounger model, designed for full-body relaxation. Every detail is crafted with purpose, from the powerful Volcano floor jet to the focused neck jets in the roomy captain\'s chairs.',
    features: ['Volcano floor jet for full-body massage', 'Captain\'s chairs with focused neck jets', 'Infinity Edge water feature', 'LED points-of-light, interior and exterior', 'Balboa Control System', '5.5kW Heater', 'Mazzei ozone injection system'],
    images: {
      primary: 'https://b4087952.smushcdn.com/4087952/wp-content/uploads/2025/06/GR_Chariton-2_White-Satin_CoastalGray_Side_Web.png?lossy=2&strip=1&webp=1',
      overhead: 'https://b4087952.smushcdn.com/4087952/wp-content/uploads/2025/06/GR_Chariton-2_White-OH_web.png?lossy=2&strip=1&webp=1'
    },
    colorImages: generateGRColorImages('Chariton'),
    shellColors: ['white', 'silver', 'opal'],
    cabinetColors: ['coastalGray', 'walnut', 'barnwood', 'black'],
    relatedModel: 'gr-chariton-1',
    fullSpecs: {
      seats: '6 Adults',
      seatingType: 'Lounge',
      dimensions: '92″ x 92″ x 37.5″',
      dimensionsMetric: '234 cm x 234 cm x 95.25cm',
      waterCapacity: '370 gallons | 1,400 liters',
      dryWeight: '650 lbs. | 295 kg',
      filledWeight: '3,738 lbs. | 1,693 kg',
      totalJets: 63,
      jets: [
        '1 Volcano jet',
        '8 Two-inch directional jets',
        '10 Two-inch multi-port jets',
        '8 Two-inch neck jets',
        '8 Three-inch directional jets',
        '8 Three-inch rotating jets',
        '4 Four-inch directional jets',
        '6 Four-inch rotating jets',
        '3 Five-inch directional jets',
        '4 Two-inch stationary jets'
      ],
      auxiliaryJets: '1 Ozone jet, 2 Water feature jets',
      lightingSystem: 'LED points-of-light, interior and exterior',
      waterFeature: 'Infinity Edge',
      controlSystem: 'Balboa Control System 240v/60amp',
      heater: '5.5kW Heater',
      energyEfficiency: '2.0 lb. density polyurethane foam; Polar Insulation; Certified to California Energy Commission (CEC) Standards',
      jetPumps: 2,
      performanceRating: 'GRHS 12',
      filtration: '50 square foot filter',
      waterCare: 'Mazzei ozone injection system',
      spaCover: '1.5 lbs. density, 4" to 2.5" tapered foam core cover, Weather resistant material | Black',
      shellColorOptions: 'White Satin, Silver Satin or Opal Satin',
      cabinetColorOptions: 'Coastal Gray, Walnut, Barnwood, Black',
      cornerColorOptions: 'Matching or Black'
    }
  },
  {
    id: 'gr-chariton-1',
    name: 'Chariton 1',
    brand: 'Grand River Spas',
    series: 'Premier Series',
    modelFamily: 'Chariton',
    persons: 6,
    jets: 51,
    price: '$10,999.99',
    priceValue: 10999.99,
    seatingLayout: 'Lounge',
    dimensions: '92″ x 92″ x 37.5″',
    dimensionsMetric: '234 cm x 234 cm x 95.25cm',
    waterCapacity: '370 gallons | 1,400 liters',
    dryWeight: '650 lbs. | 295 kg',
    filledWeight: '3,738 lbs. | 1,693 kg',
    electrical: '240v/60amp',
    description: 'Luxurious lounger with powerful Volcano jet and captain\'s chairs for head-to-toe rejuvenation.',
    features: ['Volcano floor jet', 'Captain\'s chairs with neck jets', 'Infinity Edge water feature', 'LED lighting system', 'Balboa Control System'],
    images: {
      primary: 'https://b4087952.smushcdn.com/4087952/wp-content/uploads/2025/06/GR_Chariton-1_White-Satin_CoastalGray_Side_web.png?lossy=2&strip=1&webp=1',
      overhead: 'https://b4087952.smushcdn.com/4087952/wp-content/uploads/2024/06/GR_Chariton-1-Silver-OH_web.png?lossy=2&strip=1&webp=1'
    },
    colorImages: generateGRColorImages('Chariton'),
    shellColors: ['white', 'silver', 'opal'],
    cabinetColors: ['coastalGray', 'walnut', 'barnwood', 'black'],
    relatedModel: 'gr-chariton-2',
    fullSpecs: {
      seats: '6 Adults',
      seatingType: 'Lounge',
      dimensions: '92″ x 92″ x 37.5″',
      dimensionsMetric: '234 cm x 234 cm x 95.25cm',
      waterCapacity: '370 gallons | 1,400 liters',
      dryWeight: '650 lbs. | 295 kg',
      filledWeight: '3,738 lbs. | 1,693 kg',
      totalJets: 51,
      jets: [
        '1 Volcano Jet',
        '6 Two-inch directional jets',
        '10 Two-inch multi-port jets',
        '10 Two-inch neck jets',
        '4 Three-inch directional jets',
        '6 Three-inch rotating jets',
        '4 Four-inch directional jets',
        '4 Four-inch rotating jets',
        '3 Five-inch directional jets'
      ],
      auxiliaryJets: '1 Ozone jet, 2 Water feature jets',
      lightingSystem: 'LED points-of-light, interior and exterior',
      waterFeature: 'Infinity Edge',
      controlSystem: 'Balboa Control System 240v/60amp',
      heater: '5.5kW Heater',
      energyEfficiency: '2.0 lb. density polyurethane foam; Polar Insulation; Certified to California Energy Commission (CEC) Standards',
      jetPumps: 2,
      performanceRating: 'GRHS 12',
      filtration: '50 square foot filter',
      waterCare: 'Mazzei ozone injection system',
      spaCover: '1.5 lbs. density, 4" to 2.5" tapered foam core cover, Weather resistant material | Black',
      shellColorOptions: 'White Satin, Silver Satin or Opal Satin',
      cabinetColorOptions: 'Coastal Gray, Walnut, Barnwood, Black',
      cornerColorOptions: 'Matching or Black'
    }
  },
  {
    id: 'gr-chesapeake-2',
    name: 'Chesapeake 2',
    brand: 'Grand River Spas',
    series: 'Premier Series',
    modelFamily: 'Chesapeake',
    persons: 7,
    jets: 63,
    price: '$11,999.99',
    priceValue: 11999.99,
    seatingLayout: 'Non-Lounge',
    dimensions: '92″ x 92″ x 37.5″',
    dimensionsMetric: '234 cm x 234 cm x 95.25cm',
    waterCapacity: '430 gallons | 1,628 liters',
    dryWeight: '700 lbs. | 318 kg',
    filledWeight: '3,312 lbs. | 1,501 kg',
    electrical: '240v/60amp',
    description: 'Spacious open-seating hot tub with exclusive three-direction swing seats.',
    features: ['Three-direction "swing" seats', 'Captain\'s chairs with jet therapy', 'Cascade water feature', '63 powerful jets', 'LED lighting'],
    images: {
      primary: 'https://b4087952.smushcdn.com/4087952/wp-content/uploads/2025/06/GR_Chesapeake-2_White_CoastalGray_web.png?lossy=2&strip=1&webp=1',
      overhead: 'https://b4087952.smushcdn.com/4087952/wp-content/uploads/2025/06/GR_Chesapeake-2_White-OH_web.png?lossy=2&strip=1&webp=1'
    },
    colorImages: generateGRColorImages('Chesapeake'),
    shellColors: ['white', 'silver', 'opal'],
    cabinetColors: ['coastalGray', 'walnut', 'barnwood', 'black'],
    relatedModel: 'gr-chesapeake-1',
    fullSpecs: {
      seats: '7 Adults',
      seatingType: 'Non-Lounge',
      dimensions: '92″ x 92″ x 37.5″',
      dimensionsMetric: '234 cm x 234 cm x 95.25cm',
      waterCapacity: '430 gallons | 1,628 liters',
      dryWeight: '700 lbs. | 318 kg',
      filledWeight: '3,312 lbs. | 1,501 kg',
      totalJets: 63,
      jets: [
        '1 Volcano jet',
        '8 Two-inch directional jets',
        '10 Two-inch multi-port jets',
        '8 Two-inch neck jets',
        '8 Three-inch directional jets',
        '8 Three-inch rotating jets',
        '4 Four-inch directional jets',
        '6 Four-inch rotating jets',
        '3 Five-inch directional jets',
        '4 Two-inch stationary jets'
      ],
      auxiliaryJets: '1 Ozone jet, 2 Water feature jets',
      lightingSystem: 'LED points-of-light, interior and exterior',
      waterFeature: 'Cascade',
      controlSystem: 'Balboa Control System 240v/60amp',
      heater: '5.5kW Heater',
      energyEfficiency: '2.0 lb. density polyurethane foam; Polar Insulation; Certified to California Energy Commission (CEC) Standards',
      jetPumps: 2,
      performanceRating: 'GRHS 12',
      filtration: '50 square foot filter',
      waterCare: 'Mazzei ozone injection system',
      spaCover: '1.5 lbs. density, 4" to 2.5" tapered foam core cover, Weather resistant material | Black',
      shellColorOptions: 'White Satin, Silver Satin or Opal Satin',
      cabinetColorOptions: 'Coastal Gray, Walnut, Barnwood, Black',
      cornerColorOptions: 'Matching or Black'
    }
  },
  {
    id: 'gr-chesapeake-1',
    name: 'Chesapeake 1',
    brand: 'Grand River Spas',
    series: 'Premier Series',
    modelFamily: 'Chesapeake',
    persons: 7,
    jets: 53,
    price: '$10,999.99',
    priceValue: 10999.99,
    seatingLayout: 'Non-Lounge',
    dimensions: '92″ x 92″ x 37.5″',
    dimensionsMetric: '234 cm x 234 cm x 95.25cm',
    waterCapacity: '430 gallons | 1,628 liters',
    dryWeight: '700 lbs. | 318 kg',
    filledWeight: '3,312 lbs. | 1,501 kg',
    electrical: '240v/60amp',
    description: 'Total-body relaxation with targeted jet therapy for neck, wrists, and feet.',
    features: ['Targeted neck, wrist, and foot therapy', 'Three-direction swing seats', 'Open seating for 7', 'Cascade water feature'],
    images: {
      primary: 'https://b4087952.smushcdn.com/4087952/wp-content/uploads/2025/06/GR_Chesapeake-1_Opal_Black_Side_web-e1751040384296.png?lossy=2&strip=1&webp=1',
      overhead: 'https://b4087952.smushcdn.com/4087952/wp-content/uploads/2025/06/GR_Chesapeake-1_Opal-OH_web.png?lossy=2&strip=1&webp=1'
    },
    colorImages: generateGRColorImages('Chesapeake'),
    shellColors: ['white', 'silver', 'opal'],
    cabinetColors: ['coastalGray', 'walnut', 'barnwood', 'black'],
    relatedModel: 'gr-chesapeake-2',
    fullSpecs: {
      seats: '7 Adults',
      seatingType: 'Non-Lounge',
      dimensions: '92″ x 92″ x 37.5″',
      dimensionsMetric: '234 cm x 234 cm x 95.25cm',
      waterCapacity: '430 gallons | 1,628 liters',
      dryWeight: '700 lbs. | 318 kg',
      filledWeight: '3,312 lbs. | 1,501 kg',
      totalJets: 53,
      jets: [
        '1 Volcano jet',
        '4 Two-inch directional jets',
        '10 Two-inch multi-port jets',
        '8 Two-inch neck jets',
        '6 Three-inch directional jets',
        '8 Three-inch rotating jets',
        '4 Four-inch directional jets',
        '6 Four-inch rotating jets',
        '3 Five-inch directional jets'
      ],
      auxiliaryJets: '1 Ozone jet, 2 Water feature jets',
      lightingSystem: 'LED points-of-light, interior and exterior',
      waterFeature: 'Cascade',
      controlSystem: 'Balboa Control System 240v/60amp',
      heater: '5.5kW Heater',
      energyEfficiency: '2.0 lb. density polyurethane foam; Polar Insulation; Certified to California Energy Commission (CEC) Standards',
      jetPumps: 2,
      performanceRating: 'GRHS 12',
      filtration: '50 square foot filter',
      waterCare: 'Mazzei ozone injection system',
      spaCover: '1.5 lbs. density, 4" to 2.5" tapered foam core cover, Weather resistant material | Black',
      shellColorOptions: 'White Satin, Silver Satin or Opal Satin',
      cabinetColorOptions: 'Coastal Gray, Walnut, Barnwood, Black',
      cornerColorOptions: 'Matching or Black'
    }
  },
  {
    id: 'gr-saginaw-2',
    name: 'Saginaw 2',
    brand: 'Grand River Spas',
    series: 'Premier Series',
    modelFamily: 'Saginaw',
    persons: 6,
    jets: 53,
    price: '$9,999.99',
    priceValue: 9999.99,
    seatingLayout: 'Lounge',
    dimensions: '86″ x 86″ x 37″',
    dimensionsMetric: '218 cm x 218 cm x 94 cm',
    waterCapacity: '300 gallons | 1,136 liters',
    dryWeight: '550 lbs. | 249 kg',
    filledWeight: '3,054 lbs. | 1,383 kg',
    electrical: '240v/60amp',
    description: 'Stretch out in the full-length lounger or settle into the corner swing seat for flexible comfort.',
    features: ['Full-length lounger', 'Corner swing seat', 'Precision-placed jets', 'Infinity Edge water feature', 'LED lighting'],
    images: {
      primary: 'https://b4087952.smushcdn.com/4087952/wp-content/uploads/2025/06/GR_Saginaw_2_White_Coastal_Side-768x576.png?lossy=2&strip=1&webp=1',
      overhead: 'https://b4087952.smushcdn.com/4087952/wp-content/uploads/2025/06/GR_Saginaw_2_White_OH.png?lossy=2&strip=1&webp=1'
    },
    colorImages: generateGRColorImages('Saginaw'),
    shellColors: ['white', 'silver', 'opal'],
    cabinetColors: ['coastalGray', 'walnut', 'barnwood', 'black'],
    relatedModel: 'gr-saginaw-1',
    fullSpecs: {
      seats: '6 Adults',
      seatingType: 'Lounge',
      dimensions: '86″ x 86″ x 37″',
      dimensionsMetric: '218 cm x 218 cm x 94 cm',
      waterCapacity: '300 gallons | 1,136 liters',
      dryWeight: '550 lbs. | 249 kg',
      filledWeight: '3,054 lbs. | 1,383 kg',
      totalJets: 53,
      jets: [
        '8 Two-inch directional jets',
        '12 Two-inch multi-port jets',
        '6 Two-inch neck jets',
        '7 Three-inch directional jets',
        '6 Three-inch rotating jets',
        '2 Four-inch directional jets',
        '4 Four-inch rotating jets',
        '3 Five-inch rotating jets',
        '2 Two-inch stationary jets'
      ],
      auxiliaryJets: '1 Ozone jet, 2 Water feature jets',
      lightingSystem: 'LED points-of-light, interior and exterior',
      waterFeature: 'Infinity Edge',
      controlSystem: 'Balboa Control System 240v/60amp',
      heater: '5.5kW Heater',
      energyEfficiency: '2.0 lb. density polyurethane foam; Polar Insulation; Certified to California Energy Commission (CEC) Standards',
      jetPumps: 2,
      performanceRating: 'GRHS 12',
      filtration: '50 square foot filter',
      waterCare: 'Mazzei ozone injection system',
      spaCover: '1.5 lbs. density, 4" to 2.5" tapered foam core cover, Weather resistant material | Black',
      shellColorOptions: 'White Satin, Silver Satin or Opal Satin',
      cabinetColorOptions: 'Coastal Gray, Walnut, Barnwood or Black',
      cornerColorOptions: 'Matching or Black'
    }
  },
  {
    id: 'gr-saginaw-1',
    name: 'Saginaw 1',
    brand: 'Grand River Spas',
    series: 'Premier Series',
    modelFamily: 'Saginaw',
    persons: 6,
    jets: 35,
    price: '$9,999.99',
    priceValue: 9999.99,
    seatingLayout: 'Lounge',
    dimensions: '86″ x 86″ x 37″',
    dimensionsMetric: '218 cm x 218 cm x 94 cm',
    waterCapacity: '300 gallons | 1,136 liters',
    dryWeight: '550 lbs. | 249 kg',
    filledWeight: '3,054 lbs. | 1,383 kg',
    electrical: '240v/50amp',
    description: 'Well-rounded 6-person spa with quality hydrotherapy.',
    features: ['35 jets', 'Lounge seating', 'LED lighting', 'Cascade water feature'],
    images: {
      primary: 'https://b4087952.smushcdn.com/4087952/wp-content/uploads/2025/06/GR_Saginaw_1_White_Walnut_Black_Side-768x542.png?lossy=2&strip=1&webp=1',
      overhead: 'https://b4087952.smushcdn.com/4087952/wp-content/uploads/2025/06/GR_Saginaw_1_Silver_OH_web-768x768.png?lossy=2&strip=1&webp=1'
    },
    colorImages: generateGRColorImages('Saginaw'),
    shellColors: ['white', 'silver', 'opal'],
    cabinetColors: ['coastalGray', 'walnut', 'barnwood', 'black'],
    relatedModel: 'gr-saginaw-2',
    fullSpecs: {
      seats: '6 Adults',
      seatingType: 'Lounge',
      dimensions: '86″ x 86″ x 37″',
      dimensionsMetric: '218 cm x 218 cm x 94 cm',
      waterCapacity: '300 gallons | 1,136 liters',
      dryWeight: '550 lbs. | 249 kg',
      filledWeight: '3,054 lbs. | 1,383 kg',
      totalJets: 35,
      jets: [
        '6 Two-inch directional jets',
        '9 Two-inch multi-port jets',
        '6 Two-inch neck jets',
        '4 Three-inch directional jets',
        '4 Three-inch rotating jets',
        '3 Four-inch rotating jets'
      ],
      auxiliaryJets: '1 Ozone jet, 2 Water feature jets',
      lightingSystem: 'LED points-of-light, interior and exterior',
      waterFeature: 'Cascade',
      controlSystem: 'Balboa BP500 240v/50amp',
      heater: '5.5kW Heater',
      energyEfficiency: '2.0 lb. density polyurethane foam; Polar Insulation; Certified to California Energy Commission (CEC) Standards',
      jetPumps: 1,
      performanceRating: 'GRHS 5',
      filtration: '50 square foot filter',
      waterCare: 'Mazzei ozone injection system',
      spaCover: '1.5 lbs. density, 4" to 2.5" tapered foam core cover, Weather resistant material | Black',
      shellColorOptions: 'White Satin, Silver Satin or Opal Satin',
      cabinetColorOptions: 'Coastal Gray, Walnut, Barnwood or Black',
      cornerColorOptions: 'Matching or Black'
    }
  },
  {
    id: 'gr-thornapple-2',
    name: 'Thornapple 2',
    brand: 'Grand River Spas',
    series: 'Premier Series',
    modelFamily: 'Thornapple',
    persons: 7,
    jets: 54,
    price: '$9,999.99',
    priceValue: 9999.99,
    seatingLayout: 'Non-Lounge',
    dimensions: '86″ x 86″ x 37″',
    dimensionsMetric: '218 cm x 218 cm x 94 cm',
    waterCapacity: '320 gallons | 1,211 liters',
    dryWeight: '550 lbs. | 249 kg',
    filledWeight: '3,221 lbs. | 1,459 kg',
    electrical: '240v/60amp',
    description: 'Barrier-free layout makes it easy to move from one seat to the next with calf jets in all four corners.',
    features: ['Barrier-free layout', 'Two roomy captain\'s chairs', 'Calf jets in all corners', 'Cascade water feature'],
    images: {
      primary: 'https://b4087952.smushcdn.com/4087952/wp-content/uploads/2025/06/GR_Thornapple_2_White_Coastal_Side.png?lossy=2&strip=1&webp=1',
      overhead: 'https://b4087952.smushcdn.com/4087952/wp-content/uploads/2025/06/GR_Thornapple2_White_OH.png?lossy=2&strip=1&webp=1'
    },
    colorImages: generateGRColorImages('Thornapple'),
    shellColors: ['white', 'silver', 'opal'],
    cabinetColors: ['coastalGray', 'walnut', 'barnwood', 'black'],
    relatedModel: 'gr-thornapple-1',
    fullSpecs: {
      seats: '7 Adults',
      seatingType: 'Non-Lounge',
      dimensions: '86″ x 86″ x 37″',
      dimensionsMetric: '218 cm x 218 cm x 94 cm',
      waterCapacity: '320 gallons | 1,211 liters',
      dryWeight: '550 lbs. | 249 kg',
      filledWeight: '3,221 lbs. | 1,459 kg',
      totalJets: 54,
      jets: [
        '12 Two-inch directional jets',
        '4 Two-inch multi-port jets',
        '4 Two-inch neck jets',
        '14 Three-inch directional jets',
        '12 Three-inch rotating jets',
        '5 Five-inch rotating jets'
      ],
      auxiliaryJets: '1 Ozone jet, 2 Water feature jets',
      lightingSystem: 'LED points-of-light, interior and exterior',
      waterFeature: 'Cascade',
      controlSystem: 'Balboa Control System 240v/60amp',
      heater: '5.5kW Heater',
      energyEfficiency: '2.0 lb. density polyurethane foam; Polar Insulation; Certified to California Energy Commission (CEC) Standards',
      jetPumps: 2,
      performanceRating: 'GRHS 10',
      filtration: '50 square foot filter',
      waterCare: 'Mazzei ozone injection system',
      spaCover: '1.5 lbs. density, 4" to 2.5" tapered foam core cover, Weather resistant material | Black',
      shellColorOptions: 'White Satin, Silver Satin or Opal Satin',
      cabinetColorOptions: 'Coastal Gray, Walnut, Barnwood, Black',
      cornerColorOptions: 'Matching or Black'
    }
  },
  {
    id: 'gr-thornapple-1',
    name: 'Thornapple 1',
    brand: 'Grand River Spas',
    series: 'Premier Series',
    modelFamily: 'Thornapple',
    persons: 7,
    jets: 38,
    price: '$9,999.99',
    priceValue: 9999.99,
    seatingLayout: 'Non-Lounge',
    dimensions: '86″ x 86″ x 37″',
    dimensionsMetric: '218 cm x 218 cm x 94 cm',
    waterCapacity: '320 gallons | 1,211 liters',
    dryWeight: '550 lbs. | 249 kg',
    filledWeight: '3,221 lbs. | 1,459 kg',
    electrical: '240v/50amp',
    description: 'Comfortable non-lounge with excellent jet coverage and targeted therapy.',
    features: ['Barrier-free layout', 'Captain\'s chairs', 'Calf jets in corners', 'Cascade water feature', 'LED lighting'],
    images: {
      primary: 'https://b4087952.smushcdn.com/4087952/wp-content/uploads/2025/06/GR_Thornapple_1_Opal_Barnwood_Black_Side-768x544.png?lossy=2&strip=1&webp=1',
      overhead: 'https://b4087952.smushcdn.com/4087952/wp-content/uploads/2025/06/GR_Thornapple1_Opal_OH.png?lossy=2&strip=1&webp=1'
    },
    colorImages: generateGRColorImages('Thornapple'),
    shellColors: ['white', 'silver', 'opal'],
    cabinetColors: ['coastalGray', 'walnut', 'barnwood', 'black'],
    relatedModel: 'gr-thornapple-2',
    fullSpecs: {
      seats: '7 Adults',
      seatingType: 'Non-Lounge',
      dimensions: '86″ x 86″ x 37″',
      dimensionsMetric: '218 cm x 218 cm x 94 cm',
      waterCapacity: '320 gallons | 1,211 liters',
      dryWeight: '550 lbs. | 249 kg',
      filledWeight: '3,221 lbs. | 1,459 kg',
      totalJets: 38,
      jets: [
        '13 Two-inch directional jets',
        '7 Two-inch multi-port jets',
        '4 Two-inch neck jets',
        '2 Three-inch directional jets',
        '6 Three-inch rotating jets',
        '3 Four-inch rotating jets'
      ],
      auxiliaryJets: '1 Ozone jet, 2 Water feature jets',
      lightingSystem: 'LED points-of-light, interior and exterior',
      waterFeature: 'Cascade',
      controlSystem: 'Balboa Control System 240v/50amp',
      heater: '5.5kW Heater',
      energyEfficiency: '2.0 lb. density polyurethane foam; Polar Insulation; Certified to California Energy Commission (CEC) Standards',
      jetPumps: 1,
      performanceRating: 'GRHS 5',
      filtration: '50 square foot filter',
      waterCare: 'Mazzei ozone injection system',
      spaCover: '1.5 lbs. density, 4" to 2.5" tapered foam core cover, Weather resistant material | Black',
      shellColorOptions: 'White Satin, Silver Satin or Opal Satin',
      cabinetColorOptions: 'Coastal Gray, Walnut, Barnwood, Black',
      cornerColorOptions: 'Matching or Black'
    }
  },
  {
    id: 'gr-muskegon-2',
    name: 'Muskegon 2',
    brand: 'Grand River Spas',
    series: 'Premier Series',
    modelFamily: 'Muskegon',
    persons: 6,
    jets: 41,
    price: '$9,999.99',
    priceValue: 9999.99,
    seatingLayout: 'Lounge',
    dimensions: '86″ x 86″ x 37″',
    dimensionsMetric: '218 cm x 218 cm x 94 cm',
    waterCapacity: '300 gallons | 1,136 liters',
    dryWeight: '650 lbs. | 295 kg',
    filledWeight: '3,152 lbs. | 1,430 kg',
    electrical: '240v/50amp',
    description: 'Deep Adirondack-style lounger or generous captain\'s chair for flexible comfort.',
    features: ['Deep Adirondack-style lounger', 'Generous captain\'s chair', 'Aqua Arc water feature', 'LED lighting'],
    images: {
      primary: 'https://b4087952.smushcdn.com/4087952/wp-content/uploads/2025/06/GR_Muskegon2_White_CoastalGray_Side-768x499.png?lossy=2&strip=1&webp=1',
      overhead: 'https://b4087952.smushcdn.com/4087952/wp-content/uploads/2025/06/GR_Muskegeon_2_White_OH.png?lossy=2&strip=1&webp=1'
    },
    colorImages: generateGRColorImages('Muskegon'),
    shellColors: ['white', 'silver', 'opal'],
    cabinetColors: ['coastalGray', 'walnut', 'barnwood', 'black'],
    relatedModel: 'gr-muskegon-1',
    fullSpecs: {
      seats: '6 Adults',
      seatingType: 'Lounge',
      dimensions: '86″ x 86″ x 37″',
      dimensionsMetric: '218 cm x 218 cm x 94 cm',
      waterCapacity: '300 gallons | 1,136 liters',
      dryWeight: '650 lbs. | 295 kg',
      filledWeight: '3,152 lbs. | 1,430 kg',
      totalJets: 41,
      jets: [
        '10 Two-inch directional jets',
        '10 Two-inch multi-port jets',
        '2 Two-inch neck jets',
        '1 Three-inch directional jets',
        '7 Three-inch rotating jets',
        '1 Four-inch rotating jets',
        '1 Five-inch rotating jets',
        '8 Two-inch stationary jets'
      ],
      auxiliaryJets: '1 Ozone jet',
      lightingSystem: 'LED points-of-light, interior and exterior',
      waterFeature: 'Aqua Arc',
      controlSystem: 'Balboa Control System 240v/50amp',
      heater: '5.5kW Heater',
      energyEfficiency: '2.0 lb. density polyurethane foam; Polar Insulation; Certified to California Energy Commission (CEC) Standards',
      jetPumps: 2,
      performanceRating: 'GRHS 10',
      filtration: '50 square foot filter',
      waterCare: 'Mazzei ozone injection system',
      spaCover: '1.5 lbs. density, 4" to 2.5" tapered foam core cover, Weather resistant material | Black',
      shellColorOptions: 'White Satin, Silver Satin or Opal Satin',
      cabinetColorOptions: 'Coastal Gray, Walnut, Barnwood, Black',
      cornerColorOptions: 'Matching or Black'
    }
  },
  {
    id: 'gr-muskegon-1',
    name: 'Muskegon 1',
    brand: 'Grand River Spas',
    series: 'Premier Series',
    modelFamily: 'Muskegon',
    persons: 6,
    jets: 28,
    price: '$7,999.99',
    priceValue: 7999.99,
    seatingLayout: 'Lounge',
    dimensions: '86″ x 86″ x 37″',
    dimensionsMetric: '218 cm x 218 cm x 94 cm',
    waterCapacity: '300 gallons | 1,136 liters',
    dryWeight: '650 lbs. | 295 kg',
    filledWeight: '3,152 lbs. | 1,430 kg',
    electrical: '240v/50amp',
    description: 'Great value 6-person spa with Adirondack-style lounger.',
    features: ['6-person capacity', '28 jets', 'Lounge seating', 'Infinity Edge water feature'],
    images: {
      primary: 'https://b4087952.smushcdn.com/4087952/wp-content/uploads/2025/06/GR_Muskegon1_White_Black_Side-768x498.png?lossy=2&strip=1&webp=1',
      overhead: 'https://b4087952.smushcdn.com/4087952/wp-content/uploads/2025/06/GR_Muskegeon_1_White_OH-768x768.png?lossy=2&strip=1&webp=1'
    },
    colorImages: generateGRColorImages('Muskegon'),
    shellColors: ['white', 'silver', 'opal'],
    cabinetColors: ['coastalGray', 'walnut', 'barnwood', 'black'],
    relatedModel: 'gr-muskegon-2',
    fullSpecs: {
      seats: '6 Adults',
      seatingType: 'Lounge',
      dimensions: '86″ x 86″ x 37″',
      dimensionsMetric: '218 cm x 218 cm x 94 cm',
      waterCapacity: '300 gallons | 1,136 liters',
      dryWeight: '650 lbs. | 295 kg',
      filledWeight: '3,152 lbs. | 1,430 kg',
      totalJets: 28,
      jets: [
        '6 Two-inch directional jets',
        '10 Two-inch multi-port jets',
        '2 Two-inch neck jets',
        '7 Three-inch rotating jets',
        '1 Four-inch rotating jets',
        '1 Five-inch rotating jets'
      ],
      auxiliaryJets: '1 Ozone jet, 2 Water feature jets',
      lightingSystem: 'LED points-of-light, interior and exterior',
      waterFeature: 'Infinity Edge',
      controlSystem: 'Balboa Control System 240v/50amp',
      heater: '5.5kW Heater',
      energyEfficiency: '2.0 lb. density polyurethane foam; Polar Insulation; Certified to California Energy Commission (CEC) Standards',
      jetPumps: 1,
      performanceRating: 'GRHS 4',
      filtration: '50 square foot filter',
      waterCare: 'Mazzei ozone injection system',
      spaCover: '1.5 lbs. density, 4" to 2.5" tapered foam core cover, Weather resistant material | Black',
      shellColorOptions: 'White Satin, Silver Satin or Opal Satin',
      cabinetColorOptions: 'Coastal Gray, Walnut, Barnwood, Black',
      cornerColorOptions: 'Matching or Black'
    }
  },
  {
    id: 'gr-sturgeon-2',
    name: 'Sturgeon 2',
    brand: 'Grand River Spas',
    series: 'Premier Series',
    modelFamily: 'Sturgeon',
    persons: 6,
    jets: 31,
    price: '$8,999.99',
    priceValue: 8999.99,
    seatingLayout: 'Lounge',
    dimensions: '78″ x 78″ x 35″',
    dimensionsMetric: '198 cm x 198 cm x 89 cm',
    waterCapacity: '270 gallons | 1,022 liters',
    dryWeight: '495 lbs. | 225 kg',
    filledWeight: '2,747 lbs. | 1,246 kg',
    electrical: '240v/40amp',
    description: 'Variety of seating and jet configurations with LED lighting and soothing waterfall.',
    features: ['Multiple seating options', 'Aqua Arc water feature', 'LED lighting', 'Quality construction'],
    images: {
      primary: 'https://b4087952.smushcdn.com/4087952/wp-content/uploads/2025/06/GR_Sturgeon_1-2_Opal_Walnut_Side-768x538.png?lossy=2&strip=1&webp=1',
      overhead: 'https://grandriverspas.com/wp-content/uploads/2025/06/GR_Sturgeon%201-2_Silver_OH.png'
    },
    colorImages: generateGRColorImages('Sturgeon'),
    shellColors: ['silver', 'opal'],
    cabinetColors: ['taupe', 'walnut'],
    relatedModel: 'gr-sturgeon-1',
    fullSpecs: {
      seats: '6 Adults',
      seatingType: 'Lounge',
      dimensions: '78″ x 78″ x 35″',
      dimensionsMetric: '198 cm x 198 cm x 89 cm',
      waterCapacity: '270 gallons | 1,022 liters',
      dryWeight: '495 lbs. | 225 kg',
      filledWeight: '2,747 lbs. | 1,246 kg',
      totalJets: 31,
      jets: [
        '18 Two-inch directional jets',
        '2 Two-inch neck jets',
        '6 Four-inch directional jets',
        '2 Four-inch rotating jets',
        '2 Five-inch rotating jets'
      ],
      auxiliaryJets: '1 Ozone jet',
      lightingSystem: 'LED points-of-light, interior and exterior',
      waterFeature: 'Aqua Arc',
      controlSystem: 'Balboa Control System 240v/40amp',
      heater: '5.5kW Heater',
      energyEfficiency: '2.0 lb. density polyurethane foam; Polar Insulation; Certified to California Energy Commission (CEC) Standards',
      jetPumps: 2,
      performanceRating: 'GRHS 6',
      filtration: '50 square foot filter',
      waterCare: 'Mazzei ozone injection system',
      spaCover: '1.5 lbs. density, 4" to 2.5" tapered foam core cover, Weather resistant material | Black',
      shellColorOptions: 'Silver Satin or Opal Satin',
      cabinetColorOptions: 'Taupe or Walnut',
      cornerColorOptions: 'Matching or Black'
    }
  },
  {
    id: 'gr-sturgeon-1',
    name: 'Sturgeon 1',
    brand: 'Grand River Spas',
    series: 'Premier Series',
    modelFamily: 'Sturgeon',
    persons: 6,
    jets: 31,
    price: '$8,999.99',
    priceValue: 8999.99,
    seatingLayout: 'Lounge',
    dimensions: '78″ x 78″ x 35″',
    dimensionsMetric: '198 cm x 198 cm x 89 cm',
    waterCapacity: '270 gallons | 1,022 liters',
    dryWeight: '495 lbs. | 225 kg',
    filledWeight: '2,747 lbs. | 1,246 kg',
    electrical: '240v/40amp',
    description: 'Relaxation with variety of seating and jet configurations. LED lighting and soothing waterfall.',
    features: ['Multiple seating options', 'Aqua Arc water feature', 'LED lighting', 'Entry-level Premier'],
    images: {
      primary: 'https://b4087952.smushcdn.com/4087952/wp-content/uploads/2025/06/GR_Sturgeon_1-2_Opal_Walnut_Side-768x538.png?lossy=2&strip=1&webp=1',
      overhead: 'https://grandriverspas.com/wp-content/uploads/2025/06/GR_Sturgeon%201-2_Silver_OH.png'
    },
    colorImages: generateGRColorImages('Sturgeon'),
    shellColors: ['silver', 'opal'],
    cabinetColors: ['taupe', 'walnut'],
    relatedModel: 'gr-sturgeon-2',
    fullSpecs: {
      seats: '6 Adults',
      seatingType: 'Lounge',
      dimensions: '78″ x 78″ x 35″',
      dimensionsMetric: '198 cm x 198 cm x 89 cm',
      waterCapacity: '270 gallons | 1,022 liters',
      dryWeight: '495 lbs. | 225 kg',
      filledWeight: '2,747 lbs. | 1,246 kg',
      totalJets: 31,
      jets: [
        '18 Two-inch directional jets',
        '2 Two-inch neck jets',
        '6 Four-inch directional jets',
        '2 Four-inch rotating jets',
        '2 Five-inch rotating jets'
      ],
      auxiliaryJets: '1 Ozone jet',
      lightingSystem: 'LED points-of-light, interior and exterior',
      waterFeature: 'Aqua Arc',
      controlSystem: 'Balboa Control System 240v/40amp',
      heater: '5.5kW Heater',
      energyEfficiency: '2.0 lb. density polyurethane foam; Polar Insulation; Certified to California Energy Commission (CEC) Standards',
      jetPumps: 1,
      performanceRating: 'GRHS 3',
      filtration: '50 square foot filter',
      waterCare: 'Mazzei ozone injection system',
      spaCover: '1.5 lbs. density, 4" to 2.5" tapered foam core cover, Weather resistant material | Black',
      shellColorOptions: 'Silver Satin or Opal Satin',
      cabinetColorOptions: 'Taupe or Walnut',
      cornerColorOptions: 'Matching or Black'
    }
  },
  {
    id: 'gr-swift',
    name: 'Swift',
    brand: 'Grand River Spas',
    series: 'Premier Series',
    modelFamily: 'Swift',
    persons: 3,
    jets: 33,
    price: '$7,999.99',
    priceValue: 7999.99,
    seatingLayout: 'Lounge',
    dimensions: '60″ x 84″ x 34″',
    dimensionsMetric: '152 cm x 213 cm x 86 cm',
    waterCapacity: '210 gallons | 795 liters',
    dryWeight: '395 lbs. | 179 kg',
    filledWeight: '2,148 lbs. | 973 kg',
    electrical: '240v/50amp',
    description: 'Compact yet luxurious two-person hot tub that fits perfectly in small outdoor spaces.',
    features: ['Spacious lounge seat', 'Captain\'s chair', 'Cascade water feature', 'LED lighting', 'Compact design'],
    images: {
      primary: 'https://b4087952.smushcdn.com/4087952/wp-content/uploads/2025/11/GR_2025_Swift_White_Black_Side.png?lossy=2&strip=1&webp=1',
      overhead: 'https://b4087952.smushcdn.com/4087952/wp-content/uploads/2025/11/GR_Swift_White_OH.png?lossy=2&strip=1&webp=1'
    },
    colorImages: generateGRColorImages('Premier_Swift'),
    shellColors: ['white', 'silver', 'opal'],
    cabinetColors: ['coastalGray', 'walnut', 'barnwood', 'black'],
    relatedModel: null,
    fullSpecs: {
      seats: '3 Adults',
      seatingType: 'Lounge',
      dimensions: '60″ x 84″ x 34″',
      dimensionsMetric: '152 cm x 213 cm x 86 cm',
      waterCapacity: '210 gallons | 795 liters',
      dryWeight: '395 lbs. | 179 kg',
      filledWeight: '2,148 lbs. | 973 kg',
      totalJets: 33,
      jets: [
        '8 Two-inch directional jets',
        '4 Two-inch multi-port jets',
        '2 Two-inch neck jets',
        '2 Three-inch directional jets',
        '2 Three-inch rotating jets',
        '2 Four-inch directional jets',
        '4 Four-inch rotating jets',
        '6 Two-inch stationary jets'
      ],
      auxiliaryJets: '1 Ozone jet, 2 Water feature jets',
      lightingSystem: 'LED points-of-light, interior and exterior',
      waterFeature: 'Cascade',
      controlSystem: 'Balboa Control System 240v/50amp',
      heater: '5.5kW Heater',
      energyEfficiency: '2.0 lb. density polyurethane foam; Polar Insulation; Certified to California Energy Commission (CEC) Standards',
      jetPumps: 1,
      performanceRating: 'GRHS 4',
      filtration: '20 square foot filter',
      waterCare: 'PureCD Ozone System',
      spaCover: '1.5 lbs. density, 4" to 2.5" tapered foam core cover, Weather resistant material | Black',
      shellColorOptions: 'White Satin, Silver Satin, Opal Satin',
      cabinetColorOptions: 'Coastal Gray, Barnwood, Walnut, Black',
      cornerColorOptions: 'Matching or Black'
    }
  },
  {
    id: 'gr-manistee',
    name: 'Manistee',
    brand: 'Grand River Spas',
    series: 'Premier Series',
    modelFamily: 'Manistee',
    persons: 5,
    jets: 20,
    price: '$7,999.99',
    priceValue: 7999.99,
    seatingLayout: 'Non-Lounge',
    dimensions: '72″ round x 35″ tall',
    dimensionsMetric: '183 cm round x 89 cm tall',
    waterCapacity: '250 gallons | 946 liters',
    dryWeight: '330 lbs. | 150 kg',
    filledWeight: '2,415 lbs. | 1,095 kg',
    electrical: '240v/40amp',
    description: 'Spacious and versatile round hot tub with calming LED lights and expertly placed jets.',
    features: ['Round design', '20 jets', 'Seating for 5', 'LED lighting', 'Balboa Control System'],
    images: {
      primary: 'https://b4087952.smushcdn.com/4087952/wp-content/uploads/2025/06/GR_Manistee_White_Taupe_Side-768x672.png?lossy=2&strip=1&webp=1',
      overhead: 'https://b4087952.smushcdn.com/4087952/wp-content/uploads/2025/06/GR_Manistee-ManisteeEco_White_OH-768x768.png?lossy=2&strip=1&webp=1'
    },
    colorImages: generateGRColorImages('Manistee'),
    shellColors: ['white', 'opal'],
    cabinetColors: ['taupe', 'walnut'],
    relatedModel: null,
    fullSpecs: {
      seats: '5 Adults',
      seatingType: 'Non-Lounge',
      dimensions: '72″ round x 35″ tall',
      dimensionsMetric: '183 cm round x 89 cm tall',
      waterCapacity: '250 gallons | 946 liters',
      dryWeight: '330 lbs. | 150 kg',
      filledWeight: '2,415 lbs. | 1,095 kg',
      totalJets: 20,
      jets: [
        '1 Whirlpool jet',
        '4 Three-inch directional jets',
        '2 Three-inch rotating jets',
        '2 Four-inch directional jets',
        '2 Four-inch rotating jets',
        '8 Two-inch stationary jets'
      ],
      auxiliaryJets: '1 Ozone jet',
      lightingSystem: 'LED Lighting System, Spa Light',
      waterFeature: 'N/A',
      controlSystem: 'Balboa Control System 240v/40amp',
      heater: '1.0kW Heater',
      energyEfficiency: '2.0 lb. density polyurethane foam; Polar Insulation; Certified to California Energy Commission (CEC) Standards',
      jetPumps: 1,
      performanceRating: 'GRHS 4',
      filtration: '20 square foot filter',
      waterCare: 'Optional',
      spaCover: '1.5 lbs. density, 4" to 2.5" tapered foam core cover, Weather resistant material | Black',
      shellColorOptions: 'White Satin or Opal Satin',
      cabinetColorOptions: 'Taupe or Walnut',
      cornerColorOptions: 'N/A'
    }
  },
  // ECO SERIES
  {
    id: 'gr-sturgeon-eco',
    name: 'Sturgeon Eco',
    brand: 'Grand River Spas',
    series: 'Eco Series',
    modelFamily: 'Sturgeon',
    persons: 6,
    jets: 21,
    price: '$7,999.99',
    priceValue: 7999.99,
    seatingLayout: 'Lounge',
    dimensions: '78″ x 78″ x 35″',
    dimensionsMetric: '198 cm x 198 cm x 89 cm',
    waterCapacity: '270 gallons | 1,022 liters',
    dryWeight: '495 lbs. | 225 kg',
    filledWeight: '2,747 lbs. | 1,246 kg',
    electrical: '120v/15amp',
    description: 'Plug-and-play 6-person hot tub with LED lighting and Aqua Arc water feature.',
    features: ['Plug-and-play 120v', 'Comfortable lounger', 'Captain\'s chairs', 'Aqua Arc water feature', 'LED lighting'],
    images: {
      primary: 'https://grandriverspas.com/wp-content/uploads/2025/06/GR_Sturgeon%20Eco_White_Taupe_Side-scaled.png',
      overhead: 'https://b4087952.smushcdn.com/4087952/wp-content/uploads/2025/06/GR_Sturgeon_Eco_White_OH.png?lossy=2&strip=1&webp=1'
    },
    shellColors: ['silver', 'opal'],
    cabinetColors: ['taupe', 'walnut'],
    relatedModel: null,
    fullSpecs: {
      seats: '6 Adults',
      seatingType: 'Lounge',
      dimensions: '78″ x 78″ x 35″',
      dimensionsMetric: '198 cm x 198 cm x 89 cm',
      waterCapacity: '270 gallons | 1,022 liters',
      dryWeight: '495 lbs. | 225 kg',
      filledWeight: '2,747 lbs. | 1,246 kg',
      totalJets: 21,
      jets: [
        '10 Two-inch directional jets',
        '2 Two-inch neck jets',
        '8 Three-inch directional jets',
        '2 Four-inch directional jets'
      ],
      auxiliaryJets: '1 Ozone jet',
      lightingSystem: 'LED points-of-light, interior and exterior',
      waterFeature: 'Aqua Arc',
      controlSystem: 'Balboa Control System 120v/15amp',
      heater: '1.0kW Heater',
      energyEfficiency: '2.0 lb. density polyurethane foam; Polar Insulation; Certified to California Energy Commission (CEC) Standards',
      jetPumps: 1,
      performanceRating: 'GRHS 4',
      filtration: '50 square foot filter',
      waterCare: 'Optional',
      spaCover: '1.5 lbs. density, 4" to 2.5" tapered foam core cover, Weather resistant material | Black',
      shellColorOptions: 'Silver Satin or Opal Satin',
      cabinetColorOptions: 'Taupe or Walnut',
      cornerColorOptions: 'Matching or Black'
    }
  },
  {
    id: 'gr-swift-eco',
    name: 'Swift Eco',
    brand: 'Grand River Spas',
    series: 'Eco Series',
    modelFamily: 'Swift',
    persons: 3,
    jets: 23,
    price: '$7,999.99',
    priceValue: 7999.99,
    seatingLayout: 'Lounge',
    dimensions: '60″ x 84″ x 34″',
    dimensionsMetric: '152 cm x 213 cm x 86 cm',
    waterCapacity: '210 gallons | 795 liters',
    dryWeight: '395 lbs. | 179 kg',
    filledWeight: '2,148 lbs. | 973 kg',
    electrical: '120v/15amp',
    description: 'Compact yet comfortable plug-and-play two-person hot tub for small outdoor spaces.',
    features: ['Plug-and-play 120v', 'Spacious lounge seat', 'Captain\'s chair', 'Cascade water feature', 'LED lighting'],
    images: {
      primary: 'https://b4087952.smushcdn.com/4087952/wp-content/uploads/2025/11/GR_2025_SwiftECO_White_Coastal_Side.png?lossy=2&strip=1&webp=1',
      overhead: 'https://b4087952.smushcdn.com/4087952/wp-content/uploads/2025/11/GR_Swift_White_OH.png?lossy=2&strip=1&webp=1'
    },
    shellColors: ['white', 'silver', 'opal'],
    cabinetColors: ['coastalGray', 'walnut', 'barnwood', 'black'],
    relatedModel: null,
    fullSpecs: {
      seats: '3 Adults',
      seatingType: 'Lounge',
      dimensions: '60″ x 84″ x 34″',
      dimensionsMetric: '152 cm x 213 cm x 86 cm',
      waterCapacity: '210 gallons | 795 liters',
      dryWeight: '395 lbs. | 179 kg',
      filledWeight: '2,148 lbs. | 973 kg',
      totalJets: 23,
      jets: [
        '4 Two-inch directional jets',
        '2 Two-inch neck jets',
        '4 Three-inch directional jets',
        '3 Three-inch rotating jets',
        '2 Four-inch directional jets',
        '1 Four-inch rotating jets',
        '4 Two-inch stationary jets'
      ],
      auxiliaryJets: '1 Ozone jet, 2 Water feature jets',
      lightingSystem: 'LED points-of-light, interior and exterior',
      waterFeature: 'Cascade',
      controlSystem: 'Balboa Control System 120v/15amp',
      heater: '1.0kW Heater',
      energyEfficiency: '2.0 lb. density polyurethane foam; Polar Insulation; Certified to California Energy Commission (CEC) Standards',
      jetPumps: 1,
      performanceRating: 'GRHS 2',
      filtration: '20 square foot filter',
      waterCare: 'Optional - PureCD Ozone System',
      spaCover: '1.5 lbs. density, 4" to 2.5" tapered foam core cover, Weather resistant material | Black',
      shellColorOptions: 'White Satin, Silver Satin, Opal Satin',
      cabinetColorOptions: 'Coastal Gray, Barnwood, Walnut, Black',
      cornerColorOptions: 'Matching or Black'
    }
  },
  {
    id: 'gr-manistee-eco',
    name: 'Manistee Eco',
    brand: 'Grand River Spas',
    series: 'Eco Series',
    modelFamily: 'Manistee',
    persons: 5,
    jets: 20,
    price: '$6,999.99',
    priceValue: 6999.99,
    seatingLayout: 'Non-Lounge',
    dimensions: '72″ round x 35″ tall',
    dimensionsMetric: '183 cm round x 89 cm tall',
    waterCapacity: '250 gallons | 946 liters',
    dryWeight: '330 lbs. | 150 kg',
    filledWeight: '2,415 lbs. | 1,095 kg',
    electrical: '120v/15amp',
    description: 'Plug-and-play round 5-person hot tub with hydrotherapy jets in every seat.',
    features: ['Plug-and-play 120v', '20 jets', '5-person capacity', 'LED lighting', 'Great value'],
    images: {
      primary: 'https://b4087952.smushcdn.com/4087952/wp-content/uploads/2025/06/GR_Manistee_Eco_Opal_Walnut_Side-768x576.png?lossy=2&strip=1&webp=1',
      overhead: 'https://b4087952.smushcdn.com/4087952/wp-content/uploads/2025/06/GR_Manistee-ManisteeEco_Opal_OH-768x768.png?lossy=2&strip=1&webp=1'
    },
    shellColors: ['white', 'opal'],
    cabinetColors: ['taupe', 'walnut'],
    relatedModel: null,
    fullSpecs: {
      seats: '5 Adults',
      seatingType: 'Non-Lounge',
      dimensions: '72″ round x 35″ tall',
      dimensionsMetric: '183 cm round x 89 cm tall',
      waterCapacity: '250 gallons | 946 liters',
      dryWeight: '330 lbs. | 150 kg',
      filledWeight: '2,415 lbs. | 1,095 kg',
      totalJets: 20,
      jets: [
        '1 Whirlpool jet',
        '4 Three-inch directional jets',
        '2 Three-inch rotating jets',
        '2 Four-inch directional jets',
        '2 Four-inch rotating jets',
        '8 Two-inch stationary jets'
      ],
      auxiliaryJets: '1 Ozone jet',
      lightingSystem: 'LED Lighting System, Spa Light',
      waterFeature: 'N/A',
      controlSystem: 'Balboa Control System 120v/15amp',
      heater: '1.0kW Heater',
      energyEfficiency: '2.0 lb. density polyurethane foam; Polar Insulation; Certified to California Energy Commission (CEC) Standards',
      jetPumps: 1,
      performanceRating: 'GRHS 2',
      filtration: '20 square foot filter',
      waterCare: 'Optional',
      spaCover: '1.5 lbs. density, 4" to 2.5" tapered foam core cover, Weather resistant material | Black',
      shellColorOptions: 'White Satin or Opal Satin',
      cabinetColorOptions: 'Taupe or Walnut',
      cornerColorOptions: 'N/A'
    }
  }
];

// ===========================================
// GRAND RIVER SPAS EXTRAS/OPTIONS
// ===========================================
export const GRAND_RIVER_EXTRAS = [
  {
    id: 'gr-extra-ozone',
    name: 'Ozone',
    price: '$295.99',
    priceValue: 295.99,
    image: '/images/addons/ozone.jpg',
    description: 'Advanced ozone sanitization system for cleaner, clearer water with fewer chemicals.'
  },
  {
    id: 'gr-extra-touchscreen',
    name: 'Spa Touch 4 Touchscreen',
    price: '$695.99',
    priceValue: 695.99,
    image: '/images/addons/touchscreen control.png',
    description: 'Upgrade to the Spa Touch 4 modern touchscreen control panel for easier spa management.'
  },
  {
    id: 'gr-extra-airx',
    name: 'Air X Therapy',
    price: '$299.99',
    priceValue: 299.99,
    image: '/images/addons/airxtherapy.jpg',
    description: 'Enhanced air therapy system for a more luxurious massage experience.'
  },
  {
    id: 'gr-extra-bluetooth',
    name: 'Bluetooth Stereo',
    price: '$995.99',
    priceValue: 995.99,
    image: '/images/addons/bluetooth speakers.png',
    description: 'Premium Bluetooth stereo audio system for music while you relax.'
  },
  {
    id: 'gr-extra-wifi',
    name: 'WiFi Module',
    price: '$395.99',
    priceValue: 395.99,
    image: '/images/addons/in touch wifi.png',
    description: 'Control your spa remotely with the WiFi module and smartphone app.'
  }
];

// ===========================================
// DYNASTY SPAS EXTRAS/OPTIONS BY COLLECTION
// ===========================================

// Aquora Collection Features/Add-ons with accurate images from Dynasty Spas
export const AQUORA_ALL_SEASON_FEATURES = [
  {
    id: 'aquora-rmax-insulation',
    name: 'RMAX® Insulation',
    description: 'High-performance insulation with air chamber for cold-climate, four-season use.',
    image: '/images/aquora/aquora-filtering.png',
    included: true
  },
  {
    id: 'aquora-heater',
    name: 'Energy Efficient Heater',
    description: 'Electric water heater for year-round temperature control.',
    image: '/images/aquora/aquora-filtering.png',
    included: true
  },
  {
    id: 'aquora-k300',
    name: 'K300 Digital Topside',
    description: 'Intuitive digital topside control for temperature and functions.',
    image: '/images/aquora/aquora-k1000.jpg',
    included: true
  },
  {
    id: 'aquora-led',
    name: 'Underwater LED Light',
    description: 'Vibrant underwater LED lighting for ambiance.',
    image: '/images/aquora/aquora-deckside.png',
    included: true
  },
  {
    id: 'aquora-filtration',
    name: 'Filtration Pump',
    description: '100 sq. ft. cartridge filtration system.',
    image: '/images/aquora/aquora-filtering.png',
    included: true
  },
  {
    id: 'aquora-cover',
    name: 'Black Cover',
    description: 'Insulated black cover included for heat retention.',
    image: '/images/aquora/aquora-main.png',
    included: true
  }
];

export const AQUORA_HEAT_FEATURES = [
  {
    id: 'aquora-heater',
    name: 'Energy Efficient Heater',
    description: 'Electric water heater for year-round temperature control.',
    image: '/images/aquora/aquora-filtering.png',
    included: true
  },
  {
    id: 'aquora-k300',
    name: 'K300 Digital Topside',
    description: 'Intuitive digital topside control for temperature and functions.',
    image: '/images/aquora/aquora-k1000.jpg',
    included: true
  },
  {
    id: 'aquora-led',
    name: 'Underwater LED Light',
    description: 'Vibrant underwater LED lighting for ambiance.',
    image: '/images/aquora/aquora-deckside.png',
    included: true
  },
  {
    id: 'aquora-filtration',
    name: 'Filtration Pump',
    description: '100 sq. ft. cartridge filtration system.',
    image: '/images/aquora/aquora-filtering.png',
    included: true
  }
];

export const AQUORA_COMPLETE_FEATURES = [
  {
    id: 'aquora-plugnplay',
    name: 'Plug \'N Play 110V',
    description: 'Convenient 110V/15A electrical for quick installation.',
    image: '/images/aquora/aquora-plugnplay-icon.png',
    included: true
  },
  {
    id: 'aquora-led',
    name: 'Underwater LED Light',
    description: 'Vibrant underwater LED lighting for ambiance.',
    image: '/images/aquora/aquora-deckside.png',
    included: true
  },
  {
    id: 'aquora-filtration',
    name: 'Filtration Pump',
    description: '100 sq. ft. cartridge filtration system.',
    image: '/images/aquora/aquora-complete-filtering.png',
    included: true
  }
];

export const AQUORA_CORE_FEATURES = [
  {
    id: 'aquora-shell',
    name: 'Premium Acrylic Shell',
    description: 'Pearl Gray acrylic shell only - equipment not included.',
    image: '/images/aquora/aquora-shell.png',
    included: true
  },
  {
    id: 'aquora-mats',
    name: 'Cushioned Step Mats',
    description: 'Foam step mats for comfort.',
    image: '/images/aquora/aquora-stepmats.png',
    included: true
  }
];

// Standard Aquora Extras/Upgrades available for all models
export const AQUORA_EXTRAS = [
  {
    id: 'aquora-intouch',
    name: 'In.Touch WiFi Remote',
    price: 'Call for Pricing',
    image: '/images/aquora/aquora-intouch.png',
    description: 'Control your plunge remotely with the in.Touch smartphone app.'
  },
  {
    id: 'aquora-ozone',
    name: 'Ozone System',
    price: 'Call for Pricing',
    image: '/images/aquora/aquora-filtering.png',
    description: 'Advanced ozone water purification for cleaner, clearer water.'
  },
  {
    id: 'aquora-k1000',
    name: 'K.1000 Touchscreen Upgrade',
    price: 'Call for Pricing',
    image: '/images/aquora/aquora-k1000.jpg',
    description: 'Upgrade to the K.1000 touchscreen control panel.'
  }
];

// Luxury Collection Add-ons
export const DYNASTY_LUXURY_EXTRAS = [
  {
    id: 'ds-luxury-circ-pump',
    name: 'Circulation Pump',
    price: '$495.99',
    priceValue: 495.99,
    image: '/images/aquora/aquora-filtering.png',
    description: 'Energy-efficient circulation pump for improved water flow and filtration.'
  },
  {
    id: 'ds-luxury-intouch',
    name: 'In Touch WiFi Remote',
    price: '$395.99',
    priceValue: 395.99,
    image: '/images/addons/in touch wifi.png',
    description: 'Control your spa remotely with the in.Touch WiFi smartphone app.'
  },
  {
    id: 'ds-luxury-inmix',
    name: 'In Mix Illuminated Jet System',
    price: '$995.99',
    priceValue: 995.99,
    image: '/images/addons/led controls.png',
    description: 'Advanced in.Mix illuminated jet system with LED lighting throughout jets.'
  },
  {
    id: 'ds-luxury-instream',
    name: 'In Stream Audio',
    price: '$995.99',
    priceValue: 995.99,
    image: '/images/addons/in stream bluetooth.png',
    description: 'Premium in.Stream audio system for your spa experience.'
  }
];

// Oasis Collection Add-ons
export const DYNASTY_OASIS_EXTRAS = [
  {
    id: 'ds-oasis-circ-pump',
    name: 'Circulation Pump',
    price: '$495.99',
    priceValue: 495.99,
    image: '/images/aquora/aquora-filtering.png',
    description: 'Energy-efficient circulation pump for improved water flow and filtration.'
  },
  {
    id: 'ds-oasis-intouch',
    name: 'In Touch WiFi Remote',
    price: '$395.99',
    priceValue: 395.99,
    image: '/images/addons/in touch wifi.png',
    description: 'Control your spa remotely with the in.Touch WiFi smartphone app.'
  },
  {
    id: 'ds-oasis-inmix',
    name: 'In Mix Illuminated Jet System',
    price: '$995.99',
    priceValue: 995.99,
    image: '/images/addons/led controls.png',
    description: 'Advanced in.Mix illuminated jet system with LED lighting throughout jets.'
  },
  {
    id: 'ds-oasis-instream',
    name: 'In Stream Audio',
    price: '$995.99',
    priceValue: 995.99,
    image: '/images/addons/in stream bluetooth.png',
    description: 'Premium in.Stream audio system for your spa experience.'
  }
];

// Vacation Collection Add-ons
export const DYNASTY_VACATION_EXTRAS = [
  {
    id: 'ds-vacation-circ-pump',
    name: 'Circulation Pump',
    price: '$495.99',
    priceValue: 495.99,
    image: '/images/aquora/aquora-filtering.png',
    description: 'Energy-efficient circulation pump for improved water flow and filtration.'
  },
  {
    id: 'ds-vacation-intouch',
    name: 'In Touch WiFi Remote',
    price: '$395.99',
    priceValue: 395.99,
    image: '/images/addons/in touch wifi.png',
    description: 'Control your spa remotely with the in.Touch WiFi smartphone app.'
  },
  {
    id: 'ds-vacation-inmix',
    name: 'In Mix Illuminated Jet System',
    price: '$995.99',
    priceValue: 995.99,
    image: '/images/addons/led controls.png',
    description: 'Advanced in.Mix illuminated jet system with LED lighting throughout jets.'
  },
  {
    id: 'ds-vacation-instream',
    name: 'In Stream Audio',
    price: '$995.99',
    priceValue: 995.99,
    image: '/images/addons/in stream bluetooth.png',
    description: 'Premium in.Stream audio system for your spa experience.'
  }
];

// Hideaway Collection Add-ons
export const DYNASTY_HIDEAWAY_EXTRAS = [
  {
    id: 'ds-hideaway-circ-pump',
    name: 'Circulation Pump',
    price: '$495.99',
    priceValue: 495.99,
    image: '/images/aquora/aquora-filtering.png',
    description: 'Energy-efficient circulation pump for improved water flow and filtration.'
  },
  {
    id: 'ds-hideaway-intouch',
    name: 'In Touch WiFi Remote',
    price: '$395.99',
    priceValue: 395.99,
    image: '/images/addons/in touch wifi.png',
    description: 'Control your spa remotely with the in.Touch WiFi smartphone app.'
  },
  {
    id: 'ds-hideaway-inmix',
    name: 'In Mix Illuminated Jet System',
    price: '$995.99',
    priceValue: 995.99,
    image: '/images/addons/led controls.png',
    description: 'Advanced in.Mix illuminated jet system with LED lighting throughout jets.'
  },
  {
    id: 'ds-hideaway-instream',
    name: 'In Stream Audio',
    price: '$995.99',
    priceValue: 995.99,
    image: '/images/addons/in stream bluetooth.png',
    description: 'Premium in.Stream audio system for your spa experience.'
  }
];

// Family Collection Add-ons
export const DYNASTY_FAMILY_EXTRAS = [
  {
    id: 'ds-family-circ-pump',
    name: 'Circulation Pump',
    price: '$495.99',
    priceValue: 495.99,
    image: '/images/aquora/aquora-filtering.png',
    description: 'Energy-efficient circulation pump for improved water flow and filtration.'
  },
  {
    id: 'ds-family-intouch',
    name: 'In Touch WiFi Remote',
    price: '$395.99',
    priceValue: 395.99,
    image: '/images/addons/in touch wifi.png',
    description: 'Control your spa remotely with the in.Touch WiFi smartphone app.'
  },
  {
    id: 'ds-family-inmix',
    name: 'In Mix Illuminated Jet System',
    price: '$995.99',
    priceValue: 995.99,
    image: '/images/addons/led controls.png',
    description: 'Advanced in.Mix illuminated jet system with LED lighting throughout jets.'
  },
  {
    id: 'ds-family-instream',
    name: 'In Stream Audio',
    price: '$995.99',
    priceValue: 995.99,
    image: '/images/addons/in stream bluetooth.png',
    description: 'Premium in.Stream audio system for your spa experience.'
  }
];

// Aquex Collection Add-ons
export const DYNASTY_AQUEX_EXTRAS = [
  {
    id: 'ds-aquex-circ-pump',
    name: 'Circulation Pump',
    price: '$495.99',
    priceValue: 495.99,
    image: '/images/aquora/aquora-filtering.png',
    description: 'Energy-efficient circulation pump for improved water flow and filtration.'
  },
  {
    id: 'ds-aquex-intouch',
    name: 'In Touch WiFi Remote',
    price: '$395.99',
    priceValue: 395.99,
    image: '/images/addons/in touch wifi.png',
    description: 'Control your spa remotely with the in.Touch WiFi smartphone app.'
  },
  {
    id: 'ds-aquex-inmix',
    name: 'In Mix Illuminated Jet System',
    price: '$995.99',
    priceValue: 995.99,
    image: '/images/addons/led controls.png',
    description: 'Advanced in.Mix illuminated jet system with LED lighting throughout jets.'
  },
  {
    id: 'ds-aquex-instream',
    name: 'In Stream Audio',
    price: '$995.99',
    priceValue: 995.99,
    image: '/images/addons/in stream bluetooth.png',
    description: 'Premium in.Stream audio system for your spa experience.'
  }
];

// ===========================================
// DYNASTY SPAS PRODUCTS
// ===========================================
export const DYNASTY_SPAS_PRODUCTS = [
  // OASIS COLLECTION
  {
    id: 'ds-paradise-bay-iii',
    name: 'Paradise Bay III',
    brand: 'Dynasty Spas',
    series: 'Oasis Collection',
    modelFamily: 'Paradise Bay',
    persons: 8,
    jets: 83,
    price: '$13,999.99',
    priceValue: 13999.99,
    seatingLayout: 'Lounger',
    dimensions: '92" x 102" x 39"',
    waterCapacity: '505 gallons',
    electrical: '220v/60a',
    pumps: '3 - 6.0bhp',
    filtration: '100 ft²',
    dryWeight: '1,000 lbs',
    filledWeight: '4,800 lbs',
    description: 'Premium 8-person lounger with 83 powerful jets and illuminated fountain features.',
    features: ['LED Illuminated Fountain Jets', 'LED Illuminated Diverters', 'Reverse Pull Neck Jets', 'Illuminated Weir Door'],
    images: {
      primary: 'https://static.wixstatic.com/media/5c7c78_a461af4de3624cb18c573904c199c7fb~mv2.webp'
    },
    shellColors: ['sterlingMarble', 'stormClouds', 'tuscanSun', 'smokyMountain'],
    cabinetColors: ['blackConfer', 'grayConfer', 'ashElite', 'coastalGrayElite']
  },
  {
    id: 'ds-paradise-bay-ii',
    name: 'Paradise Bay II',
    brand: 'Dynasty Spas',
    series: 'Oasis Collection',
    modelFamily: 'Paradise Bay',
    persons: 8,
    jets: 83,
    price: '$12,999.99',
    priceValue: 12999.99,
    seatingLayout: 'Lounger',
    dimensions: '92" x 102" x 39"',
    waterCapacity: '505 gallons',
    electrical: '220v/60a',
    pumps: '2 - 7.0bhp',
    filtration: '100 ft²',
    dryWeight: '1,000 lbs',
    filledWeight: '4,800 lbs',
    description: '8-person lounger with 83 jets featuring illuminated fountain jets.',
    features: ['LED Illuminated Fountain Jets', 'LED Illuminated Diverters', 'Reverse Pull Neck Jets', 'Illuminated Weir Door'],
    images: {
      primary: 'https://static.wixstatic.com/media/5c7c78_a461af4de3624cb18c573904c199c7fb~mv2.webp'
    },
    shellColors: ['sterlingMarble', 'stormClouds', 'tuscanSun', 'smokyMountain'],
    cabinetColors: ['blackConfer', 'grayConfer', 'ashElite', 'coastalGrayElite']
  },
  {
    id: 'ds-palm-island-ii',
    name: 'Palm Island II',
    brand: 'Dynasty Spas',
    series: 'Oasis Collection',
    modelFamily: 'Palm Island',
    persons: 7,
    jets: 76,
    price: '$12,999.99',
    priceValue: 12999.99,
    seatingLayout: 'Bench',
    dimensions: '92" x 92" x 39"',
    waterCapacity: '425 gallons',
    electrical: '220v/60a',
    pumps: '2 - 7.0bhp',
    filtration: '100 ft²',
    dryWeight: '900 lbs',
    filledWeight: '4,300 lbs',
    description: 'Spacious 7-person bench spa with 76 jets and illuminated fountain features.',
    features: ['LED Illuminated Fountain Jets', 'LED Illuminated Diverters', 'Reverse Pull Neck Jets', 'Illuminated Weir Door'],
    images: {
      primary: 'https://static.wixstatic.com/media/5c7c78_bca37801d2234c42920ff45b5ef8b947~mv2.webp'
    },
    shellColors: ['sterlingMarble', 'stormClouds', 'tuscanSun', 'smokyMountain'],
    cabinetColors: ['blackConfer', 'grayConfer', 'ashElite', 'coastalGrayElite']
  },
  {
    id: 'ds-palm-island-iii',
    name: 'Palm Island III',
    brand: 'Dynasty Spas',
    series: 'Oasis Collection',
    modelFamily: 'Palm Island',
    persons: 7,
    jets: 76,
    price: '$13,999.99',
    priceValue: 13999.99,
    seatingLayout: 'Bench',
    dimensions: '92" x 92" x 39"',
    waterCapacity: '425 gallons',
    electrical: '220v/60a',
    pumps: '3 - 6.0bhp',
    filtration: '100 ft²',
    dryWeight: '900 lbs',
    filledWeight: '4,300 lbs',
    description: 'Spacious 7-person bench spa with 76 jets and illuminated fountain features.',
    features: ['LED Illuminated Fountain Jets', 'LED Illuminated Diverters', 'Reverse Pull Neck Jets', 'Illuminated Weir Door'],
    images: {
      primary: 'https://static.wixstatic.com/media/5c7c78_bca37801d2234c42920ff45b5ef8b947~mv2.webp'
    },
    shellColors: ['sterlingMarble', 'stormClouds', 'tuscanSun', 'smokyMountain'],
    cabinetColors: ['blackConfer', 'grayConfer', 'ashElite', 'coastalGrayElite']
  },
  {
    id: 'ds-pleasure-cove-ii',
    name: 'Pleasure Cove II',
    brand: 'Dynasty Spas',
    series: 'Oasis Collection',
    modelFamily: 'Pleasure Cove',
    persons: 5,
    jets: 80,
    price: '$12,999.99',
    priceValue: 12999.99,
    seatingLayout: 'Dual Lounger',
    dimensions: '92" x 92" x 39"',
    waterCapacity: '425 gallons',
    electrical: '220v/60a',
    pumps: '2 - 7.0bhp',
    filtration: '100 ft²',
    dryWeight: '900 lbs',
    filledWeight: '4,300 lbs',
    description: '5-person dual lounger with 80 jets featuring illuminated waterfalls.',
    features: ['LED Top Rail Lighting', 'LED Illuminated Waterfall', 'LED Illuminated Diverters', 'Reverse Pull Neck Jets'],
    images: {
      primary: 'https://static.wixstatic.com/media/5c7c78_ee35b0a0b9df47e1911c752a6dc65d80~mv2.jpg'
    },
    shellColors: ['sterlingMarble', 'stormClouds', 'tuscanSun', 'smokyMountain'],
    cabinetColors: ['blackConfer', 'grayConfer', 'ashElite', 'coastalGrayElite']
  },
  {
    id: 'ds-pleasure-cove-iii',
    name: 'Pleasure Cove III',
    brand: 'Dynasty Spas',
    series: 'Oasis Collection',
    modelFamily: 'Pleasure Cove',
    persons: 5,
    jets: 80,
    price: '$13,999.99',
    priceValue: 13999.99,
    seatingLayout: 'Dual Lounger',
    dimensions: '92" x 92" x 39"',
    waterCapacity: '425 gallons',
    electrical: '220v/60a',
    pumps: '3 - 6.0bhp',
    filtration: '100 ft²',
    dryWeight: '900 lbs',
    filledWeight: '4,300 lbs',
    description: '5-person dual lounger with 80 jets featuring illuminated waterfalls.',
    features: ['LED Top Rail Lighting', 'LED Illuminated Waterfall', 'LED Illuminated Diverters', 'Reverse Pull Neck Jets'],
    images: {
      primary: 'https://static.wixstatic.com/media/5c7c78_ee35b0a0b9df47e1911c752a6dc65d80~mv2.jpg'
    },
    shellColors: ['sterlingMarble', 'stormClouds', 'tuscanSun', 'smokyMountain'],
    cabinetColors: ['blackConfer', 'grayConfer', 'ashElite', 'coastalGrayElite']
  },
  {
    id: 'ds-coconut-bay-ii',
    name: 'Coconut Bay II',
    brand: 'Dynasty Spas',
    series: 'Oasis Collection',
    modelFamily: 'Coconut Bay',
    persons: 5,
    jets: 74,
    price: '$12,999.99',
    priceValue: 12999.99,
    seatingLayout: 'Lounger',
    dimensions: '92" x 92" x 39"',
    waterCapacity: '425 gallons',
    electrical: '220v/60a',
    pumps: '2 - 7.0bhp',
    filtration: '100 ft²',
    dryWeight: '900 lbs',
    filledWeight: '4,300 lbs',
    description: '5-person lounger with 74 jets and beautiful illuminated waterfalls.',
    features: ['LED Illuminated Waterfalls', 'LED Illuminated Diverters', 'Reverse Pull Neck Jets', 'Illuminated Weir Door'],
    images: {
      primary: 'https://static.wixstatic.com/media/5c7c78_7b87b150ef5a451db8a4599e9b9aa68f~mv2.jpg'
    },
    shellColors: ['sterlingMarble', 'stormClouds', 'tuscanSun', 'smokyMountain'],
    cabinetColors: ['blackConfer', 'grayConfer', 'ashElite', 'coastalGrayElite']
  },
  {
    id: 'ds-coconut-bay-iii',
    name: 'Coconut Bay III',
    brand: 'Dynasty Spas',
    series: 'Oasis Collection',
    modelFamily: 'Coconut Bay',
    persons: 5,
    jets: 74,
    price: '$13,999.99',
    priceValue: 13999.99,
    seatingLayout: 'Lounger',
    dimensions: '92" x 92" x 39"',
    waterCapacity: '425 gallons',
    electrical: '220v/60a',
    pumps: '3 - 6.0bhp',
    filtration: '100 ft²',
    dryWeight: '900 lbs',
    filledWeight: '4,300 lbs',
    description: '5-person lounger with 74 jets and beautiful illuminated waterfalls.',
    features: ['LED Illuminated Waterfalls', 'LED Illuminated Diverters', 'Reverse Pull Neck Jets', 'Illuminated Weir Door'],
    images: {
      primary: 'https://static.wixstatic.com/media/5c7c78_7b87b150ef5a451db8a4599e9b9aa68f~mv2.jpg'
    },
    shellColors: ['sterlingMarble', 'stormClouds', 'tuscanSun', 'smokyMountain'],
    cabinetColors: ['blackConfer', 'grayConfer', 'ashElite', 'coastalGrayElite']
  },
  {
    id: 'ds-caribbean-breeze',
    name: 'Caribbean Breeze',
    brand: 'Dynasty Spas',
    series: 'Oasis Collection',
    modelFamily: 'Caribbean Breeze',
    persons: 7,
    jets: 73,
    price: '$11,995.99',
    priceValue: 11995.99,
    seatingLayout: 'Bench',
    dimensions: '82" x 82" x 39"',
    waterCapacity: '295 gallons',
    electrical: '220v/60a',
    pumps: '2 - 7.0bhp',
    filtration: '100 ft²',
    dryWeight: '750 lbs',
    filledWeight: '3,935 lbs',
    description: '7-person bench spa with 73 jets and illuminated fountain features.',
    features: ['LED Top Rail Lighting', 'LED Illuminated Fountain Jets', 'LED Illuminated Diverters', 'Reverse Pull Neck Jets', 'Padded Headrests'],
    images: {
      primary: 'https://static.wixstatic.com/media/5c7c78_fbd8a68293fc44af9ba6616677d13e52~mv2.webp'
    },
    shellColors: ['sterlingMarble', 'stormClouds', 'tuscanSun', 'smokyMountain'],
    cabinetColors: ['blackConfer', 'grayConfer', 'ashElite', 'coastalGrayElite']
  },
  {
    id: 'ds-nassau-royal',
    name: 'Nassau Royale',
    brand: 'Dynasty Spas',
    series: 'Oasis Collection',
    modelFamily: 'Nassau Royale',
    persons: 6,
    jets: 73,
    price: '$11,995.99',
    priceValue: 11995.99,
    seatingLayout: 'Lounger',
    dimensions: '82" x 82" x 39"',
    waterCapacity: '295 gallons',
    electrical: '220v/60a',
    pumps: '2 - 7.0bhp',
    filtration: '100 ft²',
    dryWeight: '750 lbs',
    filledWeight: '3,935 lbs',
    description: '6-person lounger with 73 jets and illuminated waterfall.',
    features: ['LED Top Rail Lighting', 'LED Illuminated Waterfall', 'LED Illuminated Fountains', 'LED Illuminated Diverters', 'Reverse Pull Neck Jets', 'Padded Headrests'],
    images: {
      primary: 'https://static.wixstatic.com/media/5c7c78_cbdbc08c5de94874956a54d800585201~mv2.webp'
    },
    shellColors: ['sterlingMarble', 'stormClouds', 'tuscanSun', 'smokyMountain'],
    cabinetColors: ['blackConfer', 'grayConfer', 'ashElite', 'coastalGrayElite']
  },
  // VACATION COLLECTION
  {
    id: 'ds-cabana-bay',
    name: 'Cabana Bay',
    brand: 'Dynasty Spas',
    series: 'Vacation Collection',
    modelFamily: 'Cabana Bay',
    persons: 5,
    jets: 42,
    price: '$9,999.99',
    priceValue: 9999.99,
    seatingLayout: 'Lounger',
    dimensions: '92" x 92" x 39"',
    waterCapacity: '425 gallons',
    electrical: '220v/60a',
    pumps: '2 - 6.0bhp',
    filtration: '50 ft²',
    dryWeight: '900 lbs',
    filledWeight: '4,370 lbs',
    description: '5-person lounger with cascading waterfall and 42 jets.',
    features: ['Cascading Waterfall', 'Padded Headrests', 'LED Underwater Lighting', 'Maintenance Free Skirting', 'Easy Grip Built-In Handles'],
    images: {
      primary: 'https://static.wixstatic.com/media/5c7c78_5513dfe4f07146e6b3769397e333b714~mv2.jpg'
    },
    shellColors: ['sterlingMarble', 'stormClouds', 'tuscanSun', 'smokyMountain'],
    cabinetColors: ['blackConfer', 'grayConfer', 'ashElite', 'coastalGrayElite']
  },
  {
    id: 'ds-ocean-breeze',
    name: 'Ocean Breeze',
    brand: 'Dynasty Spas',
    series: 'Vacation Collection',
    modelFamily: 'Ocean Breeze',
    persons: 7,
    jets: 42,
    price: '$9,999.99',
    priceValue: 9999.99,
    seatingLayout: 'Bench',
    dimensions: '92" x 92" x 39"',
    waterCapacity: '425 gallons',
    electrical: '220v/60a',
    pumps: '2 - 6.0bhp',
    filtration: '50 ft²',
    dryWeight: '900 lbs',
    filledWeight: '4,570 lbs',
    description: '7-person bench spa with LED illuminated fountains and 42 jets.',
    features: ['LED Illuminated Fountains', 'LED Underwater Lighting', 'Padded Headrests', 'Easy Grip Built-in Handles', 'Maintenance Free Skirting'],
    images: {
      primary: 'https://static.wixstatic.com/media/5c7c78_d99c32d0154b4d5784b516fb7f9cf64b~mv2.webp'
    },
    shellColors: ['sterlingMarble', 'stormClouds', 'tuscanSun', 'smokyMountain'],
    cabinetColors: ['blackConfer', 'grayConfer', 'ashElite', 'coastalGrayElite']
  },
  {
    id: 'ds-twin-palms',
    name: 'Twin Palms',
    brand: 'Dynasty Spas',
    series: 'Oasis Collection',
    modelFamily: 'Twin Palms',
    persons: 3,
    jets: 50,
    price: '$9,999.99',
    priceValue: 9999.99,
    seatingLayout: 'Dual Lounger',
    dimensions: '60" x 82.5" x 30"',
    waterCapacity: '180 gallons',
    electrical: '220v/60a',
    pumps: '2 - 6.0bhp',
    filtration: '50 ft²',
    dryWeight: '375 lbs',
    filledWeight: '2,175 lbs',
    description: 'Compact 3-person dual lounger perfect for couples.',
    features: ['Padded Headrests', 'LED Top Rail Lighting', 'LED Underwater Lighting', 'Cup Holders', 'Easy Grip Built-in Handles'],
    images: {
      primary: 'https://static.wixstatic.com/media/5c7c78_0eda11c7c2bd4659886b1569a18263e4~mv2.png'
    },
    shellColors: ['sterlingMarble', 'stormClouds', 'tuscanSun', 'smokyMountain'],
    cabinetColors: ['blackConfer', 'grayConfer', 'ashElite', 'coastalGrayElite']
  },
  {
    id: 'ds-bimini-110v',
    name: 'Bimini 110v',
    brand: 'Dynasty Spas',
    series: 'Vacation Collection',
    modelFamily: 'Bimini',
    persons: 2,
    jets: 21,
    price: '$8,495.99',
    priceValue: 8495.99,
    seatingLayout: 'Lounger',
    dimensions: '72" x 72" x 33.5"',
    waterCapacity: '160 gallons',
    electrical: '110v/20a',
    pumps: '1 - 3.0bhp',
    filtration: '50 ft²',
    dryWeight: '350 lbs',
    filledWeight: '1,390 lbs',
    description: 'Intimate 2-person lounger perfect for couples and small spaces. Plug-and-play 110v convenience.',
    features: ['K.506 Digital Topside', 'Cascading Waterfall', 'LED Underwater Light', 'Padded Headrests', 'RMAX Insulation', 'Maintenance Free Skirting'],
    images: {
      primary: 'https://static.wixstatic.com/media/5c7c78_34462486d3164fcfb82328783db9ab3d~mv2.webp'
    },
    shellColors: ['sterlingMarble', 'stormClouds', 'tuscanSun', 'smokyMountain'],
    cabinetColors: ['blackConfer', 'grayConfer']
  },
  {
    id: 'ds-bimini-220v',
    name: 'Bimini 220v',
    brand: 'Dynasty Spas',
    series: 'Vacation Collection',
    modelFamily: 'Bimini',
    persons: 2,
    jets: 21,
    price: '$8,495.99',
    priceValue: 8495.99,
    seatingLayout: 'Lounger',
    dimensions: '72" x 72" x 33.5"',
    waterCapacity: '160 gallons',
    electrical: '220v/60a',
    pumps: '1 - 6.0bhp',
    filtration: '50 ft²',
    dryWeight: '350 lbs',
    filledWeight: '1,390 lbs',
    description: 'Intimate 2-person lounger perfect for couples and small spaces. 220v for faster heating.',
    features: ['K.506 Digital Topside', 'Cascading Waterfall', 'LED Underwater Light', 'Padded Headrests', 'RMAX Insulation', 'Maintenance Free Skirting'],
    images: {
      primary: 'https://static.wixstatic.com/media/5c7c78_34462486d3164fcfb82328783db9ab3d~mv2.webp'
    },
    shellColors: ['sterlingMarble', 'stormClouds', 'tuscanSun', 'smokyMountain'],
    cabinetColors: ['blackConfer', 'grayConfer']
  },
  {
    id: 'ds-treasure-cay-110v',
    name: 'Treasure Cay 110v',
    brand: 'Dynasty Spas',
    series: 'Vacation Collection',
    modelFamily: 'Treasure Cay',
    persons: 5,
    jets: 30,
    price: '$8,995.99',
    priceValue: 8995.99,
    seatingLayout: 'Lounger',
    dimensions: '78" x 78" x 36"',
    waterCapacity: '280 gallons',
    electrical: '110v/20a',
    pumps: '1 - 3.0bhp',
    filtration: '50 ft²',
    dryWeight: '600 lbs',
    filledWeight: '3,160 lbs',
    description: '5-person lounger with comfortable seating and 30 jets. Plug-and-play 110v convenience.',
    features: ['Cascading Waterfall', 'LED Illuminated Diverters', 'LED Underwater Lighting'],
    images: {
      primary: 'https://static.wixstatic.com/media/5c7c78_d5dd6e6b07c84184a58183333213387f~mv2.jpg'
    },
    shellColors: ['sterlingMarble', 'stormClouds', 'tuscanSun', 'smokyMountain'],
    cabinetColors: ['blackConfer', 'grayConfer', 'ashElite', 'coastalGrayElite']
  },
  {
    id: 'ds-treasure-cay-220v',
    name: 'Treasure Cay 220v',
    brand: 'Dynasty Spas',
    series: 'Vacation Collection',
    modelFamily: 'Treasure Cay',
    persons: 5,
    jets: 30,
    price: '$8,995.99',
    priceValue: 8995.99,
    seatingLayout: 'Lounger',
    dimensions: '78" x 78" x 36"',
    waterCapacity: '280 gallons',
    electrical: '220v/60a',
    pumps: '1 - 6.0bhp',
    filtration: '50 ft²',
    dryWeight: '600 lbs',
    filledWeight: '3,160 lbs',
    description: '5-person lounger with comfortable seating and 30 jets. 220v for faster heating.',
    features: ['Cascading Waterfall', 'LED Illuminated Diverters', 'LED Underwater Lighting'],
    images: {
      primary: 'https://static.wixstatic.com/media/5c7c78_d5dd6e6b07c84184a58183333213387f~mv2.jpg'
    },
    shellColors: ['sterlingMarble', 'stormClouds', 'tuscanSun', 'smokyMountain'],
    cabinetColors: ['blackConfer', 'grayConfer', 'ashElite', 'coastalGrayElite']
  },
  {
    id: 'ds-sunset-cove',
    name: 'Sunset Cove',
    brand: 'Dynasty Spas',
    series: 'Vacation Collection',
    modelFamily: 'Sunset Cove',
    persons: 3,
    jets: 36,
    price: '$9,195.99',
    priceValue: 9195.99,
    seatingLayout: 'Lounger',
    dimensions: '60" x 82.5" x 33.5"',
    waterCapacity: '160 gallons',
    electrical: '220v/60a',
    pumps: '1 - 6.0bhp',
    filtration: '50 ft²',
    dryWeight: '350 lbs',
    filledWeight: '2,150 lbs',
    description: 'Compact 3-person lounger ideal for patios and smaller spaces. Features LED fountain jets.',
    features: ['LED Fountain Jets', 'LED Underwater Lighting', 'Padded Headrests', 'Easy Grip Built-in Handles', 'Maintenance Free Skirting'],
    images: {
      primary: '/images/dynasty/sunset-cove.png'
    },
    shellColors: ['sterlingMarble', 'stormClouds', 'tuscanSun', 'smokyMountain'],
    cabinetColors: ['blackConfer', 'grayConfer', 'ashElite', 'coastalGrayElite']
  },
  {
    id: 'ds-tranquility-harbor',
    name: 'Tranquility Harbor',
    brand: 'Dynasty Spas',
    series: 'Vacation Collection',
    modelFamily: 'Tranquility Harbor',
    persons: 7,
    jets: 42,
    price: '$9,695.99',
    priceValue: 9695.99,
    seatingLayout: 'Bench',
    dimensions: '82" x 82" x 39"',
    waterCapacity: '295 gallons',
    electrical: '220v/60a',
    pumps: '2 - 6.0bhp',
    filtration: '50 ft²',
    dryWeight: '675 lbs',
    filledWeight: '3,475 lbs',
    description: 'Spacious 7-person bench spa with 42 jets for family enjoyment.',
    features: ['Cascading Waterfall', 'Padded Headrest', 'LED Underwater Lighting', 'Maintenance Free Skirting', 'RMAX Insulation'],
    images: {
      primary: 'https://static.wixstatic.com/media/5c7c78_4f5108db76954c94977c8c470414a6df~mv2.jpg'
    },
    shellColors: ['sterlingMarble', 'stormClouds', 'tuscanSun', 'smokyMountain'],
    cabinetColors: ['blackConfer', 'grayConfer', 'ashElite', 'coastalGrayElite']
  },
  {
    id: 'ds-serenity-cove',
    name: 'Serenity Cove',
    brand: 'Dynasty Spas',
    series: 'Vacation Collection',
    modelFamily: 'Serenity Cove',
    persons: 5,
    jets: 42,
    price: '$9,999.99',
    priceValue: 9999.99,
    seatingLayout: 'Lounger',
    dimensions: '82" x 82" x 39"',
    waterCapacity: '295 gallons',
    electrical: '220v/60a',
    pumps: '2 - 6.0bhp',
    filtration: '50 ft²',
    dryWeight: '675 lbs',
    filledWeight: '3,475 lbs',
    description: '5-person lounger designed for relaxation and tranquility.',
    features: ['Cascading Waterfall', 'LED Underwater Lighting', 'Padded Headrests', 'Maintenance Free Skirting', 'Entry / Exit Steps'],
    images: {
      primary: 'https://static.wixstatic.com/media/5c7c78_20ede20bacfc496e90c2dce3d07818f3~mv2.jpg'
    },
    shellColors: ['sterlingMarble', 'stormClouds', 'tuscanSun', 'smokyMountain'],
    cabinetColors: ['blackConfer', 'grayConfer', 'ashElite', 'coastalGrayElite']
  },
  // HIDEAWAY COLLECTION
  {
    id: 'ds-seaside-110v',
    name: 'Seaside 110v',
    brand: 'Dynasty Spas',
    series: 'Hideaway Collection',
    modelFamily: 'Seaside',
    persons: 4,
    jets: 20,
    price: '$7,995.99',
    priceValue: 7995.99,
    seatingLayout: 'Bench',
    dimensions: '68" x 90" x 35"',
    waterCapacity: '250 gallons',
    electrical: '110v/20a',
    pumps: '1 - 3.0bhp',
    filtration: '50 ft²',
    dryWeight: '350 lbs',
    filledWeight: '2,350 lbs',
    description: 'Entry-level spa with plug-and-play convenience. Features K.362 digital topside, black scallop jets, and LED underwater lighting.',
    features: ['K.362 Digital Topside', 'Euro Fountains', 'LED Underwater Lighting', 'Padded Headrests', 'Ozonator System', 'Energy Efficient Heater', 'RMAX Insulation', 'Insulated Cover'],
    images: {
      primary: 'https://static.wixstatic.com/media/5c7c78_5cdf2136d8a84cb499f0c63569ebe365~mv2.webp'
    },
    shellColors: ['sterlingMarble'],
    cabinetColors: ['blackConfer']
  },
  {
    id: 'ds-seaside-220v',
    name: 'Seaside 220v',
    brand: 'Dynasty Spas',
    series: 'Hideaway Collection',
    modelFamily: 'Seaside',
    persons: 4,
    jets: 20,
    price: '$7,995.99',
    priceValue: 7995.99,
    seatingLayout: 'Bench',
    dimensions: '68" x 90" x 35"',
    waterCapacity: '250 gallons',
    electrical: '220v/60a',
    pumps: '1 - 6.0bhp',
    filtration: '50 ft²',
    dryWeight: '350 lbs',
    filledWeight: '2,350 lbs',
    description: 'Entry-level spa with 220v power. Features K.362 digital topside, euro fountains, and LED underwater lighting.',
    features: ['K.362 Digital Topside', 'Euro Fountains', 'LED Underwater Lighting', 'Padded Headrests', 'Ozonator System', 'Energy Efficient Heater', 'RMAX Insulation', 'Insulated Cover'],
    images: {
      primary: 'https://static.wixstatic.com/media/5c7c78_5cdf2136d8a84cb499f0c63569ebe365~mv2.webp'
    },
    shellColors: ['sterlingMarble'],
    cabinetColors: ['blackConfer']
  },
  {
    id: 'ds-bay-bliss',
    name: 'Bay Bliss',
    brand: 'Dynasty Spas',
    series: 'Hideaway Collection',
    modelFamily: 'Bay Bliss',
    persons: 5,
    jets: 30,
    price: '$8,995.99',
    priceValue: 8995.99,
    seatingLayout: 'Lounger',
    dimensions: '82" x 82" x 39"',
    waterCapacity: '295 gallons',
    electrical: '220v/60a',
    pumps: '2 - 6.0bhp',
    filtration: '50 ft²',
    dryWeight: '350 lbs',
    filledWeight: '2,710 lbs',
    description: 'Compact lounger spa perfect for intimate relaxation. Features K.362 digital topside, waterfall, and LED underwater lighting.',
    features: ['K.362 Digital Topside', 'Cascading Waterfall', 'LED Underwater Lighting', 'Padded Headrests', 'Ozonator System', 'Energy Efficient Heater', 'RMAX Insulation', 'Insulated Cover'],
    images: {
      primary: '/images/dynasty/bay-bliss.png'
    },
    shellColors: ['sterlingMarble'],
    cabinetColors: ['blackConfer']
  },
  {
    id: 'ds-high-tide',
    name: 'High Tide',
    brand: 'Dynasty Spas',
    series: 'Hideaway Collection',
    modelFamily: 'High Tide',
    persons: 7,
    jets: 30,
    price: '$8,995.99',
    priceValue: 8995.99,
    seatingLayout: 'Bench',
    dimensions: '82" x 82" x 39"',
    waterCapacity: '295 gallons',
    electrical: '220v/60a',
    pumps: '2 - 6.0bhp',
    filtration: '50 ft²',
    dryWeight: '350 lbs',
    filledWeight: '2,710 lbs',
    description: 'Bench-style spa with ample seating for relaxation. Features K.362 digital topside, waterfall, and LED underwater lighting.',
    features: ['K.362 Digital Topside', 'Cascading Waterfall', 'LED Underwater Lighting', 'Padded Headrests', 'Ozonator System', 'Energy Efficient Heater', 'RMAX Insulation', 'Insulated Cover'],
    images: {
      primary: 'https://static.wixstatic.com/media/5c7c78_20ede20bacfc496e90c2dce3d07818f3~mv2.jpg'
    },
    shellColors: ['sterlingMarble'],
    cabinetColors: ['blackConfer']
  },
  // LUXURY COLLECTION - 30TH ANNIVERSARY MODELS
  {
    id: 'ds-bahama-royale',
    name: 'Bahama Royale',
    brand: 'Dynasty Spas',
    series: 'Luxury Collection',
    modelFamily: 'Bahama Royale',
    persons: 5,
    jets: 83,
    price: '$16,959.99',
    priceValue: 16959.99,
    seatingLayout: 'Lounger',
    dimensions: '92" x 92" x 39"',
    waterCapacity: '425 gallons',
    electrical: '220v/60amp',
    pumps: '3 - 6.0bhp',
    filtration: '100 ft²',
    dryWeight: '1000 lbs',
    filledWeight: '4400 lbs',
    description: 'Premium 30th Anniversary lounger spa with deep oversized seating, K.1000 topside control, in.Touch app, and full LED in.Mix lighting throughout.',
    features: ['K.1000 Topside Control', 'In.Touch App', 'LED In.Mix Lighting', 'LED Illuminated Jets', 'LED Illuminated Pillows', 'LED Illuminated Waterfall', 'LED Illuminated Diverters', 'LED Corner Lighting', 'Deep Oversized Seating', 'Lucite Acrylic', '2-Toned Elite Skirting'],
    images: {
      primary: 'https://static.wixstatic.com/media/5c7c78_a461af4de3624cb18c573904c199c7fb~mv2.webp'
    },
    shellColors: ['sterlingMarble', 'stormClouds', 'tuscanSun', 'smokyMountain'],
    cabinetColors: ['coastalGrayElite', 'ashElite']
  },
  {
    id: 'ds-imperial-royale',
    name: 'Imperial Royale',
    brand: 'Dynasty Spas',
    series: 'Luxury Collection',
    modelFamily: 'Imperial Royale',
    persons: 7,
    jets: 83,
    price: '$16,995.99',
    priceValue: 16995.99,
    seatingLayout: 'Bench',
    dimensions: '92" x 92" x 39"',
    waterCapacity: '450 gallons',
    electrical: '220v/60amp',
    pumps: '3 - 6.0bhp',
    filtration: '100 ft²',
    dryWeight: '1000 lbs',
    filledWeight: '4400 lbs',
    description: 'Premium 30th Anniversary bench spa seating 7, with deep oversized seating, K.1000 topside control, in.Touch app, and full LED in.Mix lighting.',
    features: ['K.1000 Topside Control', 'In.Touch App', 'LED In.Mix Lighting', 'LED Illuminated Jets', 'LED Illuminated Pillows', 'LED Illuminated Waterfall', 'LED Illuminated Diverters', 'LED Corner Lighting', 'Deep Oversized Seating', 'Lucite Acrylic', '2-Toned Elite Skirting'],
    images: {
      primary: '/images/dynasty/imperial-royale.png'
    },
    shellColors: ['sterlingMarble', 'stormClouds', 'tuscanSun', 'smokyMountain'],
    cabinetColors: ['coastalGrayElite', 'ashElite']
  }
];

// ===========================================
// VIKING SPAS PRODUCTS
// ===========================================
export const VIKING_SPAS_PRODUCTS = [
  // ELITE SERIES - Includes: Spa Cover, Everlast Shell, Hope Resin Floor, Clear Guard Ozone, Temp Shield, Foam Board, Premium Light Package (Requires upgrade to Spa Touch 4)
  {
    id: 'vs-heritage-1',
    name: 'Heritage 1',
    brand: 'Viking Spas',
    series: 'Elite Series',
    modelFamily: 'Heritage',
    persons: 7,
    jets: 65,
    price: '$12,999.99',
    priceValue: 12999.99,
    seatingLayout: 'Lounge',
    dimensions: '94″ x 94″ x 38″',
    electrical: '240v/60amp',
    waterCapacity: '370 gallons',
    dryWeight: '650 lbs',
    filledWeight: '3738 lbs',
    pumps: '2',
    description: 'Our flagship model with premium features and maximum comfort. Elite Series includes: Spa Cover, Everlast Shell, Hope Resin Floor, Clear Guard Ozone, Temp Shield, Foam Board, Premium Light Package. Requires upgrade to Spa Touch 4.',
    features: ['Premium lounger', 'airX Therapy System', 'Everlast Shell', 'Clear Guard Ozone', 'Temp Shield Foam Board', 'Premium LED Light Package', 'Hope Resin Floor'],
    images: {
      primary: 'https://vikingspas.com/wp-content/uploads/2024/12/VS_2025_Heritage1_Opal_Stone_side_dropshadow-768x512.png',
      overhead: 'https://vikingspas.com/wp-content/uploads/2024/12/VS_2025_Elite_Heritage1_Opal_OH-_dropshadow.png'
    },
    shellColors: ['white', 'silver', 'opal'],
    cabinetColors: ['slate', 'chestnut', 'stone', 'carbon'],
    colorVisualizerBase: 'Heritage',
    relatedModel: 'vs-heritage-2'
  },
  {
    id: 'vs-heritage-2',
    name: 'Heritage 2',
    brand: 'Viking Spas',
    series: 'Elite Series',
    modelFamily: 'Heritage',
    persons: 7,
    jets: 70,
    price: '$13,999.99',
    priceValue: 13999.99,
    seatingLayout: 'Lounge',
    dimensions: '94″ x 94″ x 38″',
    electrical: '240v/60amp',
    waterCapacity: '370 gallons',
    dryWeight: '650 lbs',
    filledWeight: '4289 lbs',
    pumps: '2',
    description: 'Our flagship model with premium features and maximum comfort - enhanced jet configuration. Elite Series includes: Spa Cover, Everlast Shell, Hope Resin Floor, Clear Guard Ozone, Temp Shield, Foam Board, Premium Light Package. Requires upgrade to Spa Touch 4.',
    features: ['Premium lounger', 'airX Therapy System', 'Everlast Shell', 'Clear Guard Ozone', 'Temp Shield Foam Board', 'Premium LED Light Package', 'Hope Resin Floor', 'Enhanced jet configuration'],
    images: {
      primary: 'https://vikingspas.com/wp-content/uploads/2024/12/VS_2025_Heritage1_Opal_Stone_side_dropshadow-768x512.png',
      overhead: 'https://vikingspas.com/wp-content/uploads/2024/12/VS_2025_Elite_Heritage1_Opal_OH-_dropshadow.png'
    },
    shellColors: ['white', 'silver', 'opal'],
    cabinetColors: ['slate', 'chestnut', 'stone', 'carbon'],
    colorVisualizerBase: 'Heritage',
    relatedModel: 'vs-heritage-1'
  },
  {
    id: 'vs-tradition-1',
    name: 'Tradition 1',
    brand: 'Viking Spas',
    series: 'Elite Series',
    modelFamily: 'Tradition',
    persons: 7,
    jets: 58,
    price: '$12,999.99',
    priceValue: 12999.99,
    seatingLayout: 'Open',
    dimensions: '92″ x 92″ x 38″',
    electrical: '240v/60amp',
    waterCapacity: '430 gallons',
    dryWeight: '700 lbs',
    filledWeight: '4289 lbs',
    pumps: '2',
    description: 'Classic design with modern hydrotherapy features. Elite Series includes: Spa Cover, Everlast Shell, Hope Resin Floor, Clear Guard Ozone, Temp Shield, Foam Board, Premium Light Package. Requires upgrade to Spa Touch 4.',
    features: ['Open seating', 'airX Therapy System', 'Everlast Shell', 'Clear Guard Ozone', 'Temp Shield Foam Board', 'Premium LED Light Package', 'Hope Resin Floor'],
    images: {
      primary: 'https://vikingspas.com/wp-content/uploads/2024/06/VS_2025_Tradition2_Opal_Chestnut_Side_dropshadow-768x461.png',
      overhead: 'https://vikingspas.com/wp-content/uploads/2024/07/VS_2025_Elite_Tradition1_White_OH_dropshadow.png'
    },
    shellColors: ['white', 'silver', 'opal'],
    cabinetColors: ['slate', 'chestnut', 'stone', 'carbon'],
    colorVisualizerBase: 'Tradition',
    relatedModel: 'vs-tradition-2'
  },
  {
    id: 'vs-tradition-2',
    name: 'Tradition 2',
    brand: 'Viking Spas',
    series: 'Elite Series',
    modelFamily: 'Tradition',
    persons: 7,
    jets: 62,
    price: '$13,999.99',
    priceValue: 13999.99,
    seatingLayout: 'Open',
    dimensions: '92″ x 92″ x 38″',
    electrical: '240v/60amp',
    waterCapacity: '430 gallons',
    dryWeight: '700 lbs',
    filledWeight: '4289 lbs',
    pumps: '2',
    description: 'Classic design with modern hydrotherapy features - enhanced configuration. Elite Series includes: Spa Cover, Everlast Shell, Hope Resin Floor, Clear Guard Ozone, Temp Shield, Foam Board, Premium Light Package. Requires upgrade to Spa Touch 4.',
    features: ['Open seating', 'airX Therapy System', 'Everlast Shell', 'Clear Guard Ozone', 'Temp Shield Foam Board', 'Premium LED Light Package', 'Hope Resin Floor', 'Enhanced jet configuration'],
    images: {
      primary: 'https://vikingspas.com/wp-content/uploads/2024/06/VS_2025_Tradition2_Opal_Chestnut_Side_dropshadow-768x461.png',
      overhead: 'https://vikingspas.com/wp-content/uploads/2024/07/VS_2025_Elite_Tradition1_White_OH_dropshadow.png'
    },
    shellColors: ['white', 'silver', 'opal'],
    cabinetColors: ['slate', 'chestnut', 'stone', 'carbon'],
    colorVisualizerBase: 'Tradition',
    relatedModel: 'vs-tradition-1'
  },
  {
    id: 'vs-apex-1',
    name: 'Apex 1',
    brand: 'Viking Spas',
    series: 'Elite Series',
    modelFamily: 'Apex',
    persons: 6,
    jets: 55,
    price: '$11,999.99',
    priceValue: 11999.99,
    seatingLayout: 'Open',
    dimensions: '84″ x 84″ x 38″',
    electrical: '240v/60amp',
    waterCapacity: '325 gallons',
    dryWeight: '600 lbs',
    filledWeight: '3312 lbs',
    pumps: '1',
    description: 'Peak performance in a mid-size package. Elite Series includes: Spa Cover, Everlast Shell, Hope Resin Floor, Clear Guard Ozone, Temp Shield, Foam Board, Premium Light Package. Requires upgrade to Spa Touch 4.',
    features: ['6-person seating', 'airX Therapy System', 'Everlast Shell', 'Clear Guard Ozone', 'Temp Shield Foam Board', 'Premium LED Light Package', 'Hope Resin Floor'],
    images: {
      primary: 'https://vikingspas.com/wp-content/uploads/2024/06/VS_2025_Apex1_Opal_Stone_Side-768x512.png',
      overhead: 'https://vikingspas.com/wp-content/uploads/2024/06/VS_2025_Apex2_White_OH_121324.png'
    },
    shellColors: ['white', 'silver', 'opal'],
    cabinetColors: ['slate', 'chestnut', 'stone', 'carbon'],
    colorVisualizerBase: 'Apex',
    relatedModel: 'vs-apex-2'
  },
  {
    id: 'vs-apex-2',
    name: 'Apex 2',
    brand: 'Viking Spas',
    series: 'Elite Series',
    modelFamily: 'Apex',
    persons: 6,
    jets: 60,
    price: '$11,999.99',
    priceValue: 11999.99,
    seatingLayout: 'Open',
    dimensions: '84″ x 84″ x 38″',
    electrical: '240v/60amp',
    waterCapacity: '325 gallons',
    dryWeight: '600 lbs',
    filledWeight: '3312 lbs',
    pumps: '2',
    description: 'Peak performance in a mid-size package - enhanced configuration. Elite Series includes: Spa Cover, Everlast Shell, Hope Resin Floor, Clear Guard Ozone, Temp Shield, Foam Board, Premium Light Package. Requires upgrade to Spa Touch 4.',
    features: ['6-person seating', 'airX Therapy System', 'Everlast Shell', 'Clear Guard Ozone', 'Temp Shield Foam Board', 'Premium LED Light Package', 'Hope Resin Floor', 'Enhanced jet configuration'],
    images: {
      primary: 'https://vikingspas.com/wp-content/uploads/2024/06/VS_2025_Apex1_Opal_Stone_Side-768x512.png',
      overhead: 'https://vikingspas.com/wp-content/uploads/2024/06/VS_2025_Apex2_White_OH_121324.png'
    },
    shellColors: ['white', 'silver', 'opal'],
    cabinetColors: ['slate', 'chestnut', 'stone', 'carbon'],
    colorVisualizerBase: 'Apex',
    relatedModel: 'vs-apex-1'
  },
  {
    id: 'vs-ascent-1',
    name: 'Ascent 1',
    brand: 'Viking Spas',
    series: 'Elite Series',
    modelFamily: 'Ascent',
    persons: 5,
    jets: 48,
    price: '$11,999.99',
    priceValue: 11999.99,
    seatingLayout: 'Open',
    dimensions: '78″ x 78″ x 36″',
    electrical: '240v/60amp',
    waterCapacity: '345 gallons',
    dryWeight: '600 lbs',
    filledWeight: '3479 lbs',
    pumps: '1',
    description: 'Compact Elite Series with powerful performance. Elite Series includes: Spa Cover, Everlast Shell, Hope Resin Floor, Clear Guard Ozone, Temp Shield, Foam Board, Premium Light Package. Requires upgrade to Spa Touch 4.',
    features: ['5-person capacity', 'airX Therapy System', 'Everlast Shell', 'Clear Guard Ozone', 'Temp Shield Foam Board', 'Premium LED Light Package', 'Hope Resin Floor'],
    images: {
      primary: 'https://vikingspas.com/wp-content/uploads/2025/01/VS_2025_Ascent_II_White_Chestnut_Side_Dropshadow_1440PX-768x485.png',
      overhead: 'https://vikingspas.com/wp-content/uploads/2025/01/VS_2025_Ascent_II_White_OH_Dropshadow_1440px.png'
    },
    shellColors: ['white', 'silver', 'opal'],
    cabinetColors: ['slate', 'chestnut', 'stone', 'carbon'],
    colorVisualizerBase: 'Ascent',
    relatedModel: 'vs-ascent-2'
  },
  {
    id: 'vs-ascent-2',
    name: 'Ascent 2',
    brand: 'Viking Spas',
    series: 'Elite Series',
    modelFamily: 'Ascent',
    persons: 5,
    jets: 52,
    price: '$12,999.99',
    priceValue: 12999.99,
    seatingLayout: 'Open',
    dimensions: '78″ x 78″ x 36″',
    electrical: '240v/60amp',
    waterCapacity: '345 gallons',
    dryWeight: '600 lbs',
    filledWeight: '3479 lbs',
    pumps: '2',
    description: 'Compact Elite Series with powerful performance - enhanced configuration. Elite Series includes: Spa Cover, Everlast Shell, Hope Resin Floor, Clear Guard Ozone, Temp Shield, Foam Board, Premium Light Package. Requires upgrade to Spa Touch 4.',
    features: ['5-person capacity', 'airX Therapy System', 'Everlast Shell', 'Clear Guard Ozone', 'Temp Shield Foam Board', 'Premium LED Light Package', 'Hope Resin Floor', 'Enhanced jet configuration'],
    images: {
      primary: 'https://vikingspas.com/wp-content/uploads/2025/01/VS_2025_Ascent_II_White_Chestnut_Side_Dropshadow_1440PX-768x485.png',
      overhead: 'https://vikingspas.com/wp-content/uploads/2025/01/VS_2025_Ascent_II_White_OH_Dropshadow_1440px.png'
    },
    shellColors: ['white', 'silver', 'opal'],
    cabinetColors: ['slate', 'chestnut', 'stone', 'carbon'],
    colorVisualizerBase: 'Ascent',
    relatedModel: 'vs-ascent-1'
  },
  {
    id: 'vs-royale-x',
    name: 'Royal X',
    brand: 'Viking Spas',
    series: 'Elite Series',
    modelFamily: 'Royal X',
    persons: 7,
    jets: 62,
    price: '$10,999.99',
    priceValue: 10999.99,
    seatingLayout: 'Lounge',
    dimensions: '92″ x 84″ x 38″',
    electrical: '240v/60amp',
    waterCapacity: '370 gallons',
    dryWeight: '625 lbs',
    filledWeight: '3713 lbs',
    pumps: '2',
    description: 'Premium lounger with our most advanced features. Elite Series includes: Spa Cover, Everlast Shell, Hope Resin Floor, Clear Guard Ozone, Temp Shield, Foam Board, Premium Light Package. Requires upgrade to Spa Touch 4.',
    features: ['Full-body lounger', 'airX Therapy System', 'Everlast Shell', 'Clear Guard Ozone', 'Temp Shield Foam Board', 'Premium LED Light Package', 'Hope Resin Floor'],
    images: {
      primary: 'https://vikingspas.com/wp-content/uploads/2025/12/VS_Elite_RoyalX_White_Slate_Carbon-768x395.png',
      overhead: 'https://vikingspas.com/wp-content/uploads/2025/12/VS_Elite_RoyalX_White_Overhead-scaled.png'
    },
    shellColors: ['white', 'silver', 'opal'],
    cabinetColors: ['slate', 'chestnut', 'stone', 'carbon'],
    colorVisualizerBase: 'Elite_RoyaleX',
    relatedModel: null
  },
  {
    id: 'vs-regal-x',
    name: 'Regal X',
    brand: 'Viking Spas',
    series: 'Elite Series',
    modelFamily: 'Regal X',
    persons: 6,
    jets: 58,
    price: '$10,999.99',
    priceValue: 10999.99,
    seatingLayout: 'Open',
    dimensions: '84″ x 84″ x 38″',
    electrical: '240v/60amp',
    waterCapacity: '325 gallons',
    dryWeight: '600 lbs',
    filledWeight: '3312 lbs',
    pumps: '2',
    description: 'Premium open-seating spa with advanced therapy. Elite Series includes: Spa Cover, Everlast Shell, Hope Resin Floor, Clear Guard Ozone, Temp Shield, Foam Board, Premium Light Package. Requires upgrade to Spa Touch 4.',
    features: ['Open seating', 'airX Therapy System', 'Everlast Shell', 'Clear Guard Ozone', 'Temp Shield Foam Board', 'Premium LED Light Package', 'Hope Resin Floor'],
    images: {
      primary: 'https://vikingspas.com/wp-content/uploads/2025/12/VS_Elite_RegalX_Opal_Stone-1-768x439.png',
      overhead: 'https://vikingspas.com/wp-content/uploads/2025/12/VS_Elite_RegalX_Opal_Overhead.png'
    },
    shellColors: ['white', 'silver', 'opal'],
    cabinetColors: ['slate', 'chestnut', 'stone', 'carbon'],
    colorVisualizerBase: 'Elite_RegalX',
    relatedModel: null
  },
  {
    id: 'vs-elevate-x',
    name: 'Elevate X',
    brand: 'Viking Spas',
    series: 'Elite Series',
    modelFamily: 'Elevate X',
    persons: 5,
    jets: 52,
    price: '$10,999.99',
    priceValue: 10999.99,
    seatingLayout: 'Open',
    dimensions: '78″ x 78″ x 36″',
    electrical: '240v/60amp',
    waterCapacity: '345 gallons',
    dryWeight: '600 lbs',
    filledWeight: '3479 lbs',
    pumps: '2',
    description: 'Compact Elite with maximum features. Elite Series includes: Spa Cover, Everlast Shell, Hope Resin Floor, Clear Guard Ozone, Temp Shield, Foam Board, Premium Light Package. Requires upgrade to Spa Touch 4.',
    features: ['5-person capacity', 'airX Therapy System', 'Everlast Shell', 'Clear Guard Ozone', 'Temp Shield Foam Board', 'Premium LED Light Package', 'Hope Resin Floor'],
    images: {
      primary: 'https://vikingspas.com/wp-content/uploads/2025/12/VS_Elite_ElevateX_White_Slate-768x561.png',
      overhead: 'https://vikingspas.com/wp-content/uploads/2025/12/VS_Elite_ElevateX_White_OH-scaled.png'
    },
    shellColors: ['white', 'silver', 'opal'],
    cabinetColors: ['slate', 'chestnut', 'stone', 'carbon'],
    colorVisualizerBase: 'Elite_ElevateX',
    relatedModel: null
  },
  // HEIRLOOM SERIES - Includes: Spa Cover, Everlast Shell, Hope Resin Floor, Clear CD Ozone, Tempshield, Foam Board, LED Light Package (Requires Upgrade to Spa Touch 4)
  {
    id: 'vs-regal-heirloom',
    name: 'Regal',
    brand: 'Viking Spas',
    series: 'Heirloom Series',
    modelFamily: 'Regal',
    persons: 6,
    jets: 45,
    price: '$10,999.99',
    priceValue: 10999.99,
    seatingLayout: 'Open',
    dimensions: '84″ x 84″ x 34″',
    electrical: '240v/60amp',
    waterCapacity: '290 gallons',
    dryWeight: '495 lbs',
    filledWeight: '2915 lbs',
    pumps: '1',
    description: 'Premium features at an excellent value. Heirloom Series includes: Spa Cover, Everlast Shell, Hope Resin Floor, Clear CD Ozone, Tempshield, Foam Board, LED Light Package. Requires upgrade to Spa Touch 4.',
    features: ['6-person seating', 'Everlast Shell', 'Clear CD Ozone', 'Tempshield Foam Board', 'LED Light Package', 'Hope Resin Floor'],
    images: {
      primary: 'https://vikingspas.com/wp-content/uploads/2024/07/VS_2025_RegalETS_Silver_black_side_dropshadow-768x500.png',
      overhead: 'https://vikingspas.com/wp-content/uploads/2024/12/VS_2025_Regal_White-OH_dropshadow.png'
    },
    shellColors: ['white', 'silver', 'opal'],
    cabinetColors: ['ashGray', 'walnut', 'barnwood', 'black'],
    colorVisualizerBase: 'Regal',
    relatedModel: null
  },
  {
    id: 'vs-royale-heirloom',
    name: 'Royale',
    brand: 'Viking Spas',
    series: 'Heirloom Series',
    modelFamily: 'Royale',
    persons: 7,
    jets: 50,
    price: '$10,999.99',
    priceValue: 10999.99,
    seatingLayout: 'Lounge',
    dimensions: '92″ x 84″ x 34″',
    electrical: '240v/60amp',
    waterCapacity: '270 gallons',
    dryWeight: '495 lbs',
    filledWeight: '2748 lbs',
    pumps: '1',
    description: 'Spacious lounger with Heirloom quality. Heirloom Series includes: Spa Cover, Everlast Shell, Hope Resin Floor, Clear CD Ozone, Tempshield, Foam Board, LED Light Package. Requires upgrade to Spa Touch 4.',
    features: ['7-person capacity', 'Lounger seating', 'Everlast Shell', 'Clear CD Ozone', 'Tempshield Foam Board', 'LED Light Package', 'Hope Resin Floor'],
    images: {
      primary: 'https://vikingspas.com/wp-content/uploads/2024/07/VS_2025_RoyaleETS_Opal_Walnut_side_dropshadow-768x490.png',
      overhead: 'https://vikingspas.com/wp-content/uploads/2024/07/VS_2025_Royale_Silver-OH_dropshadow-2.png'
    },
    shellColors: ['white', 'silver', 'opal'],
    cabinetColors: ['ashGray', 'walnut', 'barnwood', 'black'],
    colorVisualizerBase: 'Royale',
    relatedModel: null
  },
  {
    id: 'vs-elevate',
    name: 'Elevate',
    brand: 'Viking Spas',
    series: 'Heirloom Series',
    modelFamily: 'Elevate',
    persons: 5,
    jets: 38,
    price: '$9,999.99',
    priceValue: 9999.99,
    seatingLayout: 'Open',
    dimensions: '78″ x 78″ x 32″',
    electrical: '240v/60amp',
    waterCapacity: '280 gallons',
    dryWeight: '480 lbs',
    filledWeight: '2818 lbs',
    pumps: '1',
    description: 'Compact Heirloom with excellent value. Heirloom Series includes: Spa Cover, Everlast Shell, Hope Resin Floor, Clear CD Ozone, Tempshield, Foam Board, LED Light Package. Requires upgrade to Spa Touch 4.',
    features: ['5-person capacity', 'Everlast Shell', 'Clear CD Ozone', 'Tempshield Foam Board', 'LED Light Package', 'Hope Resin Floor'],
    images: {
      primary: 'https://vikingspas.com/wp-content/uploads/2025/12/VS_Heirloom_Elevate_White_AshGray-768x489.png',
      overhead: 'https://vikingspas.com/wp-content/uploads/2025/12/VS_Heirloom_Elevate_White_OH-scaled.png'
    },
    shellColors: ['white', 'silver', 'opal'],
    cabinetColors: ['ashGray', 'walnut', 'barnwood', 'black'],
    colorVisualizerBase: 'Heirloom_Elevate',
    relatedModel: null
  },
  {
    id: 'vs-viking-heirloom',
    name: 'Viking',
    brand: 'Viking Spas',
    series: 'Heirloom Series',
    modelFamily: 'Viking',
    persons: 4,
    jets: 32,
    price: '$8,999.99',
    priceValue: 8999.99,
    seatingLayout: 'Open',
    dimensions: '72″ x 72″ x 33″',
    electrical: '240v/60amp',
    waterCapacity: '250 gallons',
    dryWeight: '330 lbs',
    filledWeight: '2416 lbs',
    pumps: '1',
    description: 'Classic Viking quality in a cozy package. Heirloom Series includes: Spa Cover, Everlast Shell, Hope Resin Floor, Clear CD Ozone, Tempshield, Foam Board, LED Light Package. Requires upgrade to Spa Touch 4.',
    features: ['Compact 4-person', 'Everlast Shell', 'Clear CD Ozone', 'Tempshield Foam Board', 'LED Light Package', 'Hope Resin Floor'],
    images: {
      primary: 'https://vikingspas.com/wp-content/uploads/2024/07/Viking-3_Coastal-Gray-SIDE_dropshadow-768x636.png',
      overhead: 'https://vikingspas.com/wp-content/uploads/2024/07/Viking-3_White-OH_dropshadow.png'
    },
    shellColors: ['white', 'silver', 'opal'],
    cabinetColors: ['ashGray', 'walnut', 'barnwood', 'black'],
    colorVisualizerBase: 'Viking-3',
    relatedModel: null
  },
  // ELEMENT SERIES (Plug & Play) - Includes: Spa Cover, Everlast Shell, Hope Resin Floor, Tempshield Foam Board, Premium LED Light Package
  {
    id: 'vs-regal-p',
    name: 'Regal P',
    brand: 'Viking Spas',
    series: 'Element Series',
    modelFamily: 'Regal P',
    persons: 6,
    jets: 38,
    price: '$9,999.99',
    priceValue: 9999.99,
    seatingLayout: 'Open',
    dimensions: '84″ x 84″ x 34″',
    electrical: '120v/15amp',
    waterCapacity: '290 gallons',
    dryWeight: '495 lbs',
    filledWeight: '2915 lbs',
    pumps: '1',
    description: 'Plug-and-play convenience with premium features. Element Series includes: Spa Cover, Everlast Shell, Hope Resin Floor, Tempshield Foam Board, Premium LED Light Package.',
    features: ['Plug-and-play 120v', 'Everlast Shell', 'Hope Resin Floor', 'Tempshield Foam Board', 'Premium LED Light Package'],
    images: {
      primary: 'https://vikingspas.com/wp-content/uploads/2024/12/Regal-P_Walnut-wBlk-SIDE-768x512.png',
      overhead: 'https://vikingspas.com/wp-content/uploads/2024/12/VS_2025_Regal-P_White_OH_dropshadow.png'
    },
    shellColors: ['white', 'silver', 'opal'],
    cabinetColors: ['walnut', 'black', 'barnwood', 'coastalGray'],
    colorVisualizerBase: 'RegalP',
    relatedModel: null
  },
  {
    id: 'vs-royale-p',
    name: 'Royal P',
    brand: 'Viking Spas',
    series: 'Element Series',
    modelFamily: 'Royal P',
    persons: 7,
    jets: 42,
    price: '$9,999.99',
    priceValue: 9999.99,
    seatingLayout: 'Lounge',
    dimensions: '92″ x 84″ x 34″',
    electrical: '120v/15amp',
    waterCapacity: '270 gallons',
    dryWeight: '495 lbs',
    filledWeight: '2748 lbs',
    pumps: '1',
    description: 'Large capacity with plug-and-play simplicity. Element Series includes: Spa Cover, Everlast Shell, Hope Resin Floor, Tempshield Foam Board, Premium LED Light Package.',
    features: ['Plug-and-play 120v', 'Lounger seating', 'Everlast Shell', 'Hope Resin Floor', 'Tempshield Foam Board', 'Premium LED Light Package'],
    images: {
      primary: 'https://vikingspas.com/wp-content/uploads/2024/12/VS_2025_Regal-P_Barnwood-wBlk-SIDE_dropshadow-768x585.png',
      overhead: 'https://vikingspas.com/wp-content/uploads/2024/07/VS_2025_Royale-P_White-OH_dropshadow.png'
    },
    shellColors: ['white', 'silver', 'opal'],
    cabinetColors: ['barnwood', 'walnut', 'black', 'coastalGray'],
    colorVisualizerBase: 'RoyaleP',
    relatedModel: null
  },
  {
    id: 'vs-elevate-p',
    name: 'Elevate P',
    brand: 'Viking Spas',
    series: 'Element Series',
    modelFamily: 'Elevate P',
    persons: 5,
    jets: 32,
    price: '$8,999.99',
    priceValue: 8999.99,
    seatingLayout: 'Open',
    dimensions: '78″ x 78″ x 32″',
    electrical: '120v/15amp',
    waterCapacity: '280 gallons',
    dryWeight: '480 lbs',
    filledWeight: '2818 lbs',
    pumps: '1',
    description: 'Entry-level comfort with easy installation. Element Series includes: Spa Cover, Everlast Shell, Hope Resin Floor, Tempshield Foam Board, Premium LED Light Package.',
    features: ['Plug-and-play 120v', 'Compact design', 'Everlast Shell', 'Hope Resin Floor', 'Tempshield Foam Board', 'Premium LED Light Package'],
    images: {
      primary: 'https://vikingspas.com/wp-content/uploads/2025/12/VS_Element_Elevate-P_White_Walnut-768x571.png',
      overhead: 'https://vikingspas.com/wp-content/uploads/2025/12/VS_Element_ElevateP_White_OH-scaled.png'
    },
    shellColors: ['white', 'silver', 'opal'],
    cabinetColors: ['walnut', 'black', 'barnwood', 'coastalGray'],
    relatedModel: null
  },
  {
    id: 'vs-viking-p',
    name: 'Viking P',
    brand: 'Viking Spas',
    series: 'Element Series',
    modelFamily: 'Viking P',
    persons: 4,
    jets: 28,
    price: '$8,999.99',
    priceValue: 8999.99,
    seatingLayout: 'Open',
    dimensions: '72″ x 72″ x 32″',
    electrical: '120v/15amp',
    waterCapacity: '250 gallons',
    dryWeight: '300 lbs',
    filledWeight: '2386 lbs',
    pumps: '1',
    description: 'Compact plug-and-play perfection. Element Series includes: Spa Cover, Everlast Shell, Hope Resin Floor, Tempshield Foam Board, Premium LED Light Package.',
    features: ['Plug-and-play 120v', 'Most affordable', 'Everlast Shell', 'Hope Resin Floor', 'Tempshield Foam Board', 'Premium LED Light Package'],
    images: {
      primary: 'https://vikingspas.com/wp-content/uploads/2024/07/Viking-2P_Walnut-SIDE_-Dropshadow-768x672.png',
      overhead: 'https://vikingspas.com/wp-content/uploads/2024/07/Viking-2P_Opal-OH_dropshadow.png'
    },
    shellColors: ['white', 'silver', 'opal'],
    cabinetColors: ['walnut', 'black', 'barnwood', 'coastalGray'],
    relatedModel: null
  }
];

// ===========================================
// VIKING SPAS EXTRAS/ADD-ONS
// ===========================================
export const VIKING_SPAS_EXTRAS = [
  {
    id: 'vs-extra-clearguard-uv',
    name: 'Clear Guard UV',
    price: '$495.99',
    priceValue: 495.99,
    image: '/images/addons/ozone.jpg',
    description: 'Advanced UV water sanitation system for cleaner, clearer water.'
  },
  {
    id: 'vs-extra-wifi',
    name: 'WiFi Module',
    price: '$399.99',
    priceValue: 399.99,
    image: '/images/addons/in touch wifi.png',
    description: 'Control your spa remotely with the WiFi module and smartphone app.'
  },
  {
    id: 'vs-extra-airx',
    name: 'Air X Therapy',
    price: '$199.99',
    priceValue: 199.99,
    image: '/images/addons/airxtherapy.jpg',
    description: 'Enhanced air therapy system for a more luxurious massage experience.'
  },
  {
    id: 'vs-extra-spatouch4',
    name: 'Spa Touch 4',
    price: '$499.99',
    priceValue: 499.99,
    image: '/images/addons/touchscreen control.png',
    description: 'Upgrade to the Spa Touch 4 touchscreen control panel for easier spa management.'
  },
  {
    id: 'vs-extra-bba-stereo',
    name: 'BBA Stereo with Subwoofer',
    price: '$995.99',
    priceValue: 995.99,
    image: '/images/addons/bluetooth speakers.png',
    description: 'Premium Bluetooth audio system with subwoofer for immersive sound.'
  }
];

// Viking Spas Free Items Note
export const VIKING_SPAS_FREE_ITEMS = {
  note: 'Every hot tub price includes a Cover, Steps, and Start-Up Chemicals — a $1,500 value. A Cover Lifter & Railing is available as an optional add-on: $349.99 installed for both. Shipping is not included and is calculated by your delivery address.',
  items: ['Cover', 'Steps', 'Start-Up Chemicals']
};

// ===========================================
// SWIM SPAS - GRAND RIVER SPAS
// ===========================================
export const GRAND_RIVER_SWIM_SPAS = [
  {
    id: 'gr-ss-valhalla',
    name: 'Valhalla',
    brand: 'Grand River Spas',
    series: 'Swim Spas',
    length: '19 ft',
    persons: 9,
    jets: 47,
    price: '$39,995.00',
    priceValue: 39995,
    dimensions: '19\' x 7\'6" x 52"',
    waterCapacity: '1,870 gallons',
    electrical: '2 x 5.5 kW/220V',
    pumps: 'Spa Zone 2x3.0BHP, Swim Zone 3x4.0BHP',
    filtration: '6 filters, 50 sq ft each',
    description: 'Our largest swim spa with separate spa and swim zones, dual temperature control, and powerful jet system.',
    features: ['Dual Zone Temperature', 'Spa Zone 6 Seats', 'Swim Zone 3 Seats', '47 Jets Total', 'LED Lighting', '6 Filtration Filters'],
    images: {
      primary: 'https://b4087952.smushcdn.com/4087952/wp-content/uploads/2024/06/Valhalla-Overhead-square-1.jpg?lossy=2&strip=1&webp=1',
      overhead: 'https://b4087952.smushcdn.com/4087952/wp-content/uploads/2024/06/Valhalla-Overhead-square-1.jpg?lossy=2&strip=1&webp=1'
    },
    shellColors: ['sterlingMarble'],
    cabinetColors: ['grayOak']
  },
  {
    id: 'gr-ss-asgard',
    name: 'Asgard',
    brand: 'Grand River Spas',
    series: 'Swim Spas',
    length: '15 ft 9 in',
    persons: 5,
    jets: 42,
    price: '$34,995.00',
    priceValue: 34995,
    dimensions: '15\'9" x 7\'6" x 52"',
    waterCapacity: '1,717 gallons',
    electrical: '220V',
    pumps: '3x4.0BHP + 1x3.0BHP',
    filtration: '4 filters, 50 sq ft each',
    description: 'Mid-size swim spa with powerful swim zone and relaxation seating.',
    features: ['5-Person Seating', '42 Jets', '3 River Swim Jets', 'Swim Stabilization Jet', 'LED Color Changing Lights', 'BBA Audio System'],
    images: {
      primary: 'https://b4087952.smushcdn.com/4087952/wp-content/uploads/2024/12/VS_SwimSpa_Asgard_Overhead.png?lossy=2&strip=1&webp=1',
      overhead: 'https://b4087952.smushcdn.com/4087952/wp-content/uploads/2024/12/VS_SwimSpa_Asgard_Overhead.png?lossy=2&strip=1&webp=1'
    },
    shellColors: ['sterlingMarble'],
    cabinetColors: ['grayOak']
  },
  {
    id: 'gr-ss-odin',
    name: 'Odin',
    brand: 'Grand River Spas',
    series: 'Swim Spas',
    length: '14 ft 9 in',
    persons: 6,
    jets: 59,
    price: '$29,995.00',
    priceValue: 29995,
    dimensions: '14\'9" x 7\'6" x 52"',
    waterCapacity: '1,584 gallons',
    electrical: '220V',
    pumps: '3x4.0BHP + 1x3.0BHP',
    filtration: '4 filters, 50 sq ft each',
    description: '15-foot swim spa with 59 jets and 6-person seating for exercise and relaxation.',
    features: ['6-Person Seating', '59 Jets', 'Variable Speed Jets', 'Exercise Zone', 'Relaxation Seating', 'LED Lighting'],
    images: {
      primary: 'https://b4087952.smushcdn.com/4087952/wp-content/uploads/2024/12/VS_SwimSpa_Odin_overhead.png?lossy=2&strip=1&webp=1',
      overhead: 'https://b4087952.smushcdn.com/4087952/wp-content/uploads/2024/12/VS_SwimSpa_Odin_overhead.png?lossy=2&strip=1&webp=1'
    },
    shellColors: ['sterlingMarble'],
    cabinetColors: ['grayOak']
  },
  {
    id: 'gr-ss-thor',
    name: 'Thor',
    brand: 'Grand River Spas',
    series: 'Swim Spas',
    length: '13 ft 2 in',
    persons: 3,
    jets: 21,
    price: '$24,995.00',
    priceValue: 24995,
    dimensions: '13\'2" x 7\'6" x 52"',
    waterCapacity: '1,453 gallons',
    electrical: '220V',
    pumps: '2x4.0BHP + 1x3.0BHP',
    filtration: '4 filters, 50 sq ft each',
    description: 'Compact swim spa with powerful performance for smaller spaces.',
    features: ['3-Person Seating', '21 Jets', 'Space-Efficient', 'Swim Jets', 'Therapy Seats', 'LED Lighting'],
    images: {
      primary: 'https://b4087952.smushcdn.com/4087952/wp-content/uploads/2024/12/VS_SwimSpa_Thor-Overhead.png?lossy=2&strip=1&webp=1',
      overhead: 'https://b4087952.smushcdn.com/4087952/wp-content/uploads/2024/12/VS_SwimSpa_Thor-Overhead.png?lossy=2&strip=1&webp=1'
    },
    shellColors: ['sterlingMarble'],
    cabinetColors: ['grayOak']
  }
];

export const VIKING_SWIM_SPAS = [
  {
    id: 'vs-ss-valhalla',
    name: 'Valhalla',
    brand: 'Viking Spas',
    series: 'Freestyle Swim Spas',
    length: '19 ft',
    persons: 9,
    jets: 47,
    price: '$39,995.00',
    priceValue: 39995,
    dimensions: '19\' x 7\'6" x 52"',
    waterCapacity: '1,870 gallons',
    electrical: '220V',
    pumps: 'Spa 2x3.0BHP, Swim 3x4.0BHP',
    filtration: '6 filters, 50 sq ft each',
    description: 'Our largest swim spa with separate spa and swim zones for dual-zone temperature control.',
    features: ['Dual Zone Temperature', '47 Jets Total', 'Full Hot Tub Section', '3 River Swim Jets', 'LED Lighting'],
    images: {
      primary: 'https://b4087952.smushcdn.com/4087952/wp-content/uploads/2024/06/Valhalla-Overhead-square-1.jpg?lossy=2&strip=1&webp=1',
      overhead: 'https://b4087952.smushcdn.com/4087952/wp-content/uploads/2024/06/Valhalla-Overhead-square-1.jpg?lossy=2&strip=1&webp=1'
    }
  },
  {
    id: 'vs-ss-asgard',
    name: 'Asgard',
    brand: 'Viking Spas',
    series: 'Freestyle Swim Spas',
    length: '15 ft 9 in',
    persons: 5,
    jets: 42,
    price: '$34,995.00',
    priceValue: 34995,
    dimensions: '15\'9" x 7\'6" x 52"',
    waterCapacity: '1,717 gallons',
    electrical: '220V',
    pumps: '3x4.0BHP + 1x3.0BHP',
    filtration: '4 filters, 50 sq ft each',
    description: 'Mid-size swim spa with versatile design for exercise and relaxation.',
    features: ['3 River Swim Jets', 'Swim Stabilization Jet', 'LED Color Changing Lights', 'BBA Audio System'],
    images: {
      primary: 'https://b4087952.smushcdn.com/4087952/wp-content/uploads/2024/12/VS_SwimSpa_Asgard_Overhead.png?lossy=2&strip=1&webp=1',
      overhead: 'https://b4087952.smushcdn.com/4087952/wp-content/uploads/2024/12/VS_SwimSpa_Asgard_Overhead.png?lossy=2&strip=1&webp=1'
    }
  },
  {
    id: 'vs-ss-odin',
    name: 'Odin',
    brand: 'Viking Spas',
    series: 'Freestyle Swim Spas',
    length: '14 ft 9 in',
    persons: 6,
    jets: 59,
    price: '$29,995.00',
    priceValue: 29995,
    dimensions: '14\'9" x 7\'6" x 52"',
    waterCapacity: '1,584 gallons',
    electrical: '220V',
    pumps: '3x4.0BHP + 1x3.0BHP',
    filtration: '4 filters, 50 sq ft each',
    description: 'Swim spa with 59 jets and 6-person seating for exercise and relaxation.',
    features: ['6-Person Seating', '59 Jets', 'Variable Speed Jets', 'Exercise Zone', 'LED Lighting'],
    images: {
      primary: 'https://b4087952.smushcdn.com/4087952/wp-content/uploads/2024/12/VS_SwimSpa_Odin_overhead.png?lossy=2&strip=1&webp=1',
      overhead: 'https://b4087952.smushcdn.com/4087952/wp-content/uploads/2024/12/VS_SwimSpa_Odin_overhead.png?lossy=2&strip=1&webp=1'
    }
  },
  {
    id: 'vs-ss-thor',
    name: 'Thor',
    brand: 'Viking Spas',
    series: 'Freestyle Swim Spas',
    length: '13 ft 2 in',
    persons: 3,
    jets: 21,
    price: '$24,995.00',
    priceValue: 24995,
    dimensions: '13\'2" x 7\'6" x 52"',
    waterCapacity: '1,453 gallons',
    electrical: '220V',
    pumps: '2x4.0BHP + 1x3.0BHP',
    filtration: '4 filters, 50 sq ft each',
    description: 'Compact swim spa with powerful performance for smaller spaces.',
    features: ['Space-Efficient', 'Swim Jets', 'Therapy Seats', 'LED Lighting'],
    images: {
      primary: 'https://b4087952.smushcdn.com/4087952/wp-content/uploads/2024/12/VS_SwimSpa_Thor-Overhead.png?lossy=2&strip=1&webp=1',
      overhead: 'https://b4087952.smushcdn.com/4087952/wp-content/uploads/2024/12/VS_SwimSpa_Thor-Overhead.png?lossy=2&strip=1&webp=1'
    }
  }
];

// ===========================================
// SWIM SPAS - DYNASTY SPAS
// ===========================================
export const DYNASTY_SWIM_SPAS = [
  {
    id: 'ds-ss-family-island-single',
    name: "11' Family Island Oasis SL",
    brand: 'Dynasty Spas',
    series: 'Family Collection',
    length: '11 ft',
    price: '$16,999.99',
    priceValue: 16999.99,
    dimensions: '92" x 132" x 38"',
    waterCapacity: '550 gallons',
    electrical: '220v/60amp',
    pumps: '2 - 7.0bhp',
    filtration: '100 ft²',
    dryWeight: '2127 lbs',
    filledWeight: '6527 lbs',
    description: 'Family-size swim spa with single lounger, K.1000 topside control, and LED lighting throughout. Note: Swim spas come in Sterling Marble only. Installation pricing depends on crane placement - this does not include install.',
    features: ['K.1000 Topside Control', 'Single Lounger', 'LED Top Rail Lighting', 'LED Illuminated Diverters', 'LED Illuminated Waterfalls', 'LED Underwater Light', 'LED Corner Skirt Lighting', 'Padded Headrests'],
    images: {
      primary: 'https://static.wixstatic.com/media/5c7c78_928b791fb72d414cba37d3699a061c27~mv2.webp'
    },
    shellColors: ['sterlingMarble'],
    cabinetColors: ['blackConfer', 'grayConfer', 'ashElite', 'coastalGrayElite']
  },
  {
    id: 'ds-ss-family-island-dual',
    name: "11' Family Island Oasis DL",
    brand: 'Dynasty Spas',
    series: 'Family Collection',
    length: '11 ft',
    price: '$16,999.99',
    priceValue: 16999.99,
    dimensions: '92" x 132" x 38"',
    waterCapacity: '550 gallons',
    electrical: '220v/60amp',
    pumps: '2 - 7.0bhp',
    filtration: '100 ft²',
    dryWeight: '2127 lbs',
    filledWeight: '6527 lbs',
    description: 'Family-size swim spa with dual loungers for maximum comfort and exercise. Note: Swim spas come in Sterling Marble only. Installation pricing depends on crane placement - this does not include install.',
    features: ['K.1000 Topside Control', 'Dual Loungers', 'LED Top Rail Lighting', 'LED Illuminated Diverters', 'LED Illuminated Waterfalls', 'LED Underwater Light', 'LED Corner Skirt Lighting', 'Padded Headrests'],
    images: {
      primary: 'https://static.wixstatic.com/media/5c7c78_928b791fb72d414cba37d3699a061c27~mv2.webp'
    },
    shellColors: ['sterlingMarble'],
    cabinetColors: ['blackConfer', 'grayConfer', 'ashElite', 'coastalGrayElite']
  },
  {
    id: 'ds-ss-aquex-party',
    name: "13' Aquex Party",
    brand: 'Dynasty Spas',
    series: 'Aquex Collection',
    length: '13 ft',
    price: '$24,995.99',
    priceValue: 24995.99,
    dimensions: '92" x 160" x 51"',
    waterCapacity: '1,100 gallons',
    electrical: '220v/60amp',
    pumps: '2 - 4.0bhp',
    filtration: '100 ft²',
    dryWeight: '2200 lbs',
    filledWeight: '11000 lbs',
    description: 'Party-ready 13-foot swim spa with bench seating, K.1000 digital controls, and LED illuminated fountain jets. Note: Swim spas come in Sterling Marble only. Installation pricing depends on crane placement - this does not include install.',
    features: ['K.1000 Digital Topside Control', 'LED Top Rail Lighting', 'LED Illuminated Diverters', 'LED Illuminated Water Fountains', 'LED Underwater Light', 'LED Corner Skirt Lighting', 'Padded Headrests', 'Stainless Steel Grab Bar'],
    images: {
      primary: 'https://static.wixstatic.com/media/5c7c78_928b791fb72d414cba37d3699a061c27~mv2.webp'
    },
    shellColors: ['sterlingMarble'],
    cabinetColors: ['blackConfer', 'grayConfer', 'ashElite', 'coastalGrayElite']
  },
  {
    id: 'ds-ss-aquex-pro',
    name: "13' Aquex Pro",
    brand: 'Dynasty Spas',
    series: 'Aquex Collection',
    length: '13 ft',
    price: '$23,995.99',
    priceValue: 23995.99,
    dimensions: '92" x 160" x 55"',
    waterCapacity: '1,530 gallons',
    electrical: '220v/60amp',
    pumps: '2 - 5.0bhp + 1 - 7.0bhp',
    filtration: '100 ft²',
    dryWeight: '2100 lbs',
    filledWeight: '14500 lbs',
    description: 'Professional 13-foot swim spa with exercise equipment and new swim current technology. Note: Swim spas come in Sterling Marble only. Installation pricing depends on crane placement - this does not include install.',
    features: ['K.1000 Topside Control', 'LED Top Rail Lighting', 'LED Illuminated Fountains', 'LED Illuminated Diverters', 'New Exercise Equipment', 'Stainless Steel Grab Bars', 'Ozonator System', 'RMAX Insulation'],
    images: {
      primary: 'https://static.wixstatic.com/media/5c7c78_928b791fb72d414cba37d3699a061c27~mv2.webp'
    },
    shellColors: ['sterlingMarble'],
    cabinetColors: ['blackConfer', 'grayConfer', 'ashElite', 'coastalGrayElite']
  },
  {
    id: 'ds-ss-aquex-pro-plus',
    name: "13' Aquex Pro Plus",
    brand: 'Dynasty Spas',
    series: 'Aquex Collection',
    length: '13 ft',
    price: '$27,995.99',
    priceValue: 27995.99,
    dimensions: '92" x 160" x 55"',
    waterCapacity: '1,530 gallons',
    electrical: '220v/60amp',
    pumps: '3 - 5.0bhp + 1 - 7.0bhp',
    filtration: '100 ft²',
    dryWeight: '2100 lbs',
    filledWeight: '14500 lbs',
    description: 'Premium 13-foot swim spa with in.Mix illuminated jets, in.Stream audio, and swim coach workout system. Note: Swim spas come in Sterling Marble only. Installation pricing depends on crane placement - this does not include install.',
    features: ['K.1000 Topside Control', 'in.Mix Illuminated Jet System', 'in.Stream Audio System', 'Swim Coach Multi-Programmable Workout', 'LED Illuminated Jets', 'LED Illuminated Waterfalls', 'New Exercise Equipment', 'Stainless Steel Grab Bars'],
    images: {
      primary: 'https://static.wixstatic.com/media/5c7c78_928b791fb72d414cba37d3699a061c27~mv2.webp'
    },
    shellColors: ['sterlingMarble'],
    cabinetColors: ['blackConfer', 'grayConfer', 'ashElite', 'coastalGrayElite']
  },
  {
    id: 'ds-ss-aquex-trainer',
    name: "16' Aquex Trainer",
    brand: 'Dynasty Spas',
    series: 'Aquex Collection',
    length: '16 ft',
    price: '$33,995.99',
    priceValue: 33995.99,
    dimensions: '92" x 192" x 60"',
    waterCapacity: '1,850 gallons',
    electrical: '220v/60amp',
    pumps: '3 - 5.0bhp + 1 - 7.0bhp',
    filtration: '100 ft²',
    dryWeight: '2700 lbs',
    filledWeight: '17500 lbs',
    description: '16-foot trainer swim spa with swim coach multi-programmable workout, in.Mix lighting, and in.Stream audio. Note: Swim spas come in Sterling Marble only. Installation pricing depends on crane placement - this does not include install.',
    features: ['K.1000 Topside Control', 'in.Mix Illuminated Jet System', 'in.Stream Audio System', 'Swim Coach Multi-Programmable Workout', 'Exercise/Rowing & Swim Tether', 'LED Illuminated Fountains', 'LED Corner Lighting'],
    images: {
      primary: 'https://static.wixstatic.com/media/5c7c78_928b791fb72d414cba37d3699a061c27~mv2.webp'
    },
    shellColors: ['sterlingMarble'],
    cabinetColors: ['blackConfer', 'grayConfer']
  },
  {
    id: 'ds-ss-aquex-pro-17',
    name: "17' Aquex Pro",
    brand: 'Dynasty Spas',
    series: 'Aquex Collection',
    length: '17 ft',
    price: '$34,995.99',
    priceValue: 34995.99,
    dimensions: '92" x 204" x 60"',
    waterCapacity: '2,100 gallons',
    electrical: '220v/60amp',
    pumps: '3 - 5.0bhp + 1 - 7.0bhp',
    filtration: '100 ft²',
    dryWeight: '2800 lbs',
    filledWeight: '19600 lbs',
    description: '17-foot professional swim spa with dual zone capability, swim coach, and premium in.Mix/in.Stream systems. Note: Swim spas come in Sterling Marble only. Installation pricing depends on crane placement - this does not include install.',
    features: ['K.1000 Topside Control', 'in.Mix Illuminated Jet System', 'in.Stream Audio System', 'Swim Coach Multi-Programmable Workout', 'Exercise/Rowing & Swim Tether', 'LED Illuminated Jets', 'LED Corner Lighting', 'Stainless Steel Grab Bars'],
    images: {
      primary: 'https://static.wixstatic.com/media/5c7c78_928b791fb72d414cba37d3699a061c27~mv2.webp'
    },
    shellColors: ['sterlingMarble'],
    cabinetColors: ['blackConfer', 'grayConfer', 'ashElite', 'coastalGrayElite']
  },
  {
    id: 'ds-ss-aquex-dual-pro',
    name: "19' Aquex Dual Pro",
    brand: 'Dynasty Spas',
    series: 'Aquex Collection',
    length: '19 ft',
    price: '$38,995.99',
    priceValue: 38995.99,
    dimensions: '92" x 228" x 60"',
    waterCapacity: '2,500 gallons',
    electrical: '220v/60amp',
    pumps: '4 - 5.0bhp + 1 - 7.0bhp',
    filtration: '100 ft²',
    dryWeight: '3200 lbs',
    filledWeight: '23200 lbs',
    description: 'Our largest 19-foot dual-zone swim spa with separate hot tub section, swim coach, and premium features. Note: Swim spas come in Sterling Marble only. Installation pricing depends on crane placement - this does not include install.',
    features: ['K.1000 Topside Control', 'in.Mix Illuminated Jet System', 'in.Stream Audio System', 'Swim Coach Multi-Programmable Workout', 'Dual Temperature Zones', 'Exercise/Rowing & Swim Tether', 'LED Corner Lighting', 'Bench Seating in Hot Tub'],
    images: {
      primary: 'https://static.wixstatic.com/media/5c7c78_928b791fb72d414cba37d3699a061c27~mv2.webp'
    },
    shellColors: ['sterlingMarble'],
    cabinetColors: ['blackConfer', 'grayConfer', 'ashElite', 'coastalGrayElite']
  }
];

// Combined Swim Spas (for backward compatibility) - Viking removed
export const SWIM_SPAS = [...GRAND_RIVER_SWIM_SPAS, ...VIKING_SWIM_SPAS];

// Saunas and Cold Plunges
// White Glove Installation available for all saunas: $1,500.00
export const SAUNA_INSTALLATION_OPTION = {
  id: 'sauna-white-glove',
  name: 'White Glove Installation',
  price: '$1,500.00',
  priceValue: 1500,
  description: 'Professional white glove installation service. Our team handles delivery, setup, and ensures your sauna is ready to use.'
};

export const SAUNAS = [
  {"id": "sauna-health-mate-serenity-2", "name": "Serenity 2 Smart Infrared Sauna", "brand": "Health Mate", "series": "Serenity Series – Smart Infrared", "category": "infrared", "price": "Call for Price", "persons": 2, "dimensions": "48.11\" W x 40.47\" D x 75.67\" H (exterior) • Interior 45\" W x 35.75\" D x 69.50\" H", "electrical": "120V / 1630W / 15 amps (NEMA 5-15P plug-in)", "heater": "Tecoloy® medical-grade full-spectrum (near, mid & far infrared)", "wood": "100% Mahogany", "shippingNote": "Free shipping not included — White Glove Installation available. Contact us for shipping & installation pricing.", "description": "Luxury 1–2 person smart infrared sauna with full-spectrum Tecoloy® heaters, app control, and 9-color chromotherapy in a compact, elegant mahogany cabin.", "longDescription": "The Serenity 2 Smart Infrared Sauna by Health Mate delivers advanced full-spectrum infrared therapy in a compact, premium footprint. Tecoloy® medical-grade heaters provide 360-degree body coverage with near-, mid-, and far-infrared wavelengths, while a high-output 96-diode LED panel offers customizable 9-color near-infrared chromotherapy. Smart Sauna Technology lets you preheat and control your session from the app, and a built-in high-performance Bluetooth audio system pairs effortlessly with your smartphone. Crafted from 100% mahogany with see-through glass, the Serenity 2 blends modern elegance with solid construction and exceptional heat retention.", "features": ["Tecoloy® medical-grade heaters — near-, mid-, and far-infrared for 360° body coverage", "Rigorously tested heaters, electronics, and controllers for safe electromagnetic frequency levels", "High-output 96-diode LED panel — 9-color customizable near-infrared chromotherapy", "Ergonomic bench crafted for a warm, heated-seat feel", "Smart Sauna Technology — schedule and control your sauna from the app", "Professional-grade controller with dual (interior & exterior) touch controls", "Built-in high-performance Bluetooth audio system", "Sleek 100% mahogany exterior with see-through glass", "Capacity: 1–2 people"], "warranty": "Lifetime warranty on Tecoloy® heaters; 5-year warranty on power supply, controller, and wood.", "images": {"primary": "/images/saunas/serenity-2/serenity-2-9.jpg", "gallery": ["/images/saunas/serenity-2/serenity-2-9.jpg", "/images/saunas/serenity-2/serenity-2-3.jpg", "/images/saunas/serenity-2/serenity-2-5.jpg", "/images/saunas/serenity-2/serenity-2-1.jpg", "/images/saunas/serenity-2/serenity-2-12.jpg", "/images/saunas/serenity-2/serenity-2-14.jpg", "/images/saunas/serenity-2/serenity-2-10.jpg", "/images/saunas/serenity-2/serenity-2-7.jpg", "/images/saunas/serenity-2/serenity-2-2.jpg", "/images/saunas/serenity-2/serenity-2-16.jpg"], "video": "https://customer-assets-7cd3h4nn.emergentagent.net/job_53b34be4-de6e-46d5-810d-f0cf0ff32b5b/artifacts/26io87hi_Serenity%20Video.mp4"}, "downloads": [{"label": "Serenity 2 Info Sheet", "file": "/brochures/serenity-2-info-sheet.pdf"}, {"label": "Owner's Manual", "file": "/brochures/serenity-manual-magnet.pdf"}, {"label": "Assembly & Wiring Guide", "file": "/brochures/serenity-assembly-wiring-guide.pdf"}], "specSheet": "/brochures/serenity-2-info-sheet.pdf"},
  {"id": "sauna-health-mate-serenity-3", "name": "Serenity 3 Smart Infrared Sauna", "brand": "Health Mate", "series": "Serenity Series – Smart Infrared", "category": "infrared", "price": "Call for Price", "persons": 3, "dimensions": "59\" W x 39.5\" D x 75.5\" H (exterior) • Interior 57\" W x 35.75\" D x 69.8\" H", "electrical": "120V / 2170W / 20 amps (NEMA 5-20P plug-in)", "heater": "Tecoloy® medical-grade full-spectrum (near, mid & far infrared)", "wood": "100% Mahogany", "shippingNote": "Free shipping not included — White Glove Installation available. Contact us for shipping & installation pricing.", "description": "Spacious 1–3 person smart infrared sauna with full-spectrum Tecoloy® heaters, app control, and 9-color chromotherapy — the larger sibling of the Serenity 2.", "longDescription": "The Serenity 3 Smart Infrared Sauna by Health Mate offers all the advanced full-spectrum technology of the Serenity line in a roomier 1–3 person cabin. Patented Tecoloy® medical-grade heaters deliver comprehensive near-, mid-, and far-infrared therapy for complete 360-degree body coverage, and a 9-color near-infrared LED chromotherapy panel lets you tailor every session. Smart Sauna Technology and a built-in Bluetooth audio system make it effortless to preheat and personalize your experience, while the 100% mahogany construction with see-through glass brings timeless elegance and superb heat retention.", "features": ["Tecoloy® medical-grade heaters — near-, mid-, and far-infrared for 360° body coverage", "Low-EMF construction — electronics and controllers tested for safe electromagnetic levels", "9-color near-infrared LED chromotherapy panel", "Ergonomic bench with a warm, heated-seat feel", "Smart Sauna Technology — schedule and control your sauna from the app", "Professional-grade controller with dual (interior & exterior) touch controls", "Built-in high-performance Bluetooth audio system", "Sleek 100% mahogany exterior with see-through glass door and windows", "Capacity: 1–3 people"], "warranty": "Lifetime warranty on Tecoloy® heaters; 5-year warranty on power supply, controller, and wood.", "images": {"primary": "/images/saunas/serenity-3/serenity-3-5.jpg", "gallery": ["/images/saunas/serenity-3/serenity-3-5.jpg", "/images/saunas/serenity-3/serenity-3-9.jpg", "/images/saunas/serenity-3/serenity-3-3.jpg", "/images/saunas/serenity-3/serenity-3-11.jpg", "/images/saunas/serenity-3/serenity-3-1.jpg", "/images/saunas/serenity-3/serenity-3-2.jpg", "/images/saunas/serenity-3/serenity-3-6.jpg", "/images/saunas/serenity-3/serenity-3-7.jpg", "/images/saunas/serenity-3/serenity-3-10.jpg", "/images/saunas/serenity-3/serenity-3-4.jpg"], "video": "https://customer-assets-7cd3h4nn.emergentagent.net/job_53b34be4-de6e-46d5-810d-f0cf0ff32b5b/artifacts/26io87hi_Serenity%20Video.mp4"}, "downloads": [{"label": "Serenity 3 Info Sheet", "file": "https://customer-assets-7cd3h4nn.emergentagent.net/job_53b34be4-de6e-46d5-810d-f0cf0ff32b5b/artifacts/1iuqtdav_Serenity%203%20Info%20Sheet.pdf"}, {"label": "Owner's Manual", "file": "/brochures/serenity-manual-magnet.pdf"}, {"label": "Assembly & Wiring Guide", "file": "/brochures/serenity-assembly-wiring-guide.pdf"}], "specSheet": "https://customer-assets-7cd3h4nn.emergentagent.net/job_53b34be4-de6e-46d5-810d-f0cf0ff32b5b/artifacts/1iuqtdav_Serenity%203%20Info%20Sheet.pdf"},
  {"id": "sauna-health-mate-enrich-2", "name": "Enrich II Infrared Sauna", "brand": "Health Mate", "series": "Enrich Series – Full Spectrum", "category": "infrared", "price": "Call for Price", "persons": 2, "heater": "Tecoloy® medical-grade full-spectrum (near, mid & far infrared)", "wood": "Premium wood construction", "shippingNote": "Free shipping not included — White Glove Installation available. Contact us for shipping & installation pricing.", "description": "Two-person full-spectrum infrared sauna combining Tecoloy® heaters with premium comfort and everyday wellness.", "longDescription": "The Enrich II brings Health Mate's signature full-spectrum infrared therapy to a comfortable two-person cabin. Patented Tecoloy® heaters deliver near-, mid-, and far-infrared wavelengths for deep, even warmth, while thoughtful ergonomics and premium wood construction make every session a retreat. Ideal for couples or anyone wanting a little extra room.", "features": ["Full-spectrum Tecoloy® medical-grade heaters", "360° body coverage — near, mid & far infrared", "Low-EMF, safety-tested electronics", "Chromotherapy lighting", "Ergonomic bench seating", "Capacity: 2 people"], "warranty": "Lifetime warranty on Tecoloy® heaters; limited warranty on power supply, controller, and wood.", "images": {"primary": "https://images.unsplash.com/photo-1572168400468-62e1b3209d7d", "gallery": ["https://images.unsplash.com/photo-1572168400468-62e1b3209d7d", "https://images.pexels.com/photos/36077605/pexels-photo-36077605.jpeg"]}},
  {"id": "sauna-health-mate-enrich-3", "name": "Enrich III Infrared Sauna", "brand": "Health Mate", "series": "Enrich Series – Full Spectrum", "category": "infrared", "price": "Call for Price", "persons": 3, "heater": "Tecoloy® medical-grade full-spectrum (near, mid & far infrared)", "wood": "Premium wood construction", "shippingNote": "Free shipping not included — White Glove Installation available. Contact us for shipping & installation pricing.", "description": "Three-person full-spectrum infrared sauna with Tecoloy® heaters and generous space for the whole family.", "longDescription": "The Enrich III expands the Enrich experience to a roomy three-person cabin without compromising on performance. Full-spectrum Tecoloy® heaters surround you with therapeutic near-, mid-, and far-infrared heat, and premium craftsmanship ensures lasting quality and beautiful looks in any space.", "features": ["Full-spectrum Tecoloy® medical-grade heaters", "360° body coverage — near, mid & far infrared", "Low-EMF, safety-tested electronics", "Chromotherapy lighting", "Spacious ergonomic seating", "Capacity: 3 people"], "warranty": "Lifetime warranty on Tecoloy® heaters; limited warranty on power supply, controller, and wood.", "images": {"primary": "https://images.pexels.com/photos/36077602/pexels-photo-36077602.jpeg", "gallery": ["https://images.pexels.com/photos/36077602/pexels-photo-36077602.jpeg", "https://images.unsplash.com/photo-1605614307370-f7a1e58ae751"]}},
  {"id": "sauna-health-mate-elevated-health", "name": "Elevated Health Infrared Sauna", "brand": "Health Mate", "series": "Signature Wellness Series", "category": "infrared", "price": "Call for Price", "persons": 2, "heater": "Tecoloy® medical-grade full-spectrum (near, mid & far infrared)", "wood": "Premium wood construction", "shippingNote": "Free shipping not included — White Glove Installation available. Contact us for shipping & installation pricing.", "description": "A premium wellness-focused infrared sauna engineered for advanced full-spectrum therapy and elevated comfort.", "longDescription": "Elevated Health is designed for those who take their wellness seriously. Full-spectrum Tecoloy® heaters provide comprehensive infrared coverage for detoxification, recovery, and relaxation, all wrapped in a refined, comfortable cabin built to Health Mate's exacting standards.", "features": ["Full-spectrum Tecoloy® medical-grade heaters", "Advanced 360° infrared coverage", "Low-EMF, safety-tested electronics", "Chromotherapy lighting", "Premium ergonomic interior", "Wellness-optimized design"], "warranty": "Lifetime warranty on Tecoloy® heaters; limited warranty on power supply, controller, and wood.", "images": {"primary": "https://images.pexels.com/photos/36077605/pexels-photo-36077605.jpeg", "gallery": ["https://images.pexels.com/photos/36077605/pexels-photo-36077605.jpeg", "https://images.unsplash.com/photo-1572168400468-62e1b3209d7d"]}},
  {"id": "sauna-health-mate-therapy-lounge", "name": "Therapy Lounge Infrared Sauna", "brand": "Health Mate", "series": "Signature Wellness Series", "category": "infrared", "price": "Call for Price", "persons": 1, "heater": "Tecoloy® medical-grade full-spectrum (near, mid & far infrared)", "wood": "Premium wood construction", "shippingNote": "Free shipping not included — White Glove Installation available. Contact us for shipping & installation pricing.", "description": "A recline-and-relax infrared lounge delivering targeted full-spectrum therapy in a single-person format.", "longDescription": "The Therapy Lounge reimagines the infrared session as a true lounge experience. Its layout is built for reclining comfort while Tecoloy® full-spectrum heaters deliver deep, even infrared warmth — perfect for focused recovery and relaxation.", "features": ["Full-spectrum Tecoloy® medical-grade heaters", "Lounge-style reclining comfort", "Low-EMF, safety-tested electronics", "Chromotherapy lighting", "Targeted infrared therapy", "Capacity: 1 person"], "warranty": "Lifetime warranty on Tecoloy® heaters; limited warranty on power supply, controller, and wood.", "images": {"primary": "https://images.unsplash.com/photo-1605614307370-f7a1e58ae751", "gallery": ["https://images.unsplash.com/photo-1605614307370-f7a1e58ae751", "https://images.pexels.com/photos/36077602/pexels-photo-36077602.jpeg"]}},
  {"id": "sauna-health-mate-inspire-2", "name": "Inspire 2 Infrared Sauna", "brand": "Health Mate", "series": "Inspire Series", "category": "infrared", "price": "Call for Price", "persons": 2, "heater": "Tecoloy® medical-grade full-spectrum (near, mid & far infrared)", "wood": "Premium wood construction", "shippingNote": "Free shipping not included — White Glove Installation available. Contact us for shipping & installation pricing.", "description": "Two-person infrared sauna delivering reliable full-spectrum warmth and clean, modern styling.", "longDescription": "The Inspire 2 makes premium infrared wellness accessible in a two-person cabin. Full-spectrum Tecoloy® heaters and Health Mate's trusted craftsmanship bring everyday relaxation and recovery within easy reach.", "features": ["Full-spectrum Tecoloy® medical-grade heaters", "360° body coverage", "Low-EMF, safety-tested electronics", "Chromotherapy lighting", "Modern, clean styling", "Capacity: 2 people"], "warranty": "Lifetime warranty on Tecoloy® heaters; limited warranty on power supply, controller, and wood.", "images": {"primary": "https://images.unsplash.com/photo-1572168400468-62e1b3209d7d", "gallery": ["https://images.unsplash.com/photo-1572168400468-62e1b3209d7d", "https://images.unsplash.com/photo-1605614307370-f7a1e58ae751"]}},
  {"id": "sauna-health-mate-inspire-3", "name": "Inspire 3 Infrared Sauna", "brand": "Health Mate", "series": "Inspire Series", "category": "infrared", "price": "Call for Price", "persons": 3, "heater": "Tecoloy® medical-grade full-spectrum (near, mid & far infrared)", "wood": "Premium wood construction", "shippingNote": "Free shipping not included — White Glove Installation available. Contact us for shipping & installation pricing.", "description": "Three-person infrared sauna offering full-spectrum warmth and comfortable space for family sessions.", "longDescription": "The Inspire 3 offers the same dependable full-spectrum infrared performance as the Inspire 2 in a larger three-person cabin. Tecoloy® heaters provide therapeutic warmth for the whole family, wrapped in Health Mate quality.", "features": ["Full-spectrum Tecoloy® medical-grade heaters", "360° body coverage", "Low-EMF, safety-tested electronics", "Chromotherapy lighting", "Spacious three-person layout", "Capacity: 3 people"], "warranty": "Lifetime warranty on Tecoloy® heaters; limited warranty on power supply, controller, and wood.", "images": {"primary": "https://images.pexels.com/photos/36077602/pexels-photo-36077602.jpeg", "gallery": ["https://images.pexels.com/photos/36077602/pexels-photo-36077602.jpeg", "https://images.pexels.com/photos/36077605/pexels-photo-36077605.jpeg"]}},
  {"id": "sauna-health-mate-red-light-panel", "name": "Red Light Therapy Panel", "brand": "Health Mate", "series": "Light Therapy", "category": "redlight", "price": "Call for Price", "persons": null, "heater": "Tecoloy® medical-grade full-spectrum (near, mid & far infrared)", "wood": "Premium wood construction", "shippingNote": "Free shipping not included — White Glove Installation available. Contact us for shipping & installation pricing.", "description": "Professional-grade red light therapy panel for skin health, recovery, and cellular wellness — pairs beautifully with any Health Mate sauna.", "longDescription": "Add targeted red and near-infrared light therapy to your wellness routine with this professional-grade panel. Red light therapy is used to support skin health, muscle recovery, circulation, and overall cellular wellness. Use it on its own or alongside your Health Mate infrared sauna for a complete light-and-heat therapy experience.", "features": ["High-output red & near-infrared LEDs", "Supports skin health and cellular recovery", "Great for post-workout recovery", "Simple, intuitive controls", "Pairs with any Health Mate sauna"], "warranty": "Lifetime warranty on Tecoloy® heaters; limited warranty on power supply, controller, and wood.", "images": {"primary": "https://images.unsplash.com/photo-1710056618331-6c384da680a9", "gallery": ["https://images.unsplash.com/photo-1710056618331-6c384da680a9", "https://images.pexels.com/photos/7789646/pexels-photo-7789646.jpeg"]}}
];

// ============================================
// SAUNA HEATERS
// ============================================
export const SAUNA_HEATERS = [
  // Finsauna HomeHeat Series with Built-In Controls
  {
    id: 'heater-finsauna-homeheat-4.5kw',
    name: 'Finsauna HomeHeat 4.5kW',
    brand: 'Finsauna',
    series: 'HomeHeat Series',
    category: 'heater',
    price: '$1,198',
    priceValue: 1198,
    wattage: '4.5kW',
    saunaSize: '125-250 cu. ft.',
    electrical: '240v',
    description: 'Wall-mounted sauna heater with built-in control panel and stones included.',
    longDescription: 'The HomeHeat Series combines a beautiful stainless-steel design and performance with an innovative built-in control panel. Triple-wall construction and industrial-strength heating elements provide years of worry-free sauna enjoyment. Comes complete with sauna stones.',
    features: [
      'Built-in on-board controls',
      'Includes sauna stones',
      'Durable stainless-steel components',
      'Triple-wall construction',
      'Industrial-strength heating elements',
      'Open air flow design',
      'Safety-tested to UL and ETL standards',
      'Designed for saunas 125-250 cu. ft.'
    ],
    images: {
      primary: 'https://static.wixstatic.com/media/f50d5c_256aa895ced648929e4d9477a1f1b67a~mv2.jpg/v1/fill/w_320,h_320,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/HomeHeat-914-1.jpg'
    }
  },
  {
    id: 'heater-finsauna-homeheat-6kw',
    name: 'Finsauna HomeHeat 6kW',
    brand: 'Finsauna',
    series: 'HomeHeat Series',
    category: 'heater',
    price: '$1,248',
    priceValue: 1248,
    wattage: '6kW',
    saunaSize: '175-350 cu. ft.',
    electrical: '240v',
    description: 'Wall-mounted sauna heater with built-in control panel and stones included.',
    longDescription: 'The HomeHeat Series combines a beautiful stainless-steel design and performance with an innovative built-in control panel. Triple-wall construction and industrial-strength heating elements provide years of worry-free sauna enjoyment. Comes complete with sauna stones.',
    features: [
      'Built-in on-board controls',
      'Includes sauna stones',
      'Durable stainless-steel components',
      'Triple-wall construction',
      'Industrial-strength heating elements',
      'Open air flow design',
      'Safety-tested to UL and ETL standards',
      'Designed for saunas 175-350 cu. ft.'
    ],
    images: {
      primary: 'https://static.wixstatic.com/media/f50d5c_256aa895ced648929e4d9477a1f1b67a~mv2.jpg/v1/fill/w_320,h_320,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/HomeHeat-914-1.jpg'
    }
  },
  {
    id: 'heater-finsauna-homeheat-8kw',
    name: 'Finsauna HomeHeat 8kW',
    brand: 'Finsauna',
    series: 'HomeHeat Series',
    category: 'heater',
    price: '$1,298',
    priceValue: 1298,
    wattage: '8kW',
    saunaSize: '275-425 cu. ft.',
    electrical: '240v',
    description: 'Wall-mounted sauna heater with built-in control panel and stones included.',
    longDescription: 'The HomeHeat Series combines a beautiful stainless-steel design and performance with an innovative built-in control panel. Triple-wall construction and industrial-strength heating elements provide years of worry-free sauna enjoyment. Comes complete with sauna stones.',
    features: [
      'Built-in on-board controls',
      'Includes sauna stones',
      'Durable stainless-steel components',
      'Triple-wall construction',
      'Industrial-strength heating elements',
      'Open air flow design',
      'Safety-tested to UL and ETL standards',
      'Designed for saunas 275-425 cu. ft.'
    ],
    images: {
      primary: 'https://static.wixstatic.com/media/f50d5c_256aa895ced648929e4d9477a1f1b67a~mv2.jpg/v1/fill/w_320,h_320,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/HomeHeat-914-1.jpg'
    }
  },
  // Finsauna ProHeat Series with SaunaLink WiFi Control
  {
    id: 'heater-finsauna-proheat-4.5kw',
    name: 'Finsauna ProHeat 4.5kW',
    brand: 'Finsauna',
    series: 'ProHeat Series',
    category: 'heater',
    price: '$2,098',
    priceValue: 2098,
    wattage: '4.5kW',
    saunaSize: '125-250 cu. ft.',
    electrical: '240v',
    description: 'Premium wall-mounted sauna heater with SaunaLink WiFi control and stones included.',
    longDescription: 'The ProHeat Series features durable stainless-steel construction, a sleek modern design, and includes the SaunaLink WiFi control for smartphone operation. Comes complete with sauna stones.',
    features: [
      'Includes SaunaLink WiFi control',
      'Smartphone app control',
      'Includes sauna stones',
      'Sleek modern design',
      'Durable stainless-steel construction',
      'Triple-wall construction',
      'Industrial-strength heating elements',
      'Safety-tested to UL and ETL standards'
    ],
    images: {
      primary: 'https://static.wixstatic.com/media/f50d5c_e2aa80df5ed74d01a0f2576e478f3561~mv2.jpg/v1/fill/w_320,h_320,al_c,q_80,enc_avif,quality_auto/ProHeat-Sauna-Heater-1A.jpg'
    }
  },
  {
    id: 'heater-finsauna-proheat-6kw',
    name: 'Finsauna ProHeat 6kW',
    brand: 'Finsauna',
    series: 'ProHeat Series',
    category: 'heater',
    price: '$2,298',
    priceValue: 2298,
    wattage: '6kW',
    saunaSize: '175-350 cu. ft.',
    electrical: '240v',
    description: 'Premium wall-mounted sauna heater with SaunaLink WiFi control and stones included.',
    longDescription: 'The ProHeat Series features durable stainless-steel construction, a sleek modern design, and includes the SaunaLink WiFi control for smartphone operation. Comes complete with sauna stones.',
    features: [
      'Includes SaunaLink WiFi control',
      'Smartphone app control',
      'Includes sauna stones',
      'Sleek modern design',
      'Durable stainless-steel construction',
      'Triple-wall construction',
      'Industrial-strength heating elements',
      'Safety-tested to UL and ETL standards'
    ],
    images: {
      primary: 'https://static.wixstatic.com/media/f50d5c_e2aa80df5ed74d01a0f2576e478f3561~mv2.jpg/v1/fill/w_320,h_320,al_c,q_80,enc_avif,quality_auto/ProHeat-Sauna-Heater-1A.jpg'
    }
  },
  {
    id: 'heater-finsauna-proheat-8kw',
    name: 'Finsauna ProHeat 8kW',
    brand: 'Finsauna',
    series: 'ProHeat Series',
    category: 'heater',
    price: '$2,348',
    priceValue: 2348,
    wattage: '8kW',
    saunaSize: '275-425 cu. ft.',
    electrical: '240v',
    description: 'Premium wall-mounted sauna heater with SaunaLink WiFi control and stones included.',
    longDescription: 'The ProHeat Series features durable stainless-steel construction, a sleek modern design, and includes the SaunaLink WiFi control for smartphone operation. Comes complete with sauna stones.',
    features: [
      'Includes SaunaLink WiFi control',
      'Smartphone app control',
      'Includes sauna stones',
      'Sleek modern design',
      'Durable stainless-steel construction',
      'Triple-wall construction',
      'Industrial-strength heating elements',
      'Safety-tested to UL and ETL standards'
    ],
    images: {
      primary: 'https://static.wixstatic.com/media/f50d5c_e2aa80df5ed74d01a0f2576e478f3561~mv2.jpg/v1/fill/w_320,h_320,al_c,q_80,enc_avif,quality_auto/ProHeat-Sauna-Heater-1A.jpg'
    }
  },
  // Finsauna ClubHeat Series (Commercial)
  {
    id: 'heater-finsauna-clubheat-10kw',
    name: 'Finsauna ClubHeat 10kW',
    brand: 'Finsauna',
    series: 'ClubHeat Series',
    category: 'heater',
    price: '$3,498',
    priceValue: 3498,
    wattage: '10kW',
    saunaSize: '388-530 cu. ft.',
    electrical: '240v',
    description: 'Commercial floor-standing sauna heater with SaunaLink WiFi control and stones included.',
    longDescription: 'The ClubHeat Series is engineered for daily use in health clubs, day spas, and larger home saunas. Heavy-duty construction with industrial-strength heating elements. Includes SaunaLink WiFi control and sauna stones.',
    features: [
      'Commercial-grade construction',
      'Includes SaunaLink WiFi control',
      'Includes sauna stones',
      'Floor-standing design',
      'Heavy-duty stainless steel',
      'Industrial-strength heating elements',
      'Large stone capacity',
      'Designed for daily commercial use',
      'Safety-tested to UL and ETL standards'
    ],
    images: {
      primary: 'https://static.wixstatic.com/media/f50d5c_7a72d74616864ec2a5cb028042312774~mv2.jpg/v1/crop/x_3,y_0,w_396,h_413/fill/w_307,h_320,fp_0.50_0.50,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/Finsauna-ClubHeat-Heater.jpg'
    }
  },
  {
    id: 'heater-finsauna-clubheat-12.5kw',
    name: 'Finsauna ClubHeat 12.5kW',
    brand: 'Finsauna',
    series: 'ClubHeat Series',
    category: 'heater',
    price: '$3,598',
    priceValue: 3598,
    wattage: '12.5kW',
    saunaSize: '530-740 cu. ft.',
    electrical: '240v',
    description: 'Commercial floor-standing sauna heater with SaunaLink WiFi control and stones included.',
    longDescription: 'The ClubHeat Series is engineered for daily use in health clubs, day spas, and larger home saunas. Heavy-duty construction with industrial-strength heating elements. Includes SaunaLink WiFi control and sauna stones.',
    features: [
      'Commercial-grade construction',
      'Includes SaunaLink WiFi control',
      'Includes sauna stones',
      'Floor-standing design',
      'Heavy-duty stainless steel',
      'Industrial-strength heating elements',
      'Large stone capacity',
      'Designed for daily commercial use',
      'Safety-tested to UL and ETL standards'
    ],
    images: {
      primary: 'https://static.wixstatic.com/media/f50d5c_7a72d74616864ec2a5cb028042312774~mv2.jpg/v1/crop/x_3,y_0,w_396,h_413/fill/w_307,h_320,fp_0.50_0.50,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/Finsauna-ClubHeat-Heater.jpg'
    }
  },
  {
    id: 'heater-finsauna-clubheat-15kw',
    name: 'Finsauna ClubHeat 15kW',
    brand: 'Finsauna',
    series: 'ClubHeat Series',
    category: 'heater',
    price: '$3,798',
    priceValue: 3798,
    wattage: '15kW',
    saunaSize: '740-990 cu. ft.',
    electrical: '240v',
    description: 'Commercial floor-standing sauna heater with SaunaLink WiFi control and stones included.',
    longDescription: 'The ClubHeat Series is engineered for daily use in health clubs, day spas, and larger home saunas. Heavy-duty construction with industrial-strength heating elements. Includes SaunaLink WiFi control and sauna stones.',
    features: [
      'Commercial-grade construction',
      'Includes SaunaLink WiFi control',
      'Includes sauna stones',
      'Floor-standing design',
      'Heavy-duty stainless steel',
      'Industrial-strength heating elements',
      'Large stone capacity',
      'Designed for daily commercial use',
      'Safety-tested to UL and ETL standards'
    ],
    images: {
      primary: 'https://static.wixstatic.com/media/f50d5c_7a72d74616864ec2a5cb028042312774~mv2.jpg/v1/crop/x_3,y_0,w_396,h_413/fill/w_307,h_320,fp_0.50_0.50,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/Finsauna-ClubHeat-Heater.jpg'
    }
  },
  // Other brand heaters (keep existing)
  {
    id: 'heater-cozy',
    name: 'Cozy Heater Collection',
    brand: 'Cozy',
    series: 'Electric Heaters',
    category: 'heater',
    price: 'Request Quote',
    priceValue: null,
    description: 'Quality electric sauna heaters designed for reliable performance and efficient heating.',
    features: [
      'Reliable electric heating',
      'Multiple size options',
      'Easy installation',
      'Durable construction'
    ],
    images: {
      primary: 'https://static.wixstatic.com/media/209f9f_82a85dadabc4462083cb76fffba8a7f1~mv2.jpg/v1/fill/w_483,h_612,fp_0.51_0.50,q_80,enc_avif,quality_auto/Heater_Cozy_72dpi.jpg'
    }
  },
  {
    id: 'heater-huum',
    name: 'Huum Heater Collection',
    brand: 'Huum',
    series: 'Designer Heaters',
    category: 'heater',
    price: 'Request Quote',
    priceValue: null,
    description: 'Award-winning Estonian sauna heaters with stunning design and exceptional performance.',
    features: [
      'Award-winning Estonian design',
      'Stunning modern aesthetics',
      'Exceptional heat performance',
      'WiFi control options'
    ],
    images: {
      primary: 'https://static.wixstatic.com/media/209f9f_a24ee283e30c4575a313162e7678884d~mv2.jpg/v1/fill/w_483,h_612,al_c,q_80,enc_avif,quality_auto/Heater_Huum_72dpi.jpg'
    }
  },
  {
    id: 'heater-iki',
    name: 'Iki Heater Collection',
    brand: 'Iki',
    series: 'Premium Heaters',
    category: 'heater',
    price: 'Request Quote',
    priceValue: null,
    description: 'Finnish-made premium sauna heaters known for authentic steam and superior craftsmanship.',
    features: [
      'Finnish craftsmanship',
      'Authentic steam experience',
      'Large stone capacity',
      'Professional-grade quality'
    ],
    images: {
      primary: 'https://static.wixstatic.com/media/209f9f_6ee23b650f644f7db9e8151e6c0956e1~mv2.jpg/v1/fill/w_483,h_612,al_c,q_80,enc_avif,quality_auto/Heater_Iki_72dpi.jpg'
    }
  },
  {
    id: 'heater-narvi',
    name: 'Narvi Heater Collection',
    brand: 'Narvi',
    series: 'Finnish Heaters',
    category: 'heater',
    price: 'Request Quote',
    priceValue: null,
    description: 'Traditional Finnish sauna heaters with over 80 years of expertise in sauna heating.',
    features: [
      'Over 80 years of Finnish expertise',
      'Traditional and modern designs',
      'Superior steam quality',
      'Durable construction'
    ],
    images: {
      primary: 'https://static.wixstatic.com/media/209f9f_68d5250a308b463680d0ac51731a80cc~mv2.jpg/v1/fill/w_483,h_612,al_c,q_80,enc_avif,quality_auto/Heater_Narvi_72dpi.jpg'
    }
  },
  {
    id: 'heater-saunum',
    name: 'Saunum AirPerfect Heater Collection',
    brand: 'Saunum',
    series: 'Climate Control Heaters',
    category: 'heater',
    price: 'Request Quote',
    priceValue: null,
    description: 'Revolutionary sauna heaters with patented climate control technology for the perfect sauna experience.',
    features: [
      'Patented climate control technology',
      'Even heat and humidity distribution',
      'Softer, gentler steam',
      'Improved air quality',
      'WiFi and app control'
    ],
    images: {
      primary: 'https://static.wixstatic.com/media/209f9f_02de3ff99723409fb7b8f1888e8991f9~mv2.jpg/v1/fill/w_483,h_612,fp_0.47_0.50,q_80,enc_avif,quality_auto/Heater_Saunum%20airperfect_72dpi.jpg'
    }
  }
];

const COLD_PLUNGES_ALL = [
  // All-in-One Cold Plunge + Chiller Systems
  {
    id: 'cp-endeavor-xl-chiller',
    name: 'Endeavor XL Plunge + Chiller',
    brand: 'Icebound',
    series: 'Endeavor',
    price: '$1,699.00',
    originalPrice: '$2,399.00',
    priceValue: 1699,
    description: 'The Endeavor XL is our longest tub, built for plungers taller than 6\'3". Classic oval inflatable design with insulated walls, fast cooling to 37°F and heating up to 107°F.',
    longDescription: 'The Endeavor XL is our longest tub, built for plungers taller than 6\'3" (150 gal, fits 2). Features a classic oval inflatable design with insulated walls. Fast cooling to 37°F and heating up to 107°F with WiFi & app-enabled chiller control.',
    features: [
      'Built for taller plungers (6\'3"+)',
      '150 gallon capacity, fits 2 comfortably',
      'Classic oval inflatable design',
      'Insulated walls for efficiency',
      'Fast cooling to 37°F',
      'Heating up to 107°F',
      'WiFi & app-enabled chiller control',
      '1HP Pro Chiller included',
      'Ozone sanitization',
      '12-month warranty'
    ],
    specs: {
      capacity: '150 gallons',
      fits: '2 adults',
      tempRange: '37°F to 107°F',
      power: '1HP Pro Chiller'
    },
    images: {
      primary: 'https://iceboundessentials.com/cdn/shop/files/3-min.png?v=1763395067&width=600',
      overhead: 'https://iceboundessentials.com/cdn/shop/files/3-min.png?v=1763395067&width=600'
    }
  },
  {
    id: 'cp-endurance-limited',
    name: 'Endurance Limited Edition Plunge + Chiller',
    brand: 'Icebound',
    series: 'Endurance',
    price: '$1,999.00',
    originalPrice: '$2,799.00',
    priceValue: 1999,
    description: 'Choose Big Tex burnt orange or Hot Pink limited edition tub. 155-gallon Endurance tub with double-slipper comfort design.',
    longDescription: 'Choose Big Tex burnt orange or Hot Pink limited edition tub. 155-gallon Endurance tub with double-slipper comfort design. Fast heating & cooling: 37–107°F with WiFi & app-enabled chiller control.',
    features: [
      'Limited Edition Big Tex Burnt Orange or Hot Pink',
      '155-gallon capacity',
      'Double-slipper comfort design',
      'Fits 2 comfortably',
      'Fast heating & cooling: 37–107°F',
      'WiFi & app-enabled chiller control',
      'Ultra-durable drop-stitch build',
      'Chiller-ready connections',
      'UV-resistant, indoor & outdoor use',
      '12-month warranty'
    ],
    specs: {
      capacity: '155 gallons',
      fits: '2 adults',
      tempRange: '37°F to 107°F',
      design: 'Double-slipper comfort'
    },
    images: {
      primary: 'https://iceboundessentials.com/cdn/shop/files/orange_endurance_card.jpg?v=1765826555&width=600',
      overhead: 'https://iceboundessentials.com/cdn/shop/files/orange_endurance_card.jpg?v=1765826555&width=600'
    }
  },
  {
    id: 'cp-endurance-classic-chiller',
    name: 'Endurance Classic Plunge + Chiller',
    brand: 'Icebound',
    series: 'Endurance',
    price: '$1,999.00',
    originalPrice: '$2,799.00',
    priceValue: 1999,
    description: 'Choose French Gray or Cool Gray Endurance tub. 155-gallon Endurance tub with double-slipper comfort design.',
    longDescription: 'Choose French Gray or Cool Gray Endurance tub. 155-gallon Endurance tub with double-slipper comfort design. Fast heating & cooling: 37–107°F with WiFi & app-enabled chiller control.',
    features: [
      'French Gray or Cool Gray options',
      '155-gallon capacity',
      'Double-slipper comfort design',
      'Fits 2 comfortably',
      'Fast heating & cooling: 37–107°F',
      'WiFi & app-enabled chiller control',
      'Ultra-durable drop-stitch build',
      'Chiller-ready connections',
      'UV-resistant, indoor & outdoor use',
      '12-month warranty'
    ],
    specs: {
      capacity: '155 gallons',
      fits: '2 adults',
      tempRange: '37°F to 107°F',
      design: 'Double-slipper comfort'
    },
    images: {
      primary: 'https://iceboundessentials.com/cdn/shop/files/french_gray_endurance_card.jpg?v=1765826744&width=600',
      overhead: 'https://iceboundessentials.com/cdn/shop/files/french_gray_endurance_card.jpg?v=1765826744&width=600'
    }
  },
  {
    id: 'cp-resolute-pro',
    name: 'The Resolute Pro',
    brand: 'Icebound',
    series: 'Resolute',
    price: '$6,999.00',
    originalPrice: '$8,999.00',
    priceValue: 6999,
    description: 'Sleek acrylic tub with matte black details. Energy efficient heat pump with fast heating & cooling: 40–104°F. Wi-Fi & app-enabled scheduling.',
    longDescription: 'The Resolute Pro features a sleek acrylic tub with matte black details. Energy efficient heat pump with fast heating & cooling: 40–104°F. Wi-Fi & app-enabled scheduling. Our plug and play system with shipping and white glove delivery included.',
    features: [
      'Sleek acrylic tub construction',
      'Matte black details',
      'Energy efficient heat pump',
      'Fast heating & cooling: 40–104°F',
      'Wi-Fi & app-enabled scheduling',
      'White glove delivery included',
      'Plug and play system',
      'Premium build quality',
      'Commercial-grade durability',
      '12-month warranty'
    ],
    specs: {
      tempRange: '40°F to 104°F',
      material: 'Acrylic',
      style: 'Matte black details',
      delivery: 'White glove included'
    },
    images: {
      primary: 'https://iceboundessentials.com/cdn/shop/files/ResoluteProPremiumColdPlunge.png?v=1744325052&width=600',
      overhead: 'https://iceboundessentials.com/cdn/shop/files/ResoluteProPremiumColdPlunge.png?v=1744325052&width=600'
    }
  },
  // Cold Plunge Tubs (without chiller)
  {
    id: 'cp-endurance-classic',
    name: 'Endurance Classic Plunge',
    brand: 'Icebound',
    series: 'Endurance',
    price: '$1,999.00',
    priceValue: 1999,
    description: 'Our signature, double-slipper Endurance tub in French Gray and Cool Gray. Fits 2 comfortably, 155 gallon capacity.',
    longDescription: 'Our signature, double-slipper Endurance tub in French Gray and Cool Gray. Fits 2 comfortably with 155 gallon capacity. Ultra-durable, drop-stitch build ready for rafting the Colorado. Chiller-ready connections. UV-resistant for indoor & outdoor use.',
    features: [
      'French Gray or Cool Gray finish',
      'Double-slipper comfort design',
      '155 gallon capacity',
      'Fits 2 comfortably',
      'Ultra-durable drop-stitch build',
      'Chiller-ready connections',
      'UV-resistant material',
      'Indoor & outdoor use',
      'Premium portable design',
      '12-month warranty'
    ],
    specs: {
      capacity: '155 gallons',
      fits: '2 adults',
      build: 'Drop-stitch construction',
      use: 'Indoor/Outdoor'
    },
    images: {
      primary: 'https://iceboundessentials.com/cdn/shop/files/french_gray_endurance_card.jpg?v=1765826744&width=600',
      overhead: 'https://iceboundessentials.com/cdn/shop/files/french_gray_endurance_card.jpg?v=1765826744&width=600'
    }
  },
  {
    id: 'cp-endurance-limited-tub',
    name: 'Endurance Limited Edition Plunge',
    brand: 'Icebound',
    series: 'Endurance',
    price: '$799.99',
    originalPrice: '$899.99',
    priceValue: 799.99,
    description: 'Our signature Endurance tub in limited edition Big Tex Burnt Orange or Hot Pink colors. Fits 2 comfortably, 155 gallon capacity.',
    longDescription: 'Our signature Endurance tub in limited edition Big Tex Burnt Orange or Hot Pink colors. Fits 2 comfortably with 155 gallon capacity. Ultra-durable, drop-stitch build. Chiller-ready connections. UV-resistant for indoor & outdoor use.',
    features: [
      'Limited Edition Big Tex Burnt Orange or Hot Pink',
      'Double-slipper comfort design',
      '155 gallon capacity',
      'Fits 2 comfortably',
      'Ultra-durable drop-stitch build',
      'Chiller-ready connections',
      'UV-resistant material',
      'Indoor & outdoor use',
      '1-Year Warranty',
      'Ships Nationwide'
    ],
    specs: {
      capacity: '155 gallons',
      fits: '2 adults',
      build: 'Drop-stitch construction',
      use: 'Indoor/Outdoor'
    },
    images: {
      primary: 'https://iceboundessentials.com/cdn/shop/files/orange_endurance_card.jpg?v=1765826555&width=600',
      overhead: 'https://iceboundessentials.com/cdn/shop/files/orange_endurance_card.jpg?v=1765826555&width=600'
    }
  },
  {
    id: 'cp-endeavor-xl',
    name: 'Endeavor XL Plunge',
    brand: 'Icebound',
    series: 'Endeavor',
    price: '$449.99',
    originalPrice: '$599.99',
    priceValue: 449.99,
    description: 'Classic oval-design, all black for those who prefer a matte finish. Fits 2 comfortably, 150 gallon capacity. Our top seller in the US military community.',
    longDescription: 'Classic oval-design, all black for our New Zealand rugby fans or those who prefer a matte finish. Fits 2 comfortably with 150 gallon capacity. Ultra-durable, drop-stitch build. Our top seller in the US military community. Chiller-ready connections. UV-resistant for indoor & outdoor use.',
    features: [
      'Classic oval design',
      'All black matte finish',
      '150 gallon capacity',
      'Fits 2 comfortably',
      'Ultra-durable drop-stitch build',
      'Top seller in US military community',
      'Chiller-ready connections',
      'UV-resistant material',
      'Indoor & outdoor use',
      '12-month warranty'
    ],
    specs: {
      capacity: '150 gallons',
      fits: '2 adults',
      build: 'Drop-stitch construction',
      use: 'Indoor/Outdoor'
    },
    images: {
      primary: 'https://iceboundessentials.com/cdn/shop/files/endeavor_cold_plunge_tub_1.png?v=1729458216&width=600',
      overhead: 'https://iceboundessentials.com/cdn/shop/files/endeavor_cold_plunge_tub_1.png?v=1729458216&width=600'
    }
  },
  // =============================================
  // DYNASTY SPAS AQUORA PLUNGE COLLECTION
  // =============================================
  {
    id: 'aquora-all-season',
    name: 'Aquora All Season',
    brand: 'Dynasty Spas',
    series: 'Aquora Collection',
    category: 'plunge',
    price: 'Call for Pricing',
    priceValue: null,
    description: 'Cold-climate, four-season plunge designed to anticipate and innovate. Features RMAX® insulation, energy efficient heater, and K300 digital topside control.',
    longDescription: 'Crafted from acrylic and fiberglass, the All-Season features high-performance insulation, including an air chamber and RMAX® insulation, to help retain heat and support all-season use. The equipment, electric water heater, cartridge filtration, and pump, is neatly concealed beneath the structure and well insulated, for a clean, high-end finish.',
    features: [
      'Cold-Climate, Four Season Use',
      'Underwater LED Light',
      'K300 Digital Topside Display',
      'Cushioned Foam Step Mats',
      'Filtration Pump',
      '220V / 60A Electrical',
      '100 Sq. Ft. Filtration',
      'Energy Efficient Heater',
      'Water Returns - Easy Flow Drain',
      'RMAX® Insulation',
      'Pearl Gray Acrylic',
      'Black Confer Skirting',
      'Black Cover Included'
    ],
    specs: {
      electrical: '220V / 60A',
      filtration: '100 sq. ft.',
      shell: 'Pearl Gray Acrylic',
      cabinet: 'Black Confer Skirting',
      insulation: 'RMAX® with Air Chamber',
      control: 'K300 Topside'
    },
    sizes: ['15\'', '19\''],
    images: {
      primary: '/images/aquora/aquora-main.png',
      overhead: '/images/aquora/aquora-shell.png',
      gallery: [
        '/images/aquora/aquora-skirting.jpeg',
        '/images/aquora/aquora-deckside.png',
        '/images/aquora/aquora-filtering.png',
        '/images/aquora/aquora-stepmats.png'
      ]
    },
    warranty: {
      shell: '10 Years',
      surface: '3 Years',
      electrical: '2 Years',
      plumbing: '2 Years',
      components: '1 Year'
    }
  },
  {
    id: 'aquora-heat',
    name: 'Aquora Heat',
    brand: 'Dynasty Spas',
    series: 'Aquora Collection',
    category: 'plunge',
    price: 'Call for Pricing',
    priceValue: null,
    description: 'Year-round use plunge with dynamic lighting and optimal performance. Features underwater LED lighting and superior filtration system.',
    longDescription: 'The Aquora Heat is designed for effortless entertaining with friends and family. Enjoy the ambiance of vibrant underwater LED lighting while a superior filtration system keeps your water clean, clear, and continuously flowing. Engineered for efficiency, it helps reduce chemical use while maintaining your ideal temperature—easily controlled through the intuitive in.k300 topside panel.',
    features: [
      'Year-Round Use',
      'Underwater LED Light',
      'K300 Digital Topside Display',
      'Cushioned Foam Step Mats',
      'Filtration Pump',
      '220V / 60A Electrical',
      '100 Sq. Ft. Filtration',
      'Energy Efficient Heater',
      'Water Returns - Easy Flow Drain',
      'Pearl Gray Acrylic',
      'Black Confer Skirting'
    ],
    specs: {
      electrical: '220V / 60A',
      filtration: '100 sq. ft.',
      shell: 'Pearl Gray Acrylic',
      cabinet: 'Black Confer Skirting',
      control: 'K300 Topside'
    },
    sizes: ['15\'', '19\''],
    images: {
      primary: '/images/aquora/aquora-main.png',
      overhead: '/images/aquora/aquora-shell.png',
      gallery: [
        '/images/aquora/aquora-heat-outdoor.jpg',
        '/images/aquora/aquora-skirting.jpeg',
        '/images/aquora/aquora-deckside.png',
        '/images/aquora/aquora-stepmats.png'
      ]
    },
    warranty: {
      shell: '10 Years',
      surface: '3 Years',
      electrical: '2 Years',
      plumbing: '2 Years',
      components: '1 Year'
    }
  },
  {
    id: 'aquora-complete',
    name: 'Aquora Complete',
    brand: 'Dynasty Spas',
    series: 'Aquora Collection',
    category: 'plunge',
    price: 'Call for Pricing',
    priceValue: null,
    description: 'Fully equipped Plug \'N Play plunge with 110V/15A electrical for quick and easy installation. Maximum efficiency with dedicated filtration pump.',
    longDescription: 'The Complete Aquora features a convenient 110V / 15-amp electrical system, allowing for quick and easy installation so you can start enjoying it with friends and family right away. Designed for maximum efficiency, this is our most energy-conscious Aquora model. Equipped with everything you need for an exceptional experience, the Complete Aquora is engineered to keep your water clean, clear, and ready for every use.',
    features: [
      'Plug \'N Play - 110V / 15A',
      'Underwater LED Light',
      'Cushioned Foam Step Mats',
      'Filtration Pump',
      '100 Sq. Ft. Filtration',
      'Water Returns - Easy Flow Drain',
      'Pearl Gray Acrylic',
      'Black Confer Skirting',
      'Maximum Energy Efficiency',
      'Quick & Easy Installation'
    ],
    specs: {
      electrical: '110V / 15A (Plug \'N Play)',
      filtration: '100 sq. ft.',
      shell: 'Pearl Gray Acrylic',
      cabinet: 'Black Confer Skirting'
    },
    sizes: ['15\'', '19\''],
    images: {
      primary: '/images/aquora/aquora-main.png',
      overhead: '/images/aquora/aquora-shell.png',
      gallery: [
        '/images/aquora/aquora-complete-filtering.png',
        '/images/aquora/aquora-skirting.jpeg',
        '/images/aquora/aquora-deckside.png',
        '/images/aquora/aquora-stepmats.png'
      ]
    },
    warranty: {
      shell: '10 Years',
      surface: '3 Years',
      electrical: '2 Years',
      plumbing: '2 Years',
      components: '1 Year'
    }
  },
  {
    id: 'aquora-core',
    name: 'Aquora Core',
    brand: 'Dynasty Spas',
    series: 'Aquora Collection',
    category: 'plunge',
    price: 'Call for Pricing',
    priceValue: null,
    description: 'Contractor build plunge shell designed for custom installations. Versatile design ideal for remodeling or new construction projects.',
    longDescription: 'The Core is crafted for contractors looking to deliver a high-end upgrade to a discerning homeowner\'s backyard. Its versatile design makes it ideal for remodeling or new construction, seamlessly integrating into beautifully landscaped spaces and custom-built decks—perfect for entertaining family and friends. Engineered with simplicity and efficiency in mind, The Core adds exceptional value and elegance to any home.',
    features: [
      'Contractor Build - Shell Only',
      'Cushioned Foam Step Mats',
      '100 Sq. Ft. Filtration Compatible',
      'Water Returns - Easy Flow Drain',
      'Pearl Gray Acrylic',
      'No 6 Month Wait',
      'Ideal for Custom Installations',
      'Remodeling & New Construction',
      'Exceptional Value'
    ],
    specs: {
      filtration: '100 sq. ft. compatible',
      shell: 'Pearl Gray Acrylic',
      type: 'Shell Only - Contractor Build'
    },
    sizes: ['15\'', '19\''],
    images: {
      primary: '/images/aquora/aquora-core-main.png',
      overhead: '/images/aquora/aquora-shell.png',
      gallery: [
        '/images/aquora/aquora-womans-feet.png',
        '/images/aquora/aquora-deckside.png',
        '/images/aquora/aquora-stepmats.png'
      ]
    },
    warranty: {
      note: 'Excludes Aquora Core - Contact dealer for details'
    }
  }
];
// Dynasty "Aquora" collection removed from the catalog per owner request.
export const COLD_PLUNGES = COLD_PLUNGES_ALL.filter((p) => p.brand !== 'Dynasty Spas');

// Combined Hot Tubs (all brands)
export const HOT_TUBS = [...GRAND_RIVER_PRODUCTS, ...VIKING_SPAS_PRODUCTS];


// ============================================
// LEISURECRAFT — Canadian-made saunas, cold plunges & outdoor furniture
// ============================================
export const LEISURECRAFT_SAUNAS = [
  {"id": "lc-outdoor-cabin-sauna", "name": "Outdoor Cabin Sauna", "brand": "LeisureCraft", "series": "Dundalk Collection", "category": "sauna", "price": "Call for Price", "description": "Canadian-made outdoor cabin sauna handcrafted in Ontario from premium cedar for authentic sauna heat and all-season durability.", "longDescription": "The Outdoor Cabin Sauna is part of the LeisureCraft Dundalk Collection, handcrafted in Ontario from high-quality cedar. Built for authentic löyly steam heat, marine-grade hardware, and lasting performance through every season, it ships as a pre-fabricated kit with guides for straightforward assembly. Backed by a 5-year warranty.", "features": ["Handcrafted in Ontario, Canada", "Premium cedar construction", "Authentic löyly steam heat", "Marine-grade T6061 aluminum hardware", "Ships as a pre-fabricated kit", "5-year warranty"], "warranty": "5-year warranty", "images": {"primary": "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/OLS562N_3CPFM1SURVOBSGP0/OLS562N_1.jpg", "gallery": ["https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/OLS562N_3CPFM1SURVOBSGP0/OLS562N_1.jpg"]}},
  {"id": "lc-luna-sauna", "name": "Luna Sauna", "brand": "LeisureCraft", "series": "Dundalk Collection", "category": "sauna", "price": "Call for Price", "description": "Canadian-made luna sauna handcrafted in Ontario from premium cedar for authentic sauna heat and all-season durability.", "longDescription": "The Luna Sauna is part of the LeisureCraft Dundalk Collection, handcrafted in Ontario from high-quality cedar. Built for authentic löyly steam heat, marine-grade hardware, and lasting performance through every season, it ships as a pre-fabricated kit with guides for straightforward assembly. Backed by a 5-year warranty.", "features": ["Handcrafted in Ontario, Canada", "Premium cedar construction", "Authentic löyly steam heat", "Marine-grade T6061 aluminum hardware", "Ships as a pre-fabricated kit", "5-year warranty"], "warranty": "5-year warranty", "images": {"primary": "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/862LU_3KNP44NUTIAT9N31/862LUEN_1.jpg", "gallery": ["https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/862LU_3KNP44NUTIAT9N31/862LUEN_1.jpg"]}},
  {"id": "lc-pure-cube-hudson-sauna", "name": "Pure Cube Hudson Sauna", "brand": "LeisureCraft", "series": "Pure Cube Collection", "category": "sauna", "price": "Call for Price", "description": "Canadian-made pure cube hudson sauna handcrafted in Ontario from premium cedar for authentic sauna heat and all-season durability.", "longDescription": "The Pure Cube Hudson Sauna is part of the LeisureCraft Pure Cube Collection, handcrafted in Ontario from high-quality cedar. Built for authentic löyly steam heat, marine-grade hardware, and lasting performance through every season, it ships as a pre-fabricated kit with guides for straightforward assembly. Backed by a 5-year warranty.", "features": ["Handcrafted in Ontario, Canada", "Premium cedar construction", "Authentic löyly steam heat", "Marine-grade T6061 aluminum hardware", "Ships as a pre-fabricated kit", "5-year warranty"], "warranty": "5-year warranty", "images": {"primary": "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/HU6112N_68N56I9NRVOBSGP0/HU6112N_10.jpg", "gallery": ["https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/HU6112N_68N56I9NRVOBSGP0/HU6112N_10.jpg"]}},
  {"id": "lc-pure-cube-mountain-view-sauna", "name": "Pure Cube Mountain View Sauna", "brand": "LeisureCraft", "series": "Pure Cube Collection", "category": "sauna", "price": "Call for Price", "description": "Canadian-made pure cube mountain view sauna handcrafted in Ontario from premium cedar for authentic sauna heat and all-season durability.", "longDescription": "The Pure Cube Mountain View Sauna is part of the LeisureCraft Pure Cube Collection, handcrafted in Ontario from high-quality cedar. Built for authentic löyly steam heat, marine-grade hardware, and lasting performance through every season, it ships as a pre-fabricated kit with guides for straightforward assembly. Backed by a 5-year warranty.", "features": ["Handcrafted in Ontario, Canada", "Premium cedar construction", "Authentic löyly steam heat", "Marine-grade T6061 aluminum hardware", "Ships as a pre-fabricated kit", "5-year warranty"], "warranty": "5-year warranty", "images": {"primary": "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/MV682_6U9H5KHPRVOBSGP0/MV682N_1.jpg", "gallery": ["https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/MV682_6U9H5KHPRVOBSGP0/MV682N_1.jpg"]}},
  {"id": "lc-barrel-sauna", "name": "Barrel Sauna", "brand": "LeisureCraft", "series": "Dundalk Collection", "category": "sauna", "price": "Call for Price", "description": "Canadian-made barrel sauna handcrafted in Ontario from premium cedar for authentic sauna heat and all-season durability.", "longDescription": "The Barrel Sauna is part of the LeisureCraft Dundalk Collection, handcrafted in Ontario from high-quality cedar. Built for authentic löyly steam heat, marine-grade hardware, and lasting performance through every season, it ships as a pre-fabricated kit with guides for straightforward assembly. Backed by a 5-year warranty.", "features": ["Handcrafted in Ontario, Canada", "Premium cedar construction", "Authentic löyly steam heat", "Marine-grade T6061 aluminum hardware", "Ships as a pre-fabricated kit", "5-year warranty"], "warranty": "5-year warranty", "images": {"primary": "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/762_8LEPR5HLSVOBSGP0/762N_1.jpg", "gallery": ["https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/762_8LEPR5HLSVOBSGP0/762N_1.jpg"]}},
  {"id": "lc-pure-cube-indoor-original-sauna", "name": "Pure Cube Indoor Original Sauna", "brand": "LeisureCraft", "series": "Pure Cube Collection", "category": "sauna", "price": "Call for Price", "description": "Canadian-made pure cube indoor original sauna handcrafted in Ontario from premium cedar for authentic sauna heat and all-season durability.", "longDescription": "The Pure Cube Indoor Original Sauna is part of the LeisureCraft Pure Cube Collection, handcrafted in Ontario from high-quality cedar. Built for authentic löyly steam heat, marine-grade hardware, and lasting performance through every season, it ships as a pre-fabricated kit with guides for straightforward assembly. Backed by a 5-year warranty.", "features": ["Handcrafted in Ontario, Canada", "Premium cedar construction", "Authentic löyly steam heat", "Marine-grade T6061 aluminum hardware", "Ships as a pre-fabricated kit", "5-year warranty"], "warranty": "5-year warranty", "images": {"primary": "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/PU552N_99N8QRPBQVOBSGP0/PU552N_1.jpg", "gallery": ["https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/PU552N_99N8QRPBQVOBSGP0/PU552N_1.jpg"]}},
  {"id": "lc-ct-element-indoor-sauna", "name": "CT Element Indoor Sauna", "brand": "LeisureCraft", "series": "Canadian Timber Collection", "category": "sauna", "price": "Call for Price", "description": "Canadian-made ct element indoor sauna handcrafted in Ontario from premium cedar for authentic sauna heat and all-season durability.", "longDescription": "The CT Element Indoor Sauna is part of the LeisureCraft Canadian Timber Collection, handcrafted in Ontario from high-quality cedar. Built for authentic löyly steam heat, marine-grade hardware, and lasting performance through every season, it ships as a pre-fabricated kit with guides for straightforward assembly. Backed by a 5-year warranty.", "features": ["Handcrafted in Ontario, Canada", "Premium cedar construction", "Authentic löyly steam heat", "Marine-grade T6061 aluminum hardware", "Ships as a pre-fabricated kit", "5-year warranty"], "warranty": "5-year warranty", "images": {"primary": "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/LS462N_A1N1TDOLP4D546E0/LS462N_1.jpg", "gallery": ["https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/LS462N_A1N1TDOLP4D546E0/LS462N_1.jpg"]}},
  {"id": "lc-indoor-cabin-sauna", "name": "Indoor Cabin Sauna", "brand": "LeisureCraft", "series": "Dundalk Collection", "category": "sauna", "price": "Call for Price", "description": "Canadian-made indoor cabin sauna handcrafted in Ontario from premium cedar for authentic sauna heat and all-season durability.", "longDescription": "The Indoor Cabin Sauna is part of the LeisureCraft Dundalk Collection, handcrafted in Ontario from high-quality cedar. Built for authentic löyly steam heat, marine-grade hardware, and lasting performance through every season, it ships as a pre-fabricated kit with guides for straightforward assembly. Backed by a 5-year warranty.", "features": ["Handcrafted in Ontario, Canada", "Premium cedar construction", "Authentic löyly steam heat", "Marine-grade T6061 aluminum hardware", "Ships as a pre-fabricated kit", "5-year warranty"], "warranty": "5-year warranty", "images": {"primary": "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/LS462N_A1N1TDOLP4D546E0/LS462N_1.jpg", "gallery": ["https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/LS462N_A1N1TDOLP4D546E0/LS462N_1.jpg"]}},
  {"id": "lc-ct-luna-sauna", "name": "CT Luna Sauna", "brand": "LeisureCraft", "series": "Canadian Timber Collection", "category": "sauna", "price": "Call for Price", "description": "Canadian-made ct luna sauna handcrafted in Ontario from premium cedar for authentic sauna heat and all-season durability.", "longDescription": "The CT Luna Sauna is part of the LeisureCraft Canadian Timber Collection, handcrafted in Ontario from high-quality cedar. Built for authentic löyly steam heat, marine-grade hardware, and lasting performance through every season, it ships as a pre-fabricated kit with guides for straightforward assembly. Backed by a 5-year warranty.", "features": ["Handcrafted in Ontario, Canada", "Premium cedar construction", "Authentic löyly steam heat", "Marine-grade T6061 aluminum hardware", "Ships as a pre-fabricated kit", "5-year warranty"], "warranty": "5-year warranty", "images": {"primary": "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/CTC22LU_ACF38S20VVOBSGP0/CTC22LUN_10.jpg", "gallery": ["https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/CTC22LU_ACF38S20VVOBSGP0/CTC22LUN_10.jpg"]}},
  {"id": "lc-pod-sauna", "name": "POD Sauna", "brand": "LeisureCraft", "series": "Dundalk Collection", "category": "sauna", "price": "Call for Price", "description": "Canadian-made pod sauna handcrafted in Ontario from premium cedar for authentic sauna heat and all-season durability.", "longDescription": "The POD Sauna is part of the LeisureCraft Dundalk Collection, handcrafted in Ontario from high-quality cedar. Built for authentic löyly steam heat, marine-grade hardware, and lasting performance through every season, it ships as a pre-fabricated kit with guides for straightforward assembly. Backed by a 5-year warranty.", "features": ["Handcrafted in Ontario, Canada", "Premium cedar construction", "Authentic löyly steam heat", "Marine-grade T6061 aluminum hardware", "Ships as a pre-fabricated kit", "5-year warranty"], "warranty": "5-year warranty", "images": {"primary": "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/862POD_ACPVCREBRVOBSGP0/826PODN_10.jpg", "gallery": ["https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/862POD_ACPVCREBRVOBSGP0/826PODN_10.jpg"]}},
  {"id": "lc-pure-cube-outdoor-original-sauna", "name": "Pure Cube Outdoor Original Sauna", "brand": "LeisureCraft", "series": "Pure Cube Collection", "category": "sauna", "price": "Call for Price", "description": "Canadian-made pure cube outdoor original sauna handcrafted in Ontario from premium cedar for authentic sauna heat and all-season durability.", "longDescription": "The Pure Cube Outdoor Original Sauna is part of the LeisureCraft Pure Cube Collection, handcrafted in Ontario from high-quality cedar. Built for authentic löyly steam heat, marine-grade hardware, and lasting performance through every season, it ships as a pre-fabricated kit with guides for straightforward assembly. Backed by a 5-year warranty.", "features": ["Handcrafted in Ontario, Canada", "Premium cedar construction", "Authentic löyly steam heat", "Marine-grade T6061 aluminum hardware", "Ships as a pre-fabricated kit", "5-year warranty"], "warranty": "5-year warranty", "images": {"primary": "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/CU580D_BA627GA900PBSGP0/CU580DN_1.jpg", "gallery": ["https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/CU580D_BA627GA900PBSGP0/CU580DN_1.jpg"]}},
  {"id": "lc-ct-elation-sauna", "name": "CT Elation Sauna", "brand": "LeisureCraft", "series": "Canadian Timber Collection", "category": "sauna", "price": "Call for Price", "description": "Canadian-made ct elation sauna handcrafted in Ontario from premium cedar for authentic sauna heat and all-season durability.", "longDescription": "The CT Elation Sauna is part of the LeisureCraft Canadian Timber Collection, handcrafted in Ontario from high-quality cedar. Built for authentic löyly steam heat, marine-grade hardware, and lasting performance through every season, it ships as a pre-fabricated kit with guides for straightforward assembly. Backed by a 5-year warranty.", "features": ["Handcrafted in Ontario, Canada", "Premium cedar construction", "Authentic löyly steam heat", "Marine-grade T6061 aluminum hardware", "Ships as a pre-fabricated kit", "5-year warranty"], "warranty": "5-year warranty", "images": {"primary": "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/CTC2424_BPON6BAD30PBSGP0/CTC2424N_10.jpg", "gallery": ["https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/CTC2424_BPON6BAD30PBSGP0/CTC2424N_10.jpg"]}},
  {"id": "lc-pure-cube-orion-sauna", "name": "Pure Cube Orion Sauna", "brand": "LeisureCraft", "series": "Pure Cube Collection", "category": "sauna", "price": "Call for Price", "description": "Canadian-made pure cube orion sauna handcrafted in Ontario from premium cedar for authentic sauna heat and all-season durability.", "longDescription": "The Pure Cube Orion Sauna is part of the LeisureCraft Pure Cube Collection, handcrafted in Ontario from high-quality cedar. Built for authentic löyly steam heat, marine-grade hardware, and lasting performance through every season, it ships as a pre-fabricated kit with guides for straightforward assembly. Backed by a 5-year warranty.", "features": ["Handcrafted in Ontario, Canada", "Premium cedar construction", "Authentic löyly steam heat", "Marine-grade T6061 aluminum hardware", "Ships as a pre-fabricated kit", "5-year warranty"], "warranty": "5-year warranty", "images": {"primary": "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/OR6112_FII13EA7QVOBSGP0/OR6112N_1.jpg", "gallery": ["https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/OR6112_FII13EA7QVOBSGP0/OR6112N_1.jpg"]}},
  {"id": "lc-panoramic-barrel-sauna", "name": "Panoramic Barrel Sauna", "brand": "LeisureCraft", "series": "Dundalk Collection", "category": "sauna", "price": "Call for Price", "description": "Canadian-made panoramic barrel sauna handcrafted in Ontario from premium cedar for authentic sauna heat and all-season durability.", "longDescription": "The Panoramic Barrel Sauna is part of the LeisureCraft Dundalk Collection, handcrafted in Ontario from high-quality cedar. Built for authentic löyly steam heat, marine-grade hardware, and lasting performance through every season, it ships as a pre-fabricated kit with guides for straightforward assembly. Backed by a 5-year warranty.", "features": ["Handcrafted in Ontario, Canada", "Premium cedar construction", "Authentic löyly steam heat", "Marine-grade T6061 aluminum hardware", "Ships as a pre-fabricated kit", "5-year warranty"], "warranty": "5-year warranty", "images": {"primary": "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/762_8LEPR5HLSVOBSGP0/762N_1.jpg", "gallery": ["https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/762_8LEPR5HLSVOBSGP0/762N_1.jpg"]}},
  {"id": "lc-pure-cube-trinity-sauna", "name": "Pure Cube Trinity Sauna", "brand": "LeisureCraft", "series": "Pure Cube Collection", "category": "sauna", "price": "Call for Price", "description": "Canadian-made pure cube trinity sauna handcrafted in Ontario from premium cedar for authentic sauna heat and all-season durability.", "longDescription": "The Pure Cube Trinity Sauna is part of the LeisureCraft Pure Cube Collection, handcrafted in Ontario from high-quality cedar. Built for authentic löyly steam heat, marine-grade hardware, and lasting performance through every season, it ships as a pre-fabricated kit with guides for straightforward assembly. Backed by a 5-year warranty.", "features": ["Handcrafted in Ontario, Canada", "Premium cedar construction", "Authentic löyly steam heat", "Marine-grade T6061 aluminum hardware", "Ships as a pre-fabricated kit", "5-year warranty"], "warranty": "5-year warranty", "images": {"primary": "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/HU6112N_68N56I9NRVOBSGP0/HU6112N_10.jpg", "gallery": ["https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/HU6112N_68N56I9NRVOBSGP0/HU6112N_10.jpg"]}},
  {"id": "lc-pure-cube-neptune-sauna", "name": "Pure Cube Neptune Sauna", "brand": "LeisureCraft", "series": "Pure Cube Collection", "category": "sauna", "price": "Call for Price", "description": "Canadian-made pure cube neptune sauna handcrafted in Ontario from premium cedar for authentic sauna heat and all-season durability.", "longDescription": "The Pure Cube Neptune Sauna is part of the LeisureCraft Pure Cube Collection, handcrafted in Ontario from high-quality cedar. Built for authentic löyly steam heat, marine-grade hardware, and lasting performance through every season, it ships as a pre-fabricated kit with guides for straightforward assembly. Backed by a 5-year warranty.", "features": ["Handcrafted in Ontario, Canada", "Premium cedar construction", "Authentic löyly steam heat", "Marine-grade T6061 aluminum hardware", "Ships as a pre-fabricated kit", "5-year warranty"], "warranty": "5-year warranty", "images": {"primary": "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/NE6112_R36BLOO6QVOBSGP0/NE6112N_1.jpg", "gallery": ["https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/NE6112_R36BLOO6QVOBSGP0/NE6112N_1.jpg"]}},
  {"id": "lc-ct-minipod-sauna", "name": "CT MiniPOD Sauna", "brand": "LeisureCraft", "series": "Canadian Timber Collection", "category": "sauna", "price": "Call for Price", "description": "Canadian-made ct minipod sauna handcrafted in Ontario from premium cedar for authentic sauna heat and all-season durability.", "longDescription": "The CT MiniPOD Sauna is part of the LeisureCraft Canadian Timber Collection, handcrafted in Ontario from high-quality cedar. Built for authentic löyly steam heat, marine-grade hardware, and lasting performance through every season, it ships as a pre-fabricated kit with guides for straightforward assembly. Backed by a 5-year warranty.", "features": ["Handcrafted in Ontario, Canada", "Premium cedar construction", "Authentic löyly steam heat", "Marine-grade T6061 aluminum hardware", "Ships as a pre-fabricated kit", "5-year warranty"], "warranty": "5-year warranty", "images": {"primary": "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/CTC77M_SCQF6BAPUVOBSGP0/CTC77MN_10.jpg", "gallery": ["https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/CTC77M_SCQF6BAPUVOBSGP0/CTC77MN_10.jpg"]}},
  {"id": "lc-ct-cabin-sauna", "name": "CT Cabin Sauna", "brand": "LeisureCraft", "series": "Canadian Timber Collection", "category": "sauna", "price": "Call for Price", "description": "Canadian-made ct cabin sauna handcrafted in Ontario from premium cedar for authentic sauna heat and all-season durability.", "longDescription": "The CT Cabin Sauna is part of the LeisureCraft Canadian Timber Collection, handcrafted in Ontario from high-quality cedar. Built for authentic löyly steam heat, marine-grade hardware, and lasting performance through every season, it ships as a pre-fabricated kit with guides for straightforward assembly. Backed by a 5-year warranty.", "features": ["Handcrafted in Ontario, Canada", "Premium cedar construction", "Authentic löyly steam heat", "Marine-grade T6061 aluminum hardware", "Ships as a pre-fabricated kit", "5-year warranty"], "warranty": "5-year warranty", "images": {"primary": "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/CTC88_UK4B5VPMUVOBSGP0/CTC88N_10.jpg", "gallery": ["https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/CTC88_UK4B5VPMUVOBSGP0/CTC88N_10.jpg"]}}
];

export const LEISURECRAFT_PLUNGES = [
  {"id": "lc-the-polar-plunge-tub", "name": "The Polar Plunge Tub", "brand": "LeisureCraft", "series": "Canadian Timber Collection", "category": "plunge", "price": "Call for Price", "description": "Canadian-made cedar cold plunge tub with stainless steel or HDPE interior and optional chiller for precise, year-round cold therapy.", "longDescription": "The The Polar Plunge Tub is handcrafted in Ontario from the same Canadian cedar as LeisureCraft saunas, combining natural beauty with a durable interior and optional chiller system for precise temperature control. Pair it with a sauna for a complete contrast-therapy setup. Backed by a 5-year warranty.", "features": ["Handcrafted Canadian cedar exterior", "Stainless steel or HDPE interior", "Chiller-compatible (down to 37°F / 2.8°C)", "No permanent plumbing — hose fill & floor drain", "Great for contrast therapy", "5-year warranty"], "warranty": "5-year warranty", "images": {"primary": "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/CT362PPN_ATHRR729S0PBSGP0/CT362PPN_1.jpg", "gallery": ["https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/CT362PPN_ATHRR729S0PBSGP0/CT362PPN_1.jpg"]}},
  {"id": "lc-the-arctic-plunge-tub", "name": "The Arctic Plunge Tub", "brand": "LeisureCraft", "series": "Dundalk Collection", "category": "plunge", "price": "Call for Price", "description": "Canadian-made cedar cold plunge tub with stainless steel or HDPE interior and optional chiller for precise, year-round cold therapy.", "longDescription": "The The Arctic Plunge Tub is handcrafted in Ontario from the same Canadian cedar as LeisureCraft saunas, combining natural beauty with a durable interior and optional chiller system for precise temperature control. Pair it with a sauna for a complete contrast-therapy setup. Backed by a 5-year warranty.", "features": ["Handcrafted Canadian cedar exterior", "Stainless steel or HDPE interior", "Chiller-compatible (down to 37°F / 2.8°C)", "No permanent plumbing — hose fill & floor drain", "Great for contrast therapy", "5-year warranty"], "warranty": "5-year warranty", "images": {"primary": "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/332CPN_IVRG00NCS0PBSGP0/332CPN_10.jpg", "gallery": ["https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/332CPN_IVRG00NCS0PBSGP0/332CPN_10.jpg"]}},
  {"id": "lc-the-glacier-plunge-tub", "name": "The Glacier Plunge Tub", "brand": "LeisureCraft", "series": "Dundalk Collection", "category": "plunge", "price": "Call for Price", "description": "Canadian-made cedar cold plunge tub with stainless steel or HDPE interior and optional chiller for precise, year-round cold therapy.", "longDescription": "The The Glacier Plunge Tub is handcrafted in Ontario from the same Canadian cedar as LeisureCraft saunas, combining natural beauty with a durable interior and optional chiller system for precise temperature control. Pair it with a sauna for a complete contrast-therapy setup. Backed by a 5-year warranty.", "features": ["Handcrafted Canadian cedar exterior", "Stainless steel or HDPE interior", "Chiller-compatible (down to 37°F / 2.8°C)", "No permanent plumbing — hose fill & floor drain", "Great for contrast therapy", "5-year warranty"], "warranty": "5-year warranty", "images": {"primary": "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/362CPN_OEHU4K7DS0PBSGP0/362CPN_10.jpg", "gallery": ["https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/362CPN_OEHU4K7DS0PBSGP0/362CPN_10.jpg"]}},
  {"id": "lc-the-baltic-plunge-tub", "name": "The Baltic Plunge Tub", "brand": "LeisureCraft", "series": "Canadian Timber Collection", "category": "plunge", "price": "Call for Price", "description": "Canadian-made cedar cold plunge tub with stainless steel or HDPE interior and optional chiller for precise, year-round cold therapy.", "longDescription": "The The Baltic Plunge Tub is handcrafted in Ontario from the same Canadian cedar as LeisureCraft saunas, combining natural beauty with a durable interior and optional chiller system for precise temperature control. Pair it with a sauna for a complete contrast-therapy setup. Backed by a 5-year warranty.", "features": ["Handcrafted Canadian cedar exterior", "Stainless steel or HDPE interior", "Chiller-compatible (down to 37°F / 2.8°C)", "No permanent plumbing — hose fill & floor drain", "Great for contrast therapy", "5-year warranty"], "warranty": "5-year warranty", "images": {"primary": "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/CT33BPN_S2JAOPD8S0PBSGP0/CT33BPN_1.jpg", "gallery": ["https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/CT33BPN_S2JAOPD8S0PBSGP0/CT33BPN_1.jpg"]}},
  {"id": "lc-the-flow-cold-plunge", "name": "The Flow Cold Plunge", "brand": "LeisureCraft", "series": "Dundalk Collection", "category": "plunge", "price": "Call for Price", "description": "Canadian-made cedar cold plunge tub with stainless steel or HDPE interior and optional chiller for precise, year-round cold therapy.", "longDescription": "The The Flow Cold Plunge is handcrafted in Ontario from the same Canadian cedar as LeisureCraft saunas, combining natural beauty with a durable interior and optional chiller system for precise temperature control. Pair it with a sauna for a complete contrast-therapy setup. Backed by a 5-year warranty.", "features": ["Handcrafted Canadian cedar exterior", "Stainless steel or HDPE interior", "Chiller-compatible (down to 37°F / 2.8°C)", "No permanent plumbing — hose fill & floor drain", "Great for contrast therapy", "5-year warranty"], "warranty": "5-year warranty", "images": {"primary": "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/372FPN_S6R9LNDES0PBSGP0/372FPN_10.jpg", "gallery": ["https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/372FPN_S6R9LNDES0PBSGP0/372FPN_10.jpg"]}}
];

export const LEISURECRAFT_FURNITURE = [
  {"id": "lc-log-captains-bar-stool", "name": "Log Captains Bar Stool", "brand": "LeisureCraft", "series": "Outdoor Furniture", "category": "furniture", "price": "Call for Price", "description": "Canadian-made cedar log captains bar stool — sturdy, comfortable, and built to stay outdoors through every season.", "longDescription": "The Log Captains Bar Stool is crafted from the same Canadian cedar as LeisureCraft saunas and designed for life outdoors. Cedar is naturally resistant to moisture, rot, and insects, and weathers gracefully to a silvery grey — or keep the original tone with an outdoor finish. Built with the same joinery and material quality as a LeisureCraft sauna.", "features": ["Handcrafted in Ontario, Canada", "Premium cedar construction", "Weather-resistant — built for year-round outdoor use", "Low maintenance", "Sauna-grade joinery and craftsmanship"], "images": {"primary": "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/L144N_12G63SFLO0PBSGP0/L144N_1.jpg", "gallery": ["https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/L144N_12G63SFLO0PBSGP0/L144N_1.jpg"]}},
  {"id": "lc-30-saddle-seat-bar-stool", "name": "30\" Saddle Seat Bar Stool", "brand": "LeisureCraft", "series": "Outdoor Furniture", "category": "furniture", "price": "Call for Price", "description": "Canadian-made cedar 30\" saddle seat bar stool — sturdy, comfortable, and built to stay outdoors through every season.", "longDescription": "The 30\" Saddle Seat Bar Stool is crafted from the same Canadian cedar as LeisureCraft saunas and designed for life outdoors. Cedar is naturally resistant to moisture, rot, and insects, and weathers gracefully to a silvery grey — or keep the original tone with an outdoor finish. Built with the same joinery and material quality as a LeisureCraft sauna.", "features": ["Handcrafted in Ontario, Canada", "Premium cedar construction", "Weather-resistant — built for year-round outdoor use", "Low maintenance", "Sauna-grade joinery and craftsmanship"], "images": {"primary": "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/CT1460N_198H7UKNM0PBSGP0/stool-saddle.jpg", "gallery": ["https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/CT1460N_198H7UKNM0PBSGP0/stool-saddle.jpg"]}},
  {"id": "lc-24-square-end-table", "name": "24\" Square End Table", "brand": "LeisureCraft", "series": "Outdoor Furniture", "category": "furniture", "price": "Call for Price", "description": "Canadian-made cedar 24\" square end table — sturdy, comfortable, and built to stay outdoors through every season.", "longDescription": "The 24\" Square End Table is crafted from the same Canadian cedar as LeisureCraft saunas and designed for life outdoors. Cedar is naturally resistant to moisture, rot, and insects, and weathers gracefully to a silvery grey — or keep the original tone with an outdoor finish. Built with the same joinery and material quality as a LeisureCraft sauna.", "features": ["Handcrafted in Ontario, Canada", "Premium cedar construction", "Weather-resistant — built for year-round outdoor use", "Low maintenance", "Sauna-grade joinery and craftsmanship"], "images": {"primary": "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/L135N_2MGLAEKFO0PBSGP0/L135N_1.jpg", "gallery": ["https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/L135N_2MGLAEKFO0PBSGP0/L135N_1.jpg"]}},
  {"id": "lc-adirondack-foldable-end-table", "name": "Adirondack Foldable End Table", "brand": "LeisureCraft", "series": "Outdoor Furniture", "category": "furniture", "price": "Call for Price", "description": "Canadian-made cedar adirondack foldable end table — sturdy, comfortable, and built to stay outdoors through every season.", "longDescription": "The Adirondack Foldable End Table is crafted from the same Canadian cedar as LeisureCraft saunas and designed for life outdoors. Cedar is naturally resistant to moisture, rot, and insects, and weathers gracefully to a silvery grey — or keep the original tone with an outdoor finish. Built with the same joinery and material quality as a LeisureCraft sauna.", "features": ["Handcrafted in Ontario, Canada", "Premium cedar construction", "Weather-resistant — built for year-round outdoor use", "Low maintenance", "Sauna-grade joinery and craftsmanship"], "images": {"primary": "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/70102023_42925FVAO0PBSGP0/_10.jpg", "gallery": ["https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/70102023_42925FVAO0PBSGP0/_10.jpg"]}},
  {"id": "lc-southern-fantasy-tiki-bar", "name": "Southern Fantasy Tiki Bar", "brand": "LeisureCraft", "series": "Outdoor Furniture", "category": "furniture", "price": "Call for Price", "description": "Canadian-made cedar southern fantasy tiki bar — sturdy, comfortable, and built to stay outdoors through every season.", "longDescription": "The Southern Fantasy Tiki Bar is crafted from the same Canadian cedar as LeisureCraft saunas and designed for life outdoors. Cedar is naturally resistant to moisture, rot, and insects, and weathers gracefully to a silvery grey — or keep the original tone with an outdoor finish. Built with the same joinery and material quality as a LeisureCraft sauna.", "features": ["Handcrafted in Ontario, Canada", "Premium cedar construction", "Weather-resistant — built for year-round outdoor use", "Low maintenance", "Sauna-grade joinery and craftsmanship"], "images": {"primary": "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/CT3672N_6PEJ4DIMN0PBSGP0/CT3672N_10.jpg", "gallery": ["https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/CT3672N_6PEJ4DIMN0PBSGP0/CT3672N_10.jpg"]}},
  {"id": "lc-outdoor-kitchen", "name": "Outdoor Kitchen", "brand": "LeisureCraft", "series": "Outdoor Furniture", "category": "furniture", "price": "Call for Price", "description": "Canadian-made cedar outdoor kitchen — sturdy, comfortable, and built to stay outdoors through every season.", "longDescription": "The Outdoor Kitchen is crafted from the same Canadian cedar as LeisureCraft saunas and designed for life outdoors. Cedar is naturally resistant to moisture, rot, and insects, and weathers gracefully to a silvery grey — or keep the original tone with an outdoor finish. Built with the same joinery and material quality as a LeisureCraft sauna.", "features": ["Handcrafted in Ontario, Canada", "Premium cedar construction", "Weather-resistant — built for year-round outdoor use", "Low maintenance", "Sauna-grade joinery and craftsmanship"], "images": {"primary": "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/L566N_7GRK354QO0PBSGP0/kitchen-small.jpg", "gallery": ["https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/L566N_7GRK354QO0PBSGP0/kitchen-small.jpg"]}},
  {"id": "lc-adirondack-log-2-seat-bench", "name": "Adirondack Log 2 Seat Bench", "brand": "LeisureCraft", "series": "Outdoor Furniture", "category": "furniture", "price": "Call for Price", "description": "Canadian-made cedar adirondack log 2 seat bench — sturdy, comfortable, and built to stay outdoors through every season.", "longDescription": "The Adirondack Log 2 Seat Bench is crafted from the same Canadian cedar as LeisureCraft saunas and designed for life outdoors. Cedar is naturally resistant to moisture, rot, and insects, and weathers gracefully to a silvery grey — or keep the original tone with an outdoor finish. Built with the same joinery and material quality as a LeisureCraft sauna.", "features": ["Handcrafted in Ontario, Canada", "Premium cedar construction", "Weather-resistant — built for year-round outdoor use", "Low maintenance", "Sauna-grade joinery and craftsmanship"], "images": {"primary": "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/L224_87NPE0LGO0PBSGP0/L224N_1.jpg", "gallery": ["https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/L224_87NPE0LGO0PBSGP0/L224N_1.jpg"]}},
  {"id": "lc-tropical-paradise-tiki-bar", "name": "Tropical Paradise Tiki Bar", "brand": "LeisureCraft", "series": "Outdoor Furniture", "category": "furniture", "price": "Call for Price", "description": "Canadian-made cedar tropical paradise tiki bar — sturdy, comfortable, and built to stay outdoors through every season.", "longDescription": "The Tropical Paradise Tiki Bar is crafted from the same Canadian cedar as LeisureCraft saunas and designed for life outdoors. Cedar is naturally resistant to moisture, rot, and insects, and weathers gracefully to a silvery grey — or keep the original tone with an outdoor finish. Built with the same joinery and material quality as a LeisureCraft sauna.", "features": ["Handcrafted in Ontario, Canada", "Premium cedar construction", "Weather-resistant — built for year-round outdoor use", "Low maintenance", "Sauna-grade joinery and craftsmanship"], "images": {"primary": "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/CT4896N_8GV5JBKNN0PBSGP0/CT4896N_10.jpg", "gallery": ["https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/CT4896N_8GV5JBKNN0PBSGP0/CT4896N_10.jpg"]}},
  {"id": "lc-36-round-bistro-table", "name": "36\" Round Bistro Table", "brand": "LeisureCraft", "series": "Outdoor Furniture", "category": "furniture", "price": "Call for Price", "description": "Canadian-made cedar 36\" round bistro table — sturdy, comfortable, and built to stay outdoors through every season.", "longDescription": "The 36\" Round Bistro Table is crafted from the same Canadian cedar as LeisureCraft saunas and designed for life outdoors. Cedar is naturally resistant to moisture, rot, and insects, and weathers gracefully to a silvery grey — or keep the original tone with an outdoor finish. Built with the same joinery and material quality as a LeisureCraft sauna.", "features": ["Handcrafted in Ontario, Canada", "Premium cedar construction", "Weather-resistant — built for year-round outdoor use", "Low maintenance", "Sauna-grade joinery and craftsmanship"], "images": {"primary": "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/L124N_9OES8HCKO0PBSGP0/L124N_1.jpg", "gallery": ["https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/L124N_9OES8HCKO0PBSGP0/L124N_1.jpg"]}},
  {"id": "lc-adirondack-log-chair", "name": "Adirondack Log Chair", "brand": "LeisureCraft", "series": "Outdoor Furniture", "category": "furniture", "price": "Call for Price", "description": "Canadian-made cedar adirondack log chair — sturdy, comfortable, and built to stay outdoors through every season.", "longDescription": "The Adirondack Log Chair is crafted from the same Canadian cedar as LeisureCraft saunas and designed for life outdoors. Cedar is naturally resistant to moisture, rot, and insects, and weathers gracefully to a silvery grey — or keep the original tone with an outdoor finish. Built with the same joinery and material quality as a LeisureCraft sauna.", "features": ["Handcrafted in Ontario, Canada", "Premium cedar construction", "Weather-resistant — built for year-round outdoor use", "Low maintenance", "Sauna-grade joinery and craftsmanship"], "images": {"primary": "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/L214N_AEIGU1VGO0PBSGP0/L214N_1.jpg", "gallery": ["https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/L214N_AEIGU1VGO0PBSGP0/L214N_1.jpg"]}},
  {"id": "lc-oval-coffee-table", "name": "Oval Coffee Table", "brand": "LeisureCraft", "series": "Outdoor Furniture", "category": "furniture", "price": "Call for Price", "description": "Canadian-made cedar oval coffee table — sturdy, comfortable, and built to stay outdoors through every season.", "longDescription": "The Oval Coffee Table is crafted from the same Canadian cedar as LeisureCraft saunas and designed for life outdoors. Cedar is naturally resistant to moisture, rot, and insects, and weathers gracefully to a silvery grey — or keep the original tone with an outdoor finish. Built with the same joinery and material quality as a LeisureCraft sauna.", "features": ["Handcrafted in Ontario, Canada", "Premium cedar construction", "Weather-resistant — built for year-round outdoor use", "Low maintenance", "Sauna-grade joinery and craftsmanship"], "images": {"primary": "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/L138N_AN2IET0GO0PBSGP0/L138N_1.jpg", "gallery": ["https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/L138N_AN2IET0GO0PBSGP0/L138N_1.jpg"]}},
  {"id": "lc-curved-dining-bench", "name": "Curved Dining Bench", "brand": "LeisureCraft", "series": "Outdoor Furniture", "category": "furniture", "price": "Call for Price", "description": "Canadian-made cedar curved dining bench — sturdy, comfortable, and built to stay outdoors through every season.", "longDescription": "The Curved Dining Bench is crafted from the same Canadian cedar as LeisureCraft saunas and designed for life outdoors. Cedar is naturally resistant to moisture, rot, and insects, and weathers gracefully to a silvery grey — or keep the original tone with an outdoor finish. Built with the same joinery and material quality as a LeisureCraft sauna.", "features": ["Handcrafted in Ontario, Canada", "Premium cedar construction", "Weather-resistant — built for year-round outdoor use", "Low maintenance", "Sauna-grade joinery and craftsmanship"], "images": {"primary": "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/L525N_BVSNJ3QPO0PBSGP0/L525N_1.jpg", "gallery": ["https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/L525N_BVSNJ3QPO0PBSGP0/L525N_1.jpg"]}},
  {"id": "lc-outdoor-log-dining-bench", "name": "Outdoor Log Dining Bench", "brand": "LeisureCraft", "series": "Outdoor Furniture", "category": "furniture", "price": "Call for Price", "description": "Canadian-made cedar outdoor log dining bench — sturdy, comfortable, and built to stay outdoors through every season.", "longDescription": "The Outdoor Log Dining Bench is crafted from the same Canadian cedar as LeisureCraft saunas and designed for life outdoors. Cedar is naturally resistant to moisture, rot, and insects, and weathers gracefully to a silvery grey — or keep the original tone with an outdoor finish. Built with the same joinery and material quality as a LeisureCraft sauna.", "features": ["Handcrafted in Ontario, Canada", "Premium cedar construction", "Weather-resistant — built for year-round outdoor use", "Low maintenance", "Sauna-grade joinery and craftsmanship"], "images": {"primary": "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/L520N_DCI8CLD1P0PBSGP0/L520N_1.jpg", "gallery": ["https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/L520N_DCI8CLD1P0PBSGP0/L520N_1.jpg"]}},
  {"id": "lc-adirondack-kids-chair", "name": "Adirondack Kids Chair", "brand": "LeisureCraft", "series": "Outdoor Furniture", "category": "furniture", "price": "Call for Price", "description": "Canadian-made cedar adirondack kids chair — sturdy, comfortable, and built to stay outdoors through every season.", "longDescription": "The Adirondack Kids Chair is crafted from the same Canadian cedar as LeisureCraft saunas and designed for life outdoors. Cedar is naturally resistant to moisture, rot, and insects, and weathers gracefully to a silvery grey — or keep the original tone with an outdoor finish. Built with the same joinery and material quality as a LeisureCraft sauna.", "features": ["Handcrafted in Ontario, Canada", "Premium cedar construction", "Weather-resistant — built for year-round outdoor use", "Low maintenance", "Sauna-grade joinery and craftsmanship"], "images": {"primary": "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/L205N_E1NPUUAGO0PBSGP0/L205N_1.jpg", "gallery": ["https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/L205N_E1NPUUAGO0PBSGP0/L205N_1.jpg"]}},
  {"id": "lc-30-stool-with-back", "name": "30\" Stool with Back", "brand": "LeisureCraft", "series": "Outdoor Furniture", "category": "furniture", "price": "Call for Price", "description": "Canadian-made cedar 30\" stool with back — sturdy, comfortable, and built to stay outdoors through every season.", "longDescription": "The 30\" Stool with Back is crafted from the same Canadian cedar as LeisureCraft saunas and designed for life outdoors. Cedar is naturally resistant to moisture, rot, and insects, and weathers gracefully to a silvery grey — or keep the original tone with an outdoor finish. Built with the same joinery and material quality as a LeisureCraft sauna.", "features": ["Handcrafted in Ontario, Canada", "Premium cedar construction", "Weather-resistant — built for year-round outdoor use", "Low maintenance", "Sauna-grade joinery and craftsmanship"], "images": {"primary": "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/CT1420N_FD6OBDLMM0PBSGP0/stool-back.jpg", "gallery": ["https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/CT1420N_FD6OBDLMM0PBSGP0/stool-back.jpg"]}},
  {"id": "lc-log-picnic-table", "name": "Log Picnic Table", "brand": "LeisureCraft", "series": "Outdoor Furniture", "category": "furniture", "price": "Call for Price", "description": "Canadian-made cedar log picnic table — sturdy, comfortable, and built to stay outdoors through every season.", "longDescription": "The Log Picnic Table is crafted from the same Canadian cedar as LeisureCraft saunas and designed for life outdoors. Cedar is naturally resistant to moisture, rot, and insects, and weathers gracefully to a silvery grey — or keep the original tone with an outdoor finish. Built with the same joinery and material quality as a LeisureCraft sauna.", "features": ["Handcrafted in Ontario, Canada", "Premium cedar construction", "Weather-resistant — built for year-round outdoor use", "Low maintenance", "Sauna-grade joinery and craftsmanship"], "images": {"primary": "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/L415N_FLCTJTPLO0PBSGP0/_10.jpg", "gallery": ["https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/L415N_FLCTJTPLO0PBSGP0/_10.jpg"]}},
  {"id": "lc-adirondack-log-gossip-bench-with-table", "name": "Adirondack Log Gossip Bench with Table", "brand": "LeisureCraft", "series": "Outdoor Furniture", "category": "furniture", "price": "Call for Price", "description": "Canadian-made cedar adirondack log gossip bench with table — sturdy, comfortable, and built to stay outdoors through every season.", "longDescription": "The Adirondack Log Gossip Bench with Table is crafted from the same Canadian cedar as LeisureCraft saunas and designed for life outdoors. Cedar is naturally resistant to moisture, rot, and insects, and weathers gracefully to a silvery grey — or keep the original tone with an outdoor finish. Built with the same joinery and material quality as a LeisureCraft sauna.", "features": ["Handcrafted in Ontario, Canada", "Premium cedar construction", "Weather-resistant — built for year-round outdoor use", "Low maintenance", "Sauna-grade joinery and craftsmanship"], "images": {"primary": "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/L234N_GBKMO8MHO0PBSGP0/L234N_1.jpg", "gallery": ["https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/L234N_GBKMO8MHO0PBSGP0/L234N_1.jpg"]}},
  {"id": "lc-36-round-coffee-table", "name": "36\" Round Coffee Table", "brand": "LeisureCraft", "series": "Outdoor Furniture", "category": "furniture", "price": "Call for Price", "description": "Canadian-made cedar 36\" round coffee table — sturdy, comfortable, and built to stay outdoors through every season.", "longDescription": "The 36\" Round Coffee Table is crafted from the same Canadian cedar as LeisureCraft saunas and designed for life outdoors. Cedar is naturally resistant to moisture, rot, and insects, and weathers gracefully to a silvery grey — or keep the original tone with an outdoor finish. Built with the same joinery and material quality as a LeisureCraft sauna.", "features": ["Handcrafted in Ontario, Canada", "Premium cedar construction", "Weather-resistant — built for year-round outdoor use", "Low maintenance", "Sauna-grade joinery and craftsmanship"], "images": {"primary": "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/L102N_I3P3VRUCO0PBSGP0/L102N_1.jpg", "gallery": ["https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/L102N_I3P3VRUCO0PBSGP0/L102N_1.jpg"]}},
  {"id": "lc-pacific-modern-outdoor-chair", "name": "Pacific Modern Outdoor Chair", "brand": "LeisureCraft", "series": "Outdoor Furniture", "category": "furniture", "price": "Call for Price", "description": "Canadian-made cedar pacific modern outdoor chair — sturdy, comfortable, and built to stay outdoors through every season.", "longDescription": "The Pacific Modern Outdoor Chair is crafted from the same Canadian cedar as LeisureCraft saunas and designed for life outdoors. Cedar is naturally resistant to moisture, rot, and insects, and weathers gracefully to a silvery grey — or keep the original tone with an outdoor finish. Built with the same joinery and material quality as a LeisureCraft sauna.", "features": ["Handcrafted in Ontario, Canada", "Premium cedar construction", "Weather-resistant — built for year-round outdoor use", "Low maintenance", "Sauna-grade joinery and craftsmanship"], "images": {"primary": "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/PM110_I465N7AJO0PBSGP0/PM110N_1.jpg", "gallery": ["https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/PM110_I465N7AJO0PBSGP0/PM110N_1.jpg"]}},
  {"id": "lc-adirondack-footrest", "name": "Adirondack Footrest", "brand": "LeisureCraft", "series": "Outdoor Furniture", "category": "furniture", "price": "Call for Price", "description": "Canadian-made cedar adirondack footrest — sturdy, comfortable, and built to stay outdoors through every season.", "longDescription": "The Adirondack Footrest is crafted from the same Canadian cedar as LeisureCraft saunas and designed for life outdoors. Cedar is naturally resistant to moisture, rot, and insects, and weathers gracefully to a silvery grey — or keep the original tone with an outdoor finish. Built with the same joinery and material quality as a LeisureCraft sauna.", "features": ["Handcrafted in Ontario, Canada", "Premium cedar construction", "Weather-resistant — built for year-round outdoor use", "Low maintenance", "Sauna-grade joinery and craftsmanship"], "images": {"primary": "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/70112018N_MGESEPGBO0PBSGP0/70112018N_1.jpg", "gallery": ["https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/70112018N_MGESEPGBO0PBSGP0/70112018N_1.jpg"]}},
  {"id": "lc-pacific-modern-coffee-table", "name": "Pacific Modern Coffee Table", "brand": "LeisureCraft", "series": "Outdoor Furniture", "category": "furniture", "price": "Call for Price", "description": "Canadian-made cedar pacific modern coffee table — sturdy, comfortable, and built to stay outdoors through every season.", "longDescription": "The Pacific Modern Coffee Table is crafted from the same Canadian cedar as LeisureCraft saunas and designed for life outdoors. Cedar is naturally resistant to moisture, rot, and insects, and weathers gracefully to a silvery grey — or keep the original tone with an outdoor finish. Built with the same joinery and material quality as a LeisureCraft sauna.", "features": ["Handcrafted in Ontario, Canada", "Premium cedar construction", "Weather-resistant — built for year-round outdoor use", "Low maintenance", "Sauna-grade joinery and craftsmanship"], "images": {"primary": "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/PM108N_MHGOU4VIO0PBSGP0/PM108N_1.jpg", "gallery": ["https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/PM108N_MHGOU4VIO0PBSGP0/PM108N_1.jpg"]}},
  {"id": "lc-table-stool", "name": "Table / Stool", "brand": "LeisureCraft", "series": "Outdoor Furniture", "category": "furniture", "price": "Call for Price", "description": "Canadian-made cedar table / stool — sturdy, comfortable, and built to stay outdoors through every season.", "longDescription": "The Table / Stool is crafted from the same Canadian cedar as LeisureCraft saunas and designed for life outdoors. Cedar is naturally resistant to moisture, rot, and insects, and weathers gracefully to a silvery grey — or keep the original tone with an outdoor finish. Built with the same joinery and material quality as a LeisureCraft sauna.", "features": ["Handcrafted in Ontario, Canada", "Premium cedar construction", "Weather-resistant — built for year-round outdoor use", "Low maintenance", "Sauna-grade joinery and craftsmanship"], "images": {"primary": "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/L136_OBD7P76FO0PBSGP0/L136N_1.jpg", "gallery": ["https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/L136_OBD7P76FO0PBSGP0/L136N_1.jpg"]}},
  {"id": "lc-adirondack-square-table", "name": "Adirondack Square Table", "brand": "LeisureCraft", "series": "Outdoor Furniture", "category": "furniture", "price": "Call for Price", "description": "Canadian-made cedar adirondack square table — sturdy, comfortable, and built to stay outdoors through every season.", "longDescription": "The Adirondack Square Table is crafted from the same Canadian cedar as LeisureCraft saunas and designed for life outdoors. Cedar is naturally resistant to moisture, rot, and insects, and weathers gracefully to a silvery grey — or keep the original tone with an outdoor finish. Built with the same joinery and material quality as a LeisureCraft sauna.", "features": ["Handcrafted in Ontario, Canada", "Premium cedar construction", "Weather-resistant — built for year-round outdoor use", "Low maintenance", "Sauna-grade joinery and craftsmanship"], "images": {"primary": "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/70122018_OCLF4G3CO0PBSGP0/70122018N_1.jpg", "gallery": ["https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/70122018_OCLF4G3CO0PBSGP0/70122018N_1.jpg"]}},
  {"id": "lc-outdoor-log-dining-table", "name": "Outdoor Log Dining Table", "brand": "LeisureCraft", "series": "Outdoor Furniture", "category": "furniture", "price": "Call for Price", "description": "Canadian-made cedar outdoor log dining table — sturdy, comfortable, and built to stay outdoors through every season.", "longDescription": "The Outdoor Log Dining Table is crafted from the same Canadian cedar as LeisureCraft saunas and designed for life outdoors. Cedar is naturally resistant to moisture, rot, and insects, and weathers gracefully to a silvery grey — or keep the original tone with an outdoor finish. Built with the same joinery and material quality as a LeisureCraft sauna.", "features": ["Handcrafted in Ontario, Canada", "Premium cedar construction", "Weather-resistant — built for year-round outdoor use", "Low maintenance", "Sauna-grade joinery and craftsmanship"], "images": {"primary": "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/L510N_PCF56S42P0PBSGP0/L510N_1.jpg", "gallery": ["https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/L510N_PCF56S42P0PBSGP0/L510N_1.jpg"]}},
  {"id": "lc-30-stool-with-back-clear-coated", "name": "30\" Stool with Back - Clear Coated", "brand": "LeisureCraft", "series": "Outdoor Furniture", "category": "furniture", "price": "Call for Price", "description": "Canadian-made cedar 30\" stool with back - clear coated — sturdy, comfortable, and built to stay outdoors through every season.", "longDescription": "The 30\" Stool with Back - Clear Coated is crafted from the same Canadian cedar as LeisureCraft saunas and designed for life outdoors. Cedar is naturally resistant to moisture, rot, and insects, and weathers gracefully to a silvery grey — or keep the original tone with an outdoor finish. Built with the same joinery and material quality as a LeisureCraft sauna.", "features": ["Handcrafted in Ontario, Canada", "Premium cedar construction", "Weather-resistant — built for year-round outdoor use", "Low maintenance", "Sauna-grade joinery and craftsmanship"], "images": {"primary": "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/CT1420CN_PDREDM5NM0PBSGP0/stool-back.jpg", "gallery": ["https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/CT1420CN_PDREDM5NM0PBSGP0/stool-back.jpg"]}},
  {"id": "lc-36-square-bistro-table", "name": "36\" Square Bistro Table", "brand": "LeisureCraft", "series": "Outdoor Furniture", "category": "furniture", "price": "Call for Price", "description": "Canadian-made cedar 36\" square bistro table — sturdy, comfortable, and built to stay outdoors through every season.", "longDescription": "The 36\" Square Bistro Table is crafted from the same Canadian cedar as LeisureCraft saunas and designed for life outdoors. Cedar is naturally resistant to moisture, rot, and insects, and weathers gracefully to a silvery grey — or keep the original tone with an outdoor finish. Built with the same joinery and material quality as a LeisureCraft sauna.", "features": ["Handcrafted in Ontario, Canada", "Premium cedar construction", "Weather-resistant — built for year-round outdoor use", "Low maintenance", "Sauna-grade joinery and craftsmanship"], "images": {"primary": "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/L125N_PLNR6AOKO0PBSGP0/L125N_1.jpg", "gallery": ["https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/L125N_PLNR6AOKO0PBSGP0/L125N_1.jpg"]}},
  {"id": "lc-log-chair-footrest", "name": "Log Chair Footrest", "brand": "LeisureCraft", "series": "Outdoor Furniture", "category": "furniture", "price": "Call for Price", "description": "Canadian-made cedar log chair footrest — sturdy, comfortable, and built to stay outdoors through every season.", "longDescription": "The Log Chair Footrest is crafted from the same Canadian cedar as LeisureCraft saunas and designed for life outdoors. Cedar is naturally resistant to moisture, rot, and insects, and weathers gracefully to a silvery grey — or keep the original tone with an outdoor finish. Built with the same joinery and material quality as a LeisureCraft sauna.", "features": ["Handcrafted in Ontario, Canada", "Premium cedar construction", "Weather-resistant — built for year-round outdoor use", "Low maintenance", "Sauna-grade joinery and craftsmanship"], "images": {"primary": "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/L108N_QRAACK4EO0PBSGP0/L108N_1.jpg", "gallery": ["https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/L108N_QRAACK4EO0PBSGP0/L108N_1.jpg"]}},
  {"id": "lc-30-saddle-seat-bar-stool-clear-coated", "name": "30\" Saddle Seat Bar Stool - Clear Coated", "brand": "LeisureCraft", "series": "Outdoor Furniture", "category": "furniture", "price": "Call for Price", "description": "Canadian-made cedar 30\" saddle seat bar stool - clear coated — sturdy, comfortable, and built to stay outdoors through every season.", "longDescription": "The 30\" Saddle Seat Bar Stool - Clear Coated is crafted from the same Canadian cedar as LeisureCraft saunas and designed for life outdoors. Cedar is naturally resistant to moisture, rot, and insects, and weathers gracefully to a silvery grey — or keep the original tone with an outdoor finish. Built with the same joinery and material quality as a LeisureCraft sauna.", "features": ["Handcrafted in Ontario, Canada", "Premium cedar construction", "Weather-resistant — built for year-round outdoor use", "Low maintenance", "Sauna-grade joinery and craftsmanship"], "images": {"primary": "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/CT1460CN_R1INLP2OM0PBSGP0/stool-saddle.jpg", "gallery": ["https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/CT1460CN_R1INLP2OM0PBSGP0/stool-saddle.jpg"]}},
  {"id": "lc-36-square-coffee-table", "name": "36\" Square Coffee Table", "brand": "LeisureCraft", "series": "Outdoor Furniture", "category": "furniture", "price": "Call for Price", "description": "Canadian-made cedar 36\" square coffee table — sturdy, comfortable, and built to stay outdoors through every season.", "longDescription": "The 36\" Square Coffee Table is crafted from the same Canadian cedar as LeisureCraft saunas and designed for life outdoors. Cedar is naturally resistant to moisture, rot, and insects, and weathers gracefully to a silvery grey — or keep the original tone with an outdoor finish. Built with the same joinery and material quality as a LeisureCraft sauna.", "features": ["Handcrafted in Ontario, Canada", "Premium cedar construction", "Weather-resistant — built for year-round outdoor use", "Low maintenance", "Sauna-grade joinery and craftsmanship"], "images": {"primary": "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/L100N_SCLNLMHCO0PBSGP0/L100N_1.jpg", "gallery": ["https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/L100N_SCLNLMHCO0PBSGP0/L100N_1.jpg"]}},
  {"id": "lc-pacific-modern-outdoor-lounge", "name": "Pacific Modern Outdoor Lounge", "brand": "LeisureCraft", "series": "Outdoor Furniture", "category": "furniture", "price": "Call for Price", "description": "Canadian-made cedar pacific modern outdoor lounge — sturdy, comfortable, and built to stay outdoors through every season.", "longDescription": "The Pacific Modern Outdoor Lounge is crafted from the same Canadian cedar as LeisureCraft saunas and designed for life outdoors. Cedar is naturally resistant to moisture, rot, and insects, and weathers gracefully to a silvery grey — or keep the original tone with an outdoor finish. Built with the same joinery and material quality as a LeisureCraft sauna.", "features": ["Handcrafted in Ontario, Canada", "Premium cedar construction", "Weather-resistant — built for year-round outdoor use", "Low maintenance", "Sauna-grade joinery and craftsmanship"], "images": {"primary": "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/PM210N_SQF05UJJO0PBSGP0/PM210N_1.jpg", "gallery": ["https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/PM210N_SQF05UJJO0PBSGP0/PM210N_1.jpg"]}},
  {"id": "lc-pacific-modern-end-table", "name": "Pacific Modern End Table", "brand": "LeisureCraft", "series": "Outdoor Furniture", "category": "furniture", "price": "Call for Price", "description": "Canadian-made cedar pacific modern end table — sturdy, comfortable, and built to stay outdoors through every season.", "longDescription": "The Pacific Modern End Table is crafted from the same Canadian cedar as LeisureCraft saunas and designed for life outdoors. Cedar is naturally resistant to moisture, rot, and insects, and weathers gracefully to a silvery grey — or keep the original tone with an outdoor finish. Built with the same joinery and material quality as a LeisureCraft sauna.", "features": ["Handcrafted in Ontario, Canada", "Premium cedar construction", "Weather-resistant — built for year-round outdoor use", "Low maintenance", "Sauna-grade joinery and craftsmanship"], "images": {"primary": "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/PM105N_ST2POC2IO0PBSGP0/PM105N_1.jpg", "gallery": ["https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/PM105N_ST2POC2IO0PBSGP0/PM105N_1.jpg"]}},
  {"id": "lc-24-round-end-table", "name": "24\" Round End Table", "brand": "LeisureCraft", "series": "Outdoor Furniture", "category": "furniture", "price": "Call for Price", "description": "Canadian-made cedar 24\" round end table — sturdy, comfortable, and built to stay outdoors through every season.", "longDescription": "The 24\" Round End Table is crafted from the same Canadian cedar as LeisureCraft saunas and designed for life outdoors. Cedar is naturally resistant to moisture, rot, and insects, and weathers gracefully to a silvery grey — or keep the original tone with an outdoor finish. Built with the same joinery and material quality as a LeisureCraft sauna.", "features": ["Handcrafted in Ontario, Canada", "Premium cedar construction", "Weather-resistant — built for year-round outdoor use", "Low maintenance", "Sauna-grade joinery and craftsmanship"], "images": {"primary": "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/L102N_I3P3VRUCO0PBSGP0/L102N_1.jpg", "gallery": ["https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/L102N_I3P3VRUCO0PBSGP0/L102N_1.jpg"]}},
  {"id": "lc-48-round-dining-table", "name": "48\" Round Dining Table", "brand": "LeisureCraft", "series": "Outdoor Furniture", "category": "furniture", "price": "Call for Price", "description": "Canadian-made cedar 48\" round dining table — sturdy, comfortable, and built to stay outdoors through every season.", "longDescription": "The 48\" Round Dining Table is crafted from the same Canadian cedar as LeisureCraft saunas and designed for life outdoors. Cedar is naturally resistant to moisture, rot, and insects, and weathers gracefully to a silvery grey — or keep the original tone with an outdoor finish. Built with the same joinery and material quality as a LeisureCraft sauna.", "features": ["Handcrafted in Ontario, Canada", "Premium cedar construction", "Weather-resistant — built for year-round outdoor use", "Low maintenance", "Sauna-grade joinery and craftsmanship"], "images": {"primary": "https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/L504N_THCR0IJMO0PBSGP0/L504N_1.jpg", "gallery": ["https://dundalkleisurecraft.s3.ca-central-1.amazonaws.com/INVENTRY/L504N_THCR0IJMO0PBSGP0/L504N_1.jpg"]}}
];

export const LEISURECRAFT_PRODUCTS = [...LEISURECRAFT_SAUNAS, ...LEISURECRAFT_PLUNGES, ...LEISURECRAFT_FURNITURE];

// Get product by ID
export const getProductById = (id) => {
  return [...HOT_TUBS, ...SWIM_SPAS, ...SAUNAS, ...SAUNA_HEATERS, ...COLD_PLUNGES, ...LEISURECRAFT_PRODUCTS].find(p => p.id === id);
};

// Get related model
export const getRelatedModel = (product) => {
  if (!product?.relatedModel) return null;
  return getProductById(product.relatedModel);
};

// Get products by brand
export const getProductsByBrand = (brand) => {
  return HOT_TUBS.filter(p => p.brand === brand);
};

// Filter helper - checks if product matches person filter
const matchesPersonFilter = (product, personsFilter) => {
  if (!personsFilter || personsFilter === 'all') return true;
  if (personsFilter === '1-3') return product.persons >= 1 && product.persons <= 3;
  if (personsFilter === '4-6') return product.persons >= 4 && product.persons <= 6;
  if (personsFilter === '7+') return product.persons >= 7;
  return true;
};

// Filter products
export const filterProducts = (products, filters) => {
  return products.filter(product => {
    if (filters.brand && filters.brand !== 'all' && product.brand !== filters.brand) return false;
    if (filters.minPrice && product.priceValue < filters.minPrice) return false;
    if (filters.maxPrice && product.priceValue > filters.maxPrice) return false;
    if (!matchesPersonFilter(product, filters.persons)) return false;
    if (filters.series && filters.series !== 'all' && product.series !== filters.series) return false;
    if (filters.seatingLayout && filters.seatingLayout !== 'all' && product.seatingLayout !== filters.seatingLayout) return false;
    return true;
  });
};

// Sort products
export const sortProducts = (products, sortBy) => {
  const sorted = [...products];
  switch (sortBy) {
    case 'price-low':
      return sorted.sort((a, b) => (a.priceValue || 0) - (b.priceValue || 0));
    case 'price-high':
      return sorted.sort((a, b) => (b.priceValue || 0) - (a.priceValue || 0));
    case 'name':
      return sorted.sort((a, b) => a.name.localeCompare(b.name));
    default:
      return sorted;
  }
};

// Get unique series
export const getUniqueSeries = (products) => {
  return [...new Set(products.map(p => p.series).filter(Boolean))];
};
